var cov_24f1td4mjl = function () {
  var path = '/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/views/dashboard/dashboardCtrl.js',
      hash = '9f520202870ceb3281ee52f07540b517d0c4cd77',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/views/dashboard/dashboardCtrl.js',
    statementMap: {
      '0': {
        start: {
          line: 2,
          column: 0
        },
        end: {
          line: 1571,
          column: 3
        }
      },
      '1': {
        start: {
          line: 3,
          column: 2
        },
        end: {
          line: 3,
          column: 27
        }
      },
      '2': {
        start: {
          line: 5,
          column: 2
        },
        end: {
          line: 5,
          column: 43
        }
      },
      '3': {
        start: {
          line: 7,
          column: 2
        },
        end: {
          line: 10,
          column: 5
        }
      },
      '4': {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 8,
          column: 49
        }
      },
      '5': {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 9,
          column: 37
        }
      },
      '6': {
        start: {
          line: 12,
          column: 2
        },
        end: {
          line: 12,
          column: 25
        }
      },
      '7': {
        start: {
          line: 13,
          column: 24
        },
        end: {
          line: 13,
          column: 34
        }
      },
      '8': {
        start: {
          line: 14,
          column: 2
        },
        end: {
          line: 14,
          column: 17
        }
      },
      '9': {
        start: {
          line: 15,
          column: 2
        },
        end: {
          line: 15,
          column: 47
        }
      },
      '10': {
        start: {
          line: 16,
          column: 2
        },
        end: {
          line: 16,
          column: 49
        }
      },
      '11': {
        start: {
          line: 17,
          column: 2
        },
        end: {
          line: 22,
          column: 4
        }
      },
      '12': {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 21,
          column: 7
        }
      },
      '13': {
        start: {
          line: 19,
          column: 6
        },
        end: {
          line: 19,
          column: 48
        }
      },
      '14': {
        start: {
          line: 20,
          column: 6
        },
        end: {
          line: 20,
          column: 57
        }
      },
      '15': {
        start: {
          line: 24,
          column: 38
        },
        end: {
          line: 24,
          column: 107
        }
      },
      '16': {
        start: {
          line: 25,
          column: 45
        },
        end: {
          line: 25,
          column: 121
        }
      },
      '17': {
        start: {
          line: 27,
          column: 2
        },
        end: {
          line: 27,
          column: 55
        }
      },
      '18': {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 28,
          column: 63
        }
      },
      '19': {
        start: {
          line: 30,
          column: 2
        },
        end: {
          line: 30,
          column: 39
        }
      },
      '20': {
        start: {
          line: 31,
          column: 2
        },
        end: {
          line: 31,
          column: 42
        }
      },
      '21': {
        start: {
          line: 32,
          column: 2
        },
        end: {
          line: 32,
          column: 47
        }
      },
      '22': {
        start: {
          line: 33,
          column: 2
        },
        end: {
          line: 33,
          column: 43
        }
      },
      '23': {
        start: {
          line: 35,
          column: 24
        },
        end: {
          line: 41,
          column: 3
        }
      },
      '24': {
        start: {
          line: 43,
          column: 2
        },
        end: {
          line: 55,
          column: 4
        }
      },
      '25': {
        start: {
          line: 57,
          column: 2
        },
        end: {
          line: 57,
          column: 28
        }
      },
      '26': {
        start: {
          line: 58,
          column: 23
        },
        end: {
          line: 58,
          column: 32
        }
      },
      '27': {
        start: {
          line: 59,
          column: 2
        },
        end: {
          line: 59,
          column: 26
        }
      },
      '28': {
        start: {
          line: 62,
          column: 2
        },
        end: {
          line: 62,
          column: 34
        }
      },
      '29': {
        start: {
          line: 63,
          column: 2
        },
        end: {
          line: 63,
          column: 37
        }
      },
      '30': {
        start: {
          line: 64,
          column: 2
        },
        end: {
          line: 71,
          column: 5
        }
      },
      '31': {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 70,
          column: 6
        }
      },
      '32': {
        start: {
          line: 68,
          column: 51
        },
        end: {
          line: 68,
          column: 58
        }
      },
      '33': {
        start: {
          line: 74,
          column: 2
        },
        end: {
          line: 88,
          column: 5
        }
      },
      '34': {
        start: {
          line: 76,
          column: 18
        },
        end: {
          line: 76,
          column: 61
        }
      },
      '35': {
        start: {
          line: 77,
          column: 4
        },
        end: {
          line: 80,
          column: 5
        }
      },
      '36': {
        start: {
          line: 78,
          column: 6
        },
        end: {
          line: 78,
          column: 53
        }
      },
      '37': {
        start: {
          line: 79,
          column: 6
        },
        end: {
          line: 79,
          column: 29
        }
      },
      '38': {
        start: {
          line: 82,
          column: 4
        },
        end: {
          line: 86,
          column: 5
        }
      },
      '39': {
        start: {
          line: 83,
          column: 6
        },
        end: {
          line: 85,
          column: 10
        }
      },
      '40': {
        start: {
          line: 84,
          column: 8
        },
        end: {
          line: 84,
          column: 33
        }
      },
      '41': {
        start: {
          line: 87,
          column: 4
        },
        end: {
          line: 87,
          column: 25
        }
      },
      '42': {
        start: {
          line: 91,
          column: 2
        },
        end: {
          line: 101,
          column: 5
        }
      },
      '43': {
        start: {
          line: 93,
          column: 18
        },
        end: {
          line: 93,
          column: 61
        }
      },
      '44': {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 98,
          column: 5
        }
      },
      '45': {
        start: {
          line: 95,
          column: 6
        },
        end: {
          line: 95,
          column: 26
        }
      },
      '46': {
        start: {
          line: 96,
          column: 6
        },
        end: {
          line: 96,
          column: 47
        }
      },
      '47': {
        start: {
          line: 97,
          column: 6
        },
        end: {
          line: 97,
          column: 29
        }
      },
      '48': {
        start: {
          line: 99,
          column: 4
        },
        end: {
          line: 99,
          column: 24
        }
      },
      '49': {
        start: {
          line: 100,
          column: 4
        },
        end: {
          line: 100,
          column: 33
        }
      },
      '50': {
        start: {
          line: 104,
          column: 2
        },
        end: {
          line: 112,
          column: 4
        }
      },
      '51': {
        start: {
          line: 105,
          column: 4
        },
        end: {
          line: 105,
          column: 48
        }
      },
      '52': {
        start: {
          line: 106,
          column: 4
        },
        end: {
          line: 106,
          column: 50
        }
      },
      '53': {
        start: {
          line: 107,
          column: 4
        },
        end: {
          line: 110,
          column: 5
        }
      },
      '54': {
        start: {
          line: 108,
          column: 6
        },
        end: {
          line: 108,
          column: 111
        }
      },
      '55': {
        start: {
          line: 109,
          column: 6
        },
        end: {
          line: 109,
          column: 13
        }
      },
      '56': {
        start: {
          line: 111,
          column: 4
        },
        end: {
          line: 111,
          column: 109
        }
      },
      '57': {
        start: {
          line: 114,
          column: 2
        },
        end: {
          line: 116,
          column: 5
        }
      },
      '58': {
        start: {
          line: 115,
          column: 4
        },
        end: {
          line: 115,
          column: 32
        }
      },
      '59': {
        start: {
          line: 117,
          column: 2
        },
        end: {
          line: 119,
          column: 4
        }
      },
      '60': {
        start: {
          line: 118,
          column: 4
        },
        end: {
          line: 118,
          column: 23
        }
      },
      '61': {
        start: {
          line: 120,
          column: 15
        },
        end: {
          line: 120,
          column: 28
        }
      },
      '62': {
        start: {
          line: 121,
          column: 19
        },
        end: {
          line: 121,
          column: 35
        }
      },
      '63': {
        start: {
          line: 122,
          column: 2
        },
        end: {
          line: 122,
          column: 45
        }
      },
      '64': {
        start: {
          line: 123,
          column: 2
        },
        end: {
          line: 140,
          column: 4
        }
      },
      '65': {
        start: {
          line: 124,
          column: 4
        },
        end: {
          line: 126,
          column: 5
        }
      },
      '66': {
        start: {
          line: 125,
          column: 6
        },
        end: {
          line: 125,
          column: 21
        }
      },
      '67': {
        start: {
          line: 127,
          column: 4
        },
        end: {
          line: 129,
          column: 5
        }
      },
      '68': {
        start: {
          line: 128,
          column: 6
        },
        end: {
          line: 128,
          column: 21
        }
      },
      '69': {
        start: {
          line: 130,
          column: 4
        },
        end: {
          line: 132,
          column: 5
        }
      },
      '70': {
        start: {
          line: 131,
          column: 6
        },
        end: {
          line: 131,
          column: 22
        }
      },
      '71': {
        start: {
          line: 133,
          column: 4
        },
        end: {
          line: 135,
          column: 5
        }
      },
      '72': {
        start: {
          line: 134,
          column: 6
        },
        end: {
          line: 134,
          column: 22
        }
      },
      '73': {
        start: {
          line: 136,
          column: 4
        },
        end: {
          line: 138,
          column: 5
        }
      },
      '74': {
        start: {
          line: 137,
          column: 6
        },
        end: {
          line: 137,
          column: 22
        }
      },
      '75': {
        start: {
          line: 139,
          column: 4
        },
        end: {
          line: 139,
          column: 19
        }
      },
      '76': {
        start: {
          line: 141,
          column: 2
        },
        end: {
          line: 150,
          column: 4
        }
      },
      '77': {
        start: {
          line: 146,
          column: 6
        },
        end: {
          line: 146,
          column: 29
        }
      },
      '78': {
        start: {
          line: 147,
          column: 6
        },
        end: {
          line: 147,
          column: 44
        }
      },
      '79': {
        start: {
          line: 148,
          column: 6
        },
        end: {
          line: 148,
          column: 72
        }
      },
      '80': {
        start: {
          line: 152,
          column: 18
        },
        end: {
          line: 152,
          column: 48
        }
      },
      '81': {
        start: {
          line: 153,
          column: 2
        },
        end: {
          line: 153,
          column: 39
        }
      },
      '82': {
        start: {
          line: 155,
          column: 2
        },
        end: {
          line: 155,
          column: 140
        }
      },
      '83': {
        start: {
          line: 157,
          column: 2
        },
        end: {
          line: 440,
          column: 4
        }
      },
      '84': {
        start: {
          line: 164,
          column: 6
        },
        end: {
          line: 173,
          column: 7
        }
      },
      '85': {
        start: {
          line: 165,
          column: 8
        },
        end: {
          line: 172,
          column: 11
        }
      },
      '86': {
        start: {
          line: 166,
          column: 10
        },
        end: {
          line: 166,
          column: 33
        }
      },
      '87': {
        start: {
          line: 167,
          column: 10
        },
        end: {
          line: 171,
          column: 11
        }
      },
      '88': {
        start: {
          line: 168,
          column: 12
        },
        end: {
          line: 168,
          column: 55
        }
      },
      '89': {
        start: {
          line: 169,
          column: 12
        },
        end: {
          line: 169,
          column: 87
        }
      },
      '90': {
        start: {
          line: 170,
          column: 12
        },
        end: {
          line: 170,
          column: 141
        }
      },
      '91': {
        start: {
          line: 176,
          column: 6
        },
        end: {
          line: 176,
          column: 40
        }
      },
      '92': {
        start: {
          line: 177,
          column: 6
        },
        end: {
          line: 235,
          column: 9
        }
      },
      '93': {
        start: {
          line: 178,
          column: 8
        },
        end: {
          line: 180,
          column: 9
        }
      },
      '94': {
        start: {
          line: 179,
          column: 10
        },
        end: {
          line: 179,
          column: 17
        }
      },
      '95': {
        start: {
          line: 181,
          column: 21
        },
        end: {
          line: 181,
          column: 28
        }
      },
      '96': {
        start: {
          line: 182,
          column: 26
        },
        end: {
          line: 182,
          column: 33
        }
      },
      '97': {
        start: {
          line: 183,
          column: 8
        },
        end: {
          line: 185,
          column: 9
        }
      },
      '98': {
        start: {
          line: 184,
          column: 10
        },
        end: {
          line: 184,
          column: 17
        }
      },
      '99': {
        start: {
          line: 186,
          column: 23
        },
        end: {
          line: 186,
          column: 25
        }
      },
      '100': {
        start: {
          line: 187,
          column: 8
        },
        end: {
          line: 195,
          column: 9
        }
      },
      '101': {
        start: {
          line: 188,
          column: 10
        },
        end: {
          line: 194,
          column: 11
        }
      },
      '102': {
        start: {
          line: 189,
          column: 27
        },
        end: {
          line: 189,
          column: 64
        }
      },
      '103': {
        start: {
          line: 190,
          column: 12
        },
        end: {
          line: 192,
          column: 13
        }
      },
      '104': {
        start: {
          line: 191,
          column: 14
        },
        end: {
          line: 191,
          column: 23
        }
      },
      '105': {
        start: {
          line: 193,
          column: 12
        },
        end: {
          line: 193,
          column: 30
        }
      },
      '106': {
        start: {
          line: 196,
          column: 26
        },
        end: {
          line: 196,
          column: 28
        }
      },
      '107': {
        start: {
          line: 198,
          column: 8
        },
        end: {
          line: 225,
          column: 9
        }
      },
      '108': {
        start: {
          line: 199,
          column: 25
        },
        end: {
          line: 209,
          column: 11
        }
      },
      '109': {
        start: {
          line: 210,
          column: 26
        },
        end: {
          line: 210,
          column: 28
        }
      },
      '110': {
        start: {
          line: 211,
          column: 10
        },
        end: {
          line: 217,
          column: 11
        }
      },
      '111': {
        start: {
          line: 212,
          column: 27
        },
        end: {
          line: 212,
          column: 39
        }
      },
      '112': {
        start: {
          line: 213,
          column: 12
        },
        end: {
          line: 215,
          column: 13
        }
      },
      '113': {
        start: {
          line: 214,
          column: 14
        },
        end: {
          line: 214,
          column: 23
        }
      },
      '114': {
        start: {
          line: 216,
          column: 12
        },
        end: {
          line: 216,
          column: 31
        }
      },
      '115': {
        start: {
          line: 218,
          column: 10
        },
        end: {
          line: 223,
          column: 11
        }
      },
      '116': {
        start: {
          line: 219,
          column: 12
        },
        end: {
          line: 222,
          column: 15
        }
      },
      '117': {
        start: {
          line: 224,
          column: 10
        },
        end: {
          line: 224,
          column: 33
        }
      },
      '118': {
        start: {
          line: 227,
          column: 8
        },
        end: {
          line: 227,
          column: 51
        }
      },
      '119': {
        start: {
          line: 228,
          column: 26
        },
        end: {
          line: 228,
          column: 80
        }
      },
      '120': {
        start: {
          line: 230,
          column: 8
        },
        end: {
          line: 230,
          column: 84
        }
      },
      '121': {
        start: {
          line: 232,
          column: 32
        },
        end: {
          line: 232,
          column: 88
        }
      },
      '122': {
        start: {
          line: 232,
          column: 61
        },
        end: {
          line: 232,
          column: 86
        }
      },
      '123': {
        start: {
          line: 234,
          column: 8
        },
        end: {
          line: 234,
          column: 84
        }
      },
      '124': {
        start: {
          line: 239,
          column: 6
        },
        end: {
          line: 241,
          column: 7
        }
      },
      '125': {
        start: {
          line: 240,
          column: 8
        },
        end: {
          line: 240,
          column: 15
        }
      },
      '126': {
        start: {
          line: 243,
          column: 6
        },
        end: {
          line: 247,
          column: 7
        }
      },
      '127': {
        start: {
          line: 244,
          column: 8
        },
        end: {
          line: 244,
          column: 33
        }
      },
      '128': {
        start: {
          line: 246,
          column: 8
        },
        end: {
          line: 246,
          column: 33
        }
      },
      '129': {
        start: {
          line: 249,
          column: 6
        },
        end: {
          line: 251,
          column: 7
        }
      },
      '130': {
        start: {
          line: 250,
          column: 8
        },
        end: {
          line: 250,
          column: 24
        }
      },
      '131': {
        start: {
          line: 253,
          column: 6
        },
        end: {
          line: 253,
          column: 78
        }
      },
      '132': {
        start: {
          line: 256,
          column: 19
        },
        end: {
          line: 256,
          column: 23
        }
      },
      '133': {
        start: {
          line: 257,
          column: 6
        },
        end: {
          line: 263,
          column: 9
        }
      },
      '134': {
        start: {
          line: 258,
          column: 8
        },
        end: {
          line: 258,
          column: 58
        }
      },
      '135': {
        start: {
          line: 260,
          column: 8
        },
        end: {
          line: 262,
          column: 9
        }
      },
      '136': {
        start: {
          line: 261,
          column: 10
        },
        end: {
          line: 261,
          column: 37
        }
      },
      '137': {
        start: {
          line: 265,
          column: 21
        },
        end: {
          line: 265,
          column: 166
        }
      },
      '138': {
        start: {
          line: 266,
          column: 6
        },
        end: {
          line: 268,
          column: 7
        }
      },
      '139': {
        start: {
          line: 267,
          column: 8
        },
        end: {
          line: 267,
          column: 44
        }
      },
      '140': {
        start: {
          line: 269,
          column: 6
        },
        end: {
          line: 275,
          column: 8
        }
      },
      '141': {
        start: {
          line: 276,
          column: 6
        },
        end: {
          line: 276,
          column: 37
        }
      },
      '142': {
        start: {
          line: 277,
          column: 6
        },
        end: {
          line: 277,
          column: 41
        }
      },
      '143': {
        start: {
          line: 278,
          column: 6
        },
        end: {
          line: 278,
          column: 51
        }
      },
      '144': {
        start: {
          line: 279,
          column: 6
        },
        end: {
          line: 354,
          column: 9
        }
      },
      '145': {
        start: {
          line: 280,
          column: 8
        },
        end: {
          line: 280,
          column: 40
        }
      },
      '146': {
        start: {
          line: 281,
          column: 8
        },
        end: {
          line: 283,
          column: 9
        }
      },
      '147': {
        start: {
          line: 282,
          column: 10
        },
        end: {
          line: 282,
          column: 44
        }
      },
      '148': {
        start: {
          line: 284,
          column: 22
        },
        end: {
          line: 284,
          column: 108
        }
      },
      '149': {
        start: {
          line: 284,
          column: 76
        },
        end: {
          line: 284,
          column: 106
        }
      },
      '150': {
        start: {
          line: 286,
          column: 8
        },
        end: {
          line: 293,
          column: 9
        }
      },
      '151': {
        start: {
          line: 287,
          column: 28
        },
        end: {
          line: 287,
          column: 69
        }
      },
      '152': {
        start: {
          line: 288,
          column: 26
        },
        end: {
          line: 288,
          column: 84
        }
      },
      '153': {
        start: {
          line: 289,
          column: 10
        },
        end: {
          line: 292,
          column: 14
        }
      },
      '154': {
        start: {
          line: 289,
          column: 125
        },
        end: {
          line: 292,
          column: 11
        }
      },
      '155': {
        start: {
          line: 295,
          column: 20
        },
        end: {
          line: 295,
          column: 58
        }
      },
      '156': {
        start: {
          line: 297,
          column: 27
        },
        end: {
          line: 297,
          column: 51
        }
      },
      '157': {
        start: {
          line: 299,
          column: 8
        },
        end: {
          line: 320,
          column: 9
        }
      },
      '158': {
        start: {
          line: 300,
          column: 10
        },
        end: {
          line: 300,
          column: 108
        }
      },
      '159': {
        start: {
          line: 301,
          column: 10
        },
        end: {
          line: 303,
          column: 11
        }
      },
      '160': {
        start: {
          line: 302,
          column: 12
        },
        end: {
          line: 302,
          column: 120
        }
      },
      '161': {
        start: {
          line: 304,
          column: 10
        },
        end: {
          line: 304,
          column: 48
        }
      },
      '162': {
        start: {
          line: 306,
          column: 10
        },
        end: {
          line: 308,
          column: 11
        }
      },
      '163': {
        start: {
          line: 307,
          column: 12
        },
        end: {
          line: 307,
          column: 21
        }
      },
      '164': {
        start: {
          line: 310,
          column: 10
        },
        end: {
          line: 310,
          column: 105
        }
      },
      '165': {
        start: {
          line: 311,
          column: 10
        },
        end: {
          line: 311,
          column: 105
        }
      },
      '166': {
        start: {
          line: 312,
          column: 10
        },
        end: {
          line: 319,
          column: 11
        }
      },
      '167': {
        start: {
          line: 313,
          column: 12
        },
        end: {
          line: 316,
          column: 13
        }
      },
      '168': {
        start: {
          line: 314,
          column: 14
        },
        end: {
          line: 314,
          column: 47
        }
      },
      '169': {
        start: {
          line: 315,
          column: 14
        },
        end: {
          line: 315,
          column: 23
        }
      },
      '170': {
        start: {
          line: 317,
          column: 12
        },
        end: {
          line: 317,
          column: 139
        }
      },
      '171': {
        start: {
          line: 318,
          column: 12
        },
        end: {
          line: 318,
          column: 38
        }
      },
      '172': {
        start: {
          line: 322,
          column: 8
        },
        end: {
          line: 324,
          column: 11
        }
      },
      '173': {
        start: {
          line: 323,
          column: 10
        },
        end: {
          line: 323,
          column: 32
        }
      },
      '174': {
        start: {
          line: 326,
          column: 8
        },
        end: {
          line: 350,
          column: 10
        }
      },
      '175': {
        start: {
          line: 335,
          column: 14
        },
        end: {
          line: 337,
          column: 144
        }
      },
      '176': {
        start: {
          line: 348,
          column: 12
        },
        end: {
          line: 348,
          column: 47
        }
      },
      '177': {
        start: {
          line: 352,
          column: 8
        },
        end: {
          line: 352,
          column: 52
        }
      },
      '178': {
        start: {
          line: 353,
          column: 8
        },
        end: {
          line: 353,
          column: 47
        }
      },
      '179': {
        start: {
          line: 357,
          column: 20
        },
        end: {
          line: 357,
          column: 43
        }
      },
      '180': {
        start: {
          line: 358,
          column: 26
        },
        end: {
          line: 358,
          column: 68
        }
      },
      '181': {
        start: {
          line: 359,
          column: 24
        },
        end: {
          line: 359,
          column: 66
        }
      },
      '182': {
        start: {
          line: 360,
          column: 21
        },
        end: {
          line: 360,
          column: 41
        }
      },
      '183': {
        start: {
          line: 361,
          column: 17
        },
        end: {
          line: 361,
          column: 19
        }
      },
      '184': {
        start: {
          line: 362,
          column: 6
        },
        end: {
          line: 362,
          column: 88
        }
      },
      '185': {
        start: {
          line: 363,
          column: 6
        },
        end: {
          line: 365,
          column: 7
        }
      },
      '186': {
        start: {
          line: 364,
          column: 8
        },
        end: {
          line: 364,
          column: 15
        }
      },
      '187': {
        start: {
          line: 366,
          column: 18
        },
        end: {
          line: 366,
          column: 56
        }
      },
      '188': {
        start: {
          line: 367,
          column: 6
        },
        end: {
          line: 370,
          column: 7
        }
      },
      '189': {
        start: {
          line: 368,
          column: 8
        },
        end: {
          line: 368,
          column: 81
        }
      },
      '190': {
        start: {
          line: 369,
          column: 8
        },
        end: {
          line: 369,
          column: 119
        }
      },
      '191': {
        start: {
          line: 372,
          column: 21
        },
        end: {
          line: 421,
          column: 7
        }
      },
      '192': {
        start: {
          line: 419,
          column: 10
        },
        end: {
          line: 419,
          column: 124
        }
      },
      '193': {
        start: {
          line: 423,
          column: 6
        },
        end: {
          line: 423,
          column: 76
        }
      },
      '194': {
        start: {
          line: 425,
          column: 6
        },
        end: {
          line: 425,
          column: 145
        }
      },
      '195': {
        start: {
          line: 426,
          column: 6
        },
        end: {
          line: 430,
          column: 9
        }
      },
      '196': {
        start: {
          line: 431,
          column: 6
        },
        end: {
          line: 437,
          column: 7
        }
      },
      '197': {
        start: {
          line: 432,
          column: 8
        },
        end: {
          line: 436,
          column: 11
        }
      },
      '198': {
        start: {
          line: 438,
          column: 6
        },
        end: {
          line: 438,
          column: 31
        }
      },
      '199': {
        start: {
          line: 442,
          column: 37
        },
        end: {
          line: 464,
          column: 3
        }
      },
      '200': {
        start: {
          line: 451,
          column: 20
        },
        end: {
          line: 451,
          column: 68
        }
      },
      '201': {
        start: {
          line: 452,
          column: 25
        },
        end: {
          line: 452,
          column: 76
        }
      },
      '202': {
        start: {
          line: 453,
          column: 6
        },
        end: {
          line: 453,
          column: 58
        }
      },
      '203': {
        start: {
          line: 454,
          column: 6
        },
        end: {
          line: 454,
          column: 49
        }
      },
      '204': {
        start: {
          line: 455,
          column: 6
        },
        end: {
          line: 455,
          column: 98
        }
      },
      '205': {
        start: {
          line: 456,
          column: 6
        },
        end: {
          line: 456,
          column: 112
        }
      },
      '206': {
        start: {
          line: 457,
          column: 6
        },
        end: {
          line: 457,
          column: 54
        }
      },
      '207': {
        start: {
          line: 465,
          column: 2
        },
        end: {
          line: 663,
          column: 4
        }
      },
      '208': {
        start: {
          line: 472,
          column: 14
        },
        end: {
          line: 472,
          column: 107
        }
      },
      '209': {
        start: {
          line: 480,
          column: 24
        },
        end: {
          line: 480,
          column: 38
        }
      },
      '210': {
        start: {
          line: 481,
          column: 12
        },
        end: {
          line: 481,
          column: 37
        }
      },
      '211': {
        start: {
          line: 482,
          column: 12
        },
        end: {
          line: 482,
          column: 40
        }
      },
      '212': {
        start: {
          line: 483,
          column: 28
        },
        end: {
          line: 483,
          column: 62
        }
      },
      '213': {
        start: {
          line: 484,
          column: 12
        },
        end: {
          line: 484,
          column: 38
        }
      },
      '214': {
        start: {
          line: 485,
          column: 12
        },
        end: {
          line: 491,
          column: 13
        }
      },
      '215': {
        start: {
          line: 486,
          column: 36
        },
        end: {
          line: 486,
          column: 58
        }
      },
      '216': {
        start: {
          line: 487,
          column: 14
        },
        end: {
          line: 489,
          column: 17
        }
      },
      '217': {
        start: {
          line: 488,
          column: 16
        },
        end: {
          line: 488,
          column: 127
        }
      },
      '218': {
        start: {
          line: 490,
          column: 14
        },
        end: {
          line: 490,
          column: 20
        }
      },
      '219': {
        start: {
          line: 510,
          column: 20
        },
        end: {
          line: 510,
          column: 43
        }
      },
      '220': {
        start: {
          line: 511,
          column: 6
        },
        end: {
          line: 511,
          column: 44
        }
      },
      '221': {
        start: {
          line: 512,
          column: 6
        },
        end: {
          line: 512,
          column: 40
        }
      },
      '222': {
        start: {
          line: 513,
          column: 6
        },
        end: {
          line: 523,
          column: 7
        }
      },
      '223': {
        start: {
          line: 514,
          column: 8
        },
        end: {
          line: 519,
          column: 9
        }
      },
      '224': {
        start: {
          line: 515,
          column: 10
        },
        end: {
          line: 518,
          column: 11
        }
      },
      '225': {
        start: {
          line: 516,
          column: 12
        },
        end: {
          line: 516,
          column: 46
        }
      },
      '226': {
        start: {
          line: 517,
          column: 12
        },
        end: {
          line: 517,
          column: 18
        }
      },
      '227': {
        start: {
          line: 520,
          column: 8
        },
        end: {
          line: 522,
          column: 9
        }
      },
      '228': {
        start: {
          line: 521,
          column: 10
        },
        end: {
          line: 521,
          column: 56
        }
      },
      '229': {
        start: {
          line: 524,
          column: 6
        },
        end: {
          line: 524,
          column: 42
        }
      },
      '230': {
        start: {
          line: 525,
          column: 6
        },
        end: {
          line: 525,
          column: 45
        }
      },
      '231': {
        start: {
          line: 526,
          column: 6
        },
        end: {
          line: 608,
          column: 9
        }
      },
      '232': {
        start: {
          line: 528,
          column: 8
        },
        end: {
          line: 528,
          column: 48
        }
      },
      '233': {
        start: {
          line: 529,
          column: 23
        },
        end: {
          line: 586,
          column: 9
        }
      },
      '234': {
        start: {
          line: 578,
          column: 22
        },
        end: {
          line: 578,
          column: 42
        }
      },
      '235': {
        start: {
          line: 579,
          column: 12
        },
        end: {
          line: 579,
          column: 36
        }
      },
      '236': {
        start: {
          line: 588,
          column: 8
        },
        end: {
          line: 588,
          column: 62
        }
      },
      '237': {
        start: {
          line: 589,
          column: 8
        },
        end: {
          line: 589,
          column: 46
        }
      },
      '238': {
        start: {
          line: 591,
          column: 8
        },
        end: {
          line: 606,
          column: 9
        }
      },
      '239': {
        start: {
          line: 592,
          column: 10
        },
        end: {
          line: 595,
          column: 11
        }
      },
      '240': {
        start: {
          line: 593,
          column: 27
        },
        end: {
          line: 593,
          column: 48
        }
      },
      '241': {
        start: {
          line: 594,
          column: 12
        },
        end: {
          line: 594,
          column: 46
        }
      },
      '242': {
        start: {
          line: 596,
          column: 24
        },
        end: {
          line: 596,
          column: 97
        }
      },
      '243': {
        start: {
          line: 597,
          column: 10
        },
        end: {
          line: 600,
          column: 13
        }
      },
      '244': {
        start: {
          line: 601,
          column: 10
        },
        end: {
          line: 604,
          column: 13
        }
      },
      '245': {
        start: {
          line: 605,
          column: 10
        },
        end: {
          line: 605,
          column: 102
        }
      },
      '246': {
        start: {
          line: 607,
          column: 8
        },
        end: {
          line: 607,
          column: 59
        }
      },
      '247': {
        start: {
          line: 612,
          column: 6
        },
        end: {
          line: 612,
          column: 38
        }
      },
      '248': {
        start: {
          line: 613,
          column: 6
        },
        end: {
          line: 613,
          column: 80
        }
      },
      '249': {
        start: {
          line: 614,
          column: 6
        },
        end: {
          line: 614,
          column: 81
        }
      },
      '250': {
        start: {
          line: 615,
          column: 6
        },
        end: {
          line: 615,
          column: 82
        }
      },
      '251': {
        start: {
          line: 616,
          column: 6
        },
        end: {
          line: 616,
          column: 37
        }
      },
      '252': {
        start: {
          line: 617,
          column: 6
        },
        end: {
          line: 657,
          column: 9
        }
      },
      '253': {
        start: {
          line: 618,
          column: 8
        },
        end: {
          line: 642,
          column: 9
        }
      },
      '254': {
        start: {
          line: 619,
          column: 21
        },
        end: {
          line: 625,
          column: 11
        }
      },
      '255': {
        start: {
          line: 626,
          column: 10
        },
        end: {
          line: 628,
          column: 11
        }
      },
      '256': {
        start: {
          line: 627,
          column: 12
        },
        end: {
          line: 627,
          column: 93
        }
      },
      '257': {
        start: {
          line: 630,
          column: 21
        },
        end: {
          line: 636,
          column: 11
        }
      },
      '258': {
        start: {
          line: 637,
          column: 10
        },
        end: {
          line: 639,
          column: 11
        }
      },
      '259': {
        start: {
          line: 638,
          column: 12
        },
        end: {
          line: 638,
          column: 94
        }
      },
      '260': {
        start: {
          line: 641,
          column: 10
        },
        end: {
          line: 641,
          column: 90
        }
      },
      '261': {
        start: {
          line: 644,
          column: 8
        },
        end: {
          line: 654,
          column: 11
        }
      },
      '262': {
        start: {
          line: 645,
          column: 23
        },
        end: {
          line: 645,
          column: 68
        }
      },
      '263': {
        start: {
          line: 645,
          column: 39
        },
        end: {
          line: 645,
          column: 60
        }
      },
      '264': {
        start: {
          line: 646,
          column: 10
        },
        end: {
          line: 646,
          column: 62
        }
      },
      '265': {
        start: {
          line: 647,
          column: 10
        },
        end: {
          line: 652,
          column: 15
        }
      },
      '266': {
        start: {
          line: 653,
          column: 10
        },
        end: {
          line: 653,
          column: 58
        }
      },
      '267': {
        start: {
          line: 656,
          column: 8
        },
        end: {
          line: 656,
          column: 41
        }
      },
      '268': {
        start: {
          line: 660,
          column: 6
        },
        end: {
          line: 660,
          column: 31
        }
      },
      '269': {
        start: {
          line: 661,
          column: 6
        },
        end: {
          line: 661,
          column: 31
        }
      },
      '270': {
        start: {
          line: 665,
          column: 2
        },
        end: {
          line: 669,
          column: 4
        }
      },
      '271': {
        start: {
          line: 666,
          column: 4
        },
        end: {
          line: 668,
          column: 7
        }
      },
      '272': {
        start: {
          line: 667,
          column: 6
        },
        end: {
          line: 667,
          column: 33
        }
      },
      '273': {
        start: {
          line: 670,
          column: 2
        },
        end: {
          line: 670,
          column: 53
        }
      },
      '274': {
        start: {
          line: 671,
          column: 2
        },
        end: {
          line: 901,
          column: 4
        }
      },
      '275': {
        start: {
          line: 686,
          column: 6
        },
        end: {
          line: 686,
          column: 27
        }
      },
      '276': {
        start: {
          line: 689,
          column: 6
        },
        end: {
          line: 693,
          column: 7
        }
      },
      '277': {
        start: {
          line: 690,
          column: 8
        },
        end: {
          line: 692,
          column: 9
        }
      },
      '278': {
        start: {
          line: 691,
          column: 10
        },
        end: {
          line: 691,
          column: 52
        }
      },
      '279': {
        start: {
          line: 694,
          column: 6
        },
        end: {
          line: 694,
          column: 48
        }
      },
      '280': {
        start: {
          line: 697,
          column: 24
        },
        end: {
          line: 697,
          column: 42
        }
      },
      '281': {
        start: {
          line: 698,
          column: 6
        },
        end: {
          line: 698,
          column: 42
        }
      },
      '282': {
        start: {
          line: 700,
          column: 20
        },
        end: {
          line: 700,
          column: 82
        }
      },
      '283': {
        start: {
          line: 701,
          column: 6
        },
        end: {
          line: 709,
          column: 7
        }
      },
      '284': {
        start: {
          line: 702,
          column: 23
        },
        end: {
          line: 702,
          column: 44
        }
      },
      '285': {
        start: {
          line: 703,
          column: 21
        },
        end: {
          line: 703,
          column: 23
        }
      },
      '286': {
        start: {
          line: 704,
          column: 8
        },
        end: {
          line: 707,
          column: 9
        }
      },
      '287': {
        start: {
          line: 705,
          column: 20
        },
        end: {
          line: 705,
          column: 51
        }
      },
      '288': {
        start: {
          line: 706,
          column: 10
        },
        end: {
          line: 706,
          column: 52
        }
      },
      '289': {
        start: {
          line: 708,
          column: 8
        },
        end: {
          line: 708,
          column: 41
        }
      },
      '290': {
        start: {
          line: 710,
          column: 6
        },
        end: {
          line: 712,
          column: 7
        }
      },
      '291': {
        start: {
          line: 711,
          column: 8
        },
        end: {
          line: 711,
          column: 36
        }
      },
      '292': {
        start: {
          line: 713,
          column: 6
        },
        end: {
          line: 715,
          column: 7
        }
      },
      '293': {
        start: {
          line: 714,
          column: 8
        },
        end: {
          line: 714,
          column: 41
        }
      },
      '294': {
        start: {
          line: 717,
          column: 6
        },
        end: {
          line: 717,
          column: 25
        }
      },
      '295': {
        start: {
          line: 719,
          column: 6
        },
        end: {
          line: 721,
          column: 7
        }
      },
      '296': {
        start: {
          line: 720,
          column: 8
        },
        end: {
          line: 720,
          column: 28
        }
      },
      '297': {
        start: {
          line: 722,
          column: 6
        },
        end: {
          line: 729,
          column: 35
        }
      },
      '298': {
        start: {
          line: 730,
          column: 6
        },
        end: {
          line: 730,
          column: 63
        }
      },
      '299': {
        start: {
          line: 731,
          column: 6
        },
        end: {
          line: 734,
          column: 7
        }
      },
      '300': {
        start: {
          line: 732,
          column: 8
        },
        end: {
          line: 732,
          column: 38
        }
      },
      '301': {
        start: {
          line: 733,
          column: 8
        },
        end: {
          line: 733,
          column: 31
        }
      },
      '302': {
        start: {
          line: 735,
          column: 6
        },
        end: {
          line: 735,
          column: 24
        }
      },
      '303': {
        start: {
          line: 737,
          column: 6
        },
        end: {
          line: 737,
          column: 30
        }
      },
      '304': {
        start: {
          line: 740,
          column: 6
        },
        end: {
          line: 745,
          column: 7
        }
      },
      '305': {
        start: {
          line: 741,
          column: 8
        },
        end: {
          line: 743,
          column: 11
        }
      },
      '306': {
        start: {
          line: 744,
          column: 8
        },
        end: {
          line: 744,
          column: 42
        }
      },
      '307': {
        start: {
          line: 746,
          column: 6
        },
        end: {
          line: 746,
          column: 36
        }
      },
      '308': {
        start: {
          line: 752,
          column: 6
        },
        end: {
          line: 759,
          column: 9
        }
      },
      '309': {
        start: {
          line: 753,
          column: 8
        },
        end: {
          line: 756,
          column: 11
        }
      },
      '310': {
        start: {
          line: 754,
          column: 10
        },
        end: {
          line: 754,
          column: 71
        }
      },
      '311': {
        start: {
          line: 755,
          column: 10
        },
        end: {
          line: 755,
          column: 23
        }
      },
      '312': {
        start: {
          line: 757,
          column: 8
        },
        end: {
          line: 757,
          column: 54
        }
      },
      '313': {
        start: {
          line: 758,
          column: 8
        },
        end: {
          line: 758,
          column: 46
        }
      },
      '314': {
        start: {
          line: 763,
          column: 17
        },
        end: {
          line: 763,
          column: 22
        }
      },
      '315': {
        start: {
          line: 764,
          column: 6
        },
        end: {
          line: 770,
          column: 7
        }
      },
      '316': {
        start: {
          line: 765,
          column: 8
        },
        end: {
          line: 769,
          column: 9
        }
      },
      '317': {
        start: {
          line: 766,
          column: 10
        },
        end: {
          line: 766,
          column: 49
        }
      },
      '318': {
        start: {
          line: 767,
          column: 10
        },
        end: {
          line: 767,
          column: 22
        }
      },
      '319': {
        start: {
          line: 768,
          column: 10
        },
        end: {
          line: 768,
          column: 16
        }
      },
      '320': {
        start: {
          line: 771,
          column: 6
        },
        end: {
          line: 773,
          column: 7
        }
      },
      '321': {
        start: {
          line: 772,
          column: 8
        },
        end: {
          line: 772,
          column: 32
        }
      },
      '322': {
        start: {
          line: 777,
          column: 6
        },
        end: {
          line: 782,
          column: 7
        }
      },
      '323': {
        start: {
          line: 778,
          column: 8
        },
        end: {
          line: 780,
          column: 11
        }
      },
      '324': {
        start: {
          line: 779,
          column: 10
        },
        end: {
          line: 779,
          column: 68
        }
      },
      '325': {
        start: {
          line: 781,
          column: 8
        },
        end: {
          line: 781,
          column: 110
        }
      },
      '326': {
        start: {
          line: 784,
          column: 6
        },
        end: {
          line: 784,
          column: 30
        }
      },
      '327': {
        start: {
          line: 788,
          column: 6
        },
        end: {
          line: 790,
          column: 7
        }
      },
      '328': {
        start: {
          line: 789,
          column: 8
        },
        end: {
          line: 789,
          column: 15
        }
      },
      '329': {
        start: {
          line: 791,
          column: 6
        },
        end: {
          line: 791,
          column: 83
        }
      },
      '330': {
        start: {
          line: 792,
          column: 6
        },
        end: {
          line: 792,
          column: 27
        }
      },
      '331': {
        start: {
          line: 794,
          column: 6
        },
        end: {
          line: 796,
          column: 7
        }
      },
      '332': {
        start: {
          line: 795,
          column: 8
        },
        end: {
          line: 795,
          column: 15
        }
      },
      '333': {
        start: {
          line: 797,
          column: 6
        },
        end: {
          line: 797,
          column: 36
        }
      },
      '334': {
        start: {
          line: 799,
          column: 21
        },
        end: {
          line: 799,
          column: 207
        }
      },
      '335': {
        start: {
          line: 800,
          column: 6
        },
        end: {
          line: 800,
          column: 49
        }
      },
      '336': {
        start: {
          line: 801,
          column: 21
        },
        end: {
          line: 806,
          column: 7
        }
      },
      '337': {
        start: {
          line: 807,
          column: 6
        },
        end: {
          line: 807,
          column: 69
        }
      },
      '338': {
        start: {
          line: 808,
          column: 6
        },
        end: {
          line: 899,
          column: 9
        }
      },
      '339': {
        start: {
          line: 809,
          column: 23
        },
        end: {
          line: 809,
          column: 24
        }
      },
      '340': {
        start: {
          line: 810,
          column: 8
        },
        end: {
          line: 821,
          column: 9
        }
      },
      '341': {
        start: {
          line: 811,
          column: 10
        },
        end: {
          line: 814,
          column: 11
        }
      },
      '342': {
        start: {
          line: 812,
          column: 12
        },
        end: {
          line: 812,
          column: 27
        }
      },
      '343': {
        start: {
          line: 813,
          column: 12
        },
        end: {
          line: 813,
          column: 21
        }
      },
      '344': {
        start: {
          line: 815,
          column: 23
        },
        end: {
          line: 815,
          column: 63
        }
      },
      '345': {
        start: {
          line: 817,
          column: 10
        },
        end: {
          line: 817,
          column: 25
        }
      },
      '346': {
        start: {
          line: 818,
          column: 10
        },
        end: {
          line: 820,
          column: 11
        }
      },
      '347': {
        start: {
          line: 819,
          column: 12
        },
        end: {
          line: 819,
          column: 57
        }
      },
      '348': {
        start: {
          line: 882,
          column: 8
        },
        end: {
          line: 884,
          column: 9
        }
      },
      '349': {
        start: {
          line: 883,
          column: 10
        },
        end: {
          line: 883,
          column: 53
        }
      },
      '350': {
        start: {
          line: 885,
          column: 8
        },
        end: {
          line: 885,
          column: 81
        }
      },
      '351': {
        start: {
          line: 886,
          column: 8
        },
        end: {
          line: 897,
          column: 10
        }
      },
      '352': {
        start: {
          line: 887,
          column: 22
        },
        end: {
          line: 887,
          column: 60
        }
      },
      '353': {
        start: {
          line: 889,
          column: 10
        },
        end: {
          line: 895,
          column: 11
        }
      },
      '354': {
        start: {
          line: 890,
          column: 12
        },
        end: {
          line: 894,
          column: 169
        }
      },
      '355': {
        start: {
          line: 896,
          column: 10
        },
        end: {
          line: 896,
          column: 21
        }
      },
      '356': {
        start: {
          line: 898,
          column: 8
        },
        end: {
          line: 898,
          column: 75
        }
      },
      '357': {
        start: {
          line: 902,
          column: 2
        },
        end: {
          line: 902,
          column: 39
        }
      },
      '358': {
        start: {
          line: 904,
          column: 2
        },
        end: {
          line: 906,
          column: 5
        }
      },
      '359': {
        start: {
          line: 905,
          column: 4
        },
        end: {
          line: 905,
          column: 36
        }
      },
      '360': {
        start: {
          line: 907,
          column: 2
        },
        end: {
          line: 911,
          column: 5
        }
      },
      '361': {
        start: {
          line: 910,
          column: 4
        },
        end: {
          line: 910,
          column: 42
        }
      },
      '362': {
        start: {
          line: 913,
          column: 2
        },
        end: {
          line: 953,
          column: 4
        }
      },
      '363': {
        start: {
          line: 955,
          column: 2
        },
        end: {
          line: 955,
          column: 27
        }
      },
      '364': {
        start: {
          line: 956,
          column: 2
        },
        end: {
          line: 967,
          column: 4
        }
      },
      '365': {
        start: {
          line: 968,
          column: 2
        },
        end: {
          line: 968,
          column: 29
        }
      },
      '366': {
        start: {
          line: 969,
          column: 2
        },
        end: {
          line: 969,
          column: 49
        }
      },
      '367': {
        start: {
          line: 971,
          column: 2
        },
        end: {
          line: 976,
          column: 3
        }
      },
      '368': {
        start: {
          line: 972,
          column: 4
        },
        end: {
          line: 975,
          column: 5
        }
      },
      '369': {
        start: {
          line: 973,
          column: 6
        },
        end: {
          line: 973,
          column: 36
        }
      },
      '370': {
        start: {
          line: 974,
          column: 6
        },
        end: {
          line: 974,
          column: 12
        }
      },
      '371': {
        start: {
          line: 978,
          column: 2
        },
        end: {
          line: 1014,
          column: 5
        }
      },
      '372': {
        start: {
          line: 979,
          column: 16
        },
        end: {
          line: 979,
          column: 38
        }
      },
      '373': {
        start: {
          line: 983,
          column: 4
        },
        end: {
          line: 989,
          column: 5
        }
      },
      '374': {
        start: {
          line: 984,
          column: 6
        },
        end: {
          line: 988,
          column: 7
        }
      },
      '375': {
        start: {
          line: 987,
          column: 8
        },
        end: {
          line: 987,
          column: 57
        }
      },
      '376': {
        start: {
          line: 991,
          column: 18
        },
        end: {
          line: 993,
          column: 5
        }
      },
      '377': {
        start: {
          line: 995,
          column: 4
        },
        end: {
          line: 997,
          column: 7
        }
      },
      '378': {
        start: {
          line: 996,
          column: 6
        },
        end: {
          line: 996,
          column: 39
        }
      },
      '379': {
        start: {
          line: 998,
          column: 4
        },
        end: {
          line: 1006,
          column: 7
        }
      },
      '380': {
        start: {
          line: 999,
          column: 6
        },
        end: {
          line: 1004,
          column: 7
        }
      },
      '381': {
        start: {
          line: 1000,
          column: 8
        },
        end: {
          line: 1003,
          column: 9
        }
      },
      '382': {
        start: {
          line: 1001,
          column: 10
        },
        end: {
          line: 1001,
          column: 30
        }
      },
      '383': {
        start: {
          line: 1002,
          column: 10
        },
        end: {
          line: 1002,
          column: 16
        }
      },
      '384': {
        start: {
          line: 1005,
          column: 6
        },
        end: {
          line: 1005,
          column: 18
        }
      },
      '385': {
        start: {
          line: 1008,
          column: 4
        },
        end: {
          line: 1013,
          column: 7
        }
      },
      '386': {
        start: {
          line: 1009,
          column: 6
        },
        end: {
          line: 1009,
          column: 35
        }
      },
      '387': {
        start: {
          line: 1010,
          column: 6
        },
        end: {
          line: 1012,
          column: 7
        }
      },
      '388': {
        start: {
          line: 1016,
          column: 2
        },
        end: {
          line: 1023,
          column: 4
        }
      },
      '389': {
        start: {
          line: 1017,
          column: 4
        },
        end: {
          line: 1022,
          column: 7
        }
      },
      '390': {
        start: {
          line: 1018,
          column: 6
        },
        end: {
          line: 1018,
          column: 29
        }
      },
      '391': {
        start: {
          line: 1019,
          column: 6
        },
        end: {
          line: 1021,
          column: 7
        }
      },
      '392': {
        start: {
          line: 1020,
          column: 8
        },
        end: {
          line: 1020,
          column: 122
        }
      },
      '393': {
        start: {
          line: 1024,
          column: 2
        },
        end: {
          line: 1024,
          column: 24
        }
      },
      '394': {
        start: {
          line: 1026,
          column: 2
        },
        end: {
          line: 1048,
          column: 4
        }
      },
      '395': {
        start: {
          line: 1029,
          column: 6
        },
        end: {
          line: 1046,
          column: 9
        }
      },
      '396': {
        start: {
          line: 1030,
          column: 8
        },
        end: {
          line: 1036,
          column: 9
        }
      },
      '397': {
        start: {
          line: 1031,
          column: 10
        },
        end: {
          line: 1033,
          column: 11
        }
      },
      '398': {
        start: {
          line: 1032,
          column: 12
        },
        end: {
          line: 1032,
          column: 21
        }
      },
      '399': {
        start: {
          line: 1034,
          column: 10
        },
        end: {
          line: 1034,
          column: 62
        }
      },
      '400': {
        start: {
          line: 1035,
          column: 10
        },
        end: {
          line: 1035,
          column: 58
        }
      },
      '401': {
        start: {
          line: 1037,
          column: 8
        },
        end: {
          line: 1045,
          column: 11
        }
      },
      '402': {
        start: {
          line: 1038,
          column: 10
        },
        end: {
          line: 1040,
          column: 11
        }
      },
      '403': {
        start: {
          line: 1039,
          column: 12
        },
        end: {
          line: 1039,
          column: 21
        }
      },
      '404': {
        start: {
          line: 1041,
          column: 10
        },
        end: {
          line: 1043,
          column: 11
        }
      },
      '405': {
        start: {
          line: 1042,
          column: 12
        },
        end: {
          line: 1042,
          column: 22
        }
      },
      '406': {
        start: {
          line: 1044,
          column: 10
        },
        end: {
          line: 1044,
          column: 19
        }
      },
      '407': {
        start: {
          line: 1050,
          column: 2
        },
        end: {
          line: 1071,
          column: 4
        }
      },
      '408': {
        start: {
          line: 1053,
          column: 6
        },
        end: {
          line: 1057,
          column: 9
        }
      },
      '409': {
        start: {
          line: 1054,
          column: 8
        },
        end: {
          line: 1056,
          column: 9
        }
      },
      '410': {
        start: {
          line: 1055,
          column: 10
        },
        end: {
          line: 1055,
          column: 106
        }
      },
      '411': {
        start: {
          line: 1060,
          column: 6
        },
        end: {
          line: 1069,
          column: 9
        }
      },
      '412': {
        start: {
          line: 1061,
          column: 8
        },
        end: {
          line: 1064,
          column: 9
        }
      },
      '413': {
        start: {
          line: 1062,
          column: 10
        },
        end: {
          line: 1062,
          column: 72
        }
      },
      '414': {
        start: {
          line: 1063,
          column: 10
        },
        end: {
          line: 1063,
          column: 72
        }
      },
      '415': {
        start: {
          line: 1065,
          column: 8
        },
        end: {
          line: 1068,
          column: 11
        }
      },
      '416': {
        start: {
          line: 1066,
          column: 10
        },
        end: {
          line: 1066,
          column: 71
        }
      },
      '417': {
        start: {
          line: 1067,
          column: 10
        },
        end: {
          line: 1067,
          column: 23
        }
      },
      '418': {
        start: {
          line: 1074,
          column: 2
        },
        end: {
          line: 1074,
          column: 34
        }
      },
      '419': {
        start: {
          line: 1075,
          column: 2
        },
        end: {
          line: 1078,
          column: 4
        }
      },
      '420': {
        start: {
          line: 1080,
          column: 2
        },
        end: {
          line: 1082,
          column: 4
        }
      },
      '421': {
        start: {
          line: 1081,
          column: 4
        },
        end: {
          line: 1081,
          column: 57
        }
      },
      '422': {
        start: {
          line: 1084,
          column: 2
        },
        end: {
          line: 1143,
          column: 4
        }
      },
      '423': {
        start: {
          line: 1117,
          column: 24
        },
        end: {
          line: 1117,
          column: 54
        }
      },
      '424': {
        start: {
          line: 1118,
          column: 6
        },
        end: {
          line: 1118,
          column: 55
        }
      },
      '425': {
        start: {
          line: 1119,
          column: 6
        },
        end: {
          line: 1119,
          column: 33
        }
      },
      '426': {
        start: {
          line: 1120,
          column: 6
        },
        end: {
          line: 1120,
          column: 27
        }
      },
      '427': {
        start: {
          line: 1123,
          column: 6
        },
        end: {
          line: 1123,
          column: 25
        }
      },
      '428': {
        start: {
          line: 1124,
          column: 6
        },
        end: {
          line: 1124,
          column: 28
        }
      },
      '429': {
        start: {
          line: 1125,
          column: 6
        },
        end: {
          line: 1125,
          column: 21
        }
      },
      '430': {
        start: {
          line: 1128,
          column: 6
        },
        end: {
          line: 1134,
          column: 9
        }
      },
      '431': {
        start: {
          line: 1129,
          column: 8
        },
        end: {
          line: 1129,
          column: 65
        }
      },
      '432': {
        start: {
          line: 1130,
          column: 8
        },
        end: {
          line: 1130,
          column: 40
        }
      },
      '433': {
        start: {
          line: 1131,
          column: 8
        },
        end: {
          line: 1131,
          column: 48
        }
      },
      '434': {
        start: {
          line: 1132,
          column: 8
        },
        end: {
          line: 1132,
          column: 50
        }
      },
      '435': {
        start: {
          line: 1133,
          column: 8
        },
        end: {
          line: 1133,
          column: 54
        }
      },
      '436': {
        start: {
          line: 1137,
          column: 6
        },
        end: {
          line: 1137,
          column: 33
        }
      },
      '437': {
        start: {
          line: 1138,
          column: 6
        },
        end: {
          line: 1138,
          column: 58
        }
      },
      '438': {
        start: {
          line: 1139,
          column: 6
        },
        end: {
          line: 1141,
          column: 9
        }
      },
      '439': {
        start: {
          line: 1140,
          column: 8
        },
        end: {
          line: 1140,
          column: 22
        }
      },
      '440': {
        start: {
          line: 1144,
          column: 2
        },
        end: {
          line: 1144,
          column: 26
        }
      },
      '441': {
        start: {
          line: 1145,
          column: 2
        },
        end: {
          line: 1145,
          column: 29
        }
      },
      '442': {
        start: {
          line: 1146,
          column: 2
        },
        end: {
          line: 1146,
          column: 29
        }
      },
      '443': {
        start: {
          line: 1147,
          column: 2
        },
        end: {
          line: 1147,
          column: 46
        }
      },
      '444': {
        start: {
          line: 1149,
          column: 19
        },
        end: {
          line: 1154,
          column: 4
        }
      },
      '445': {
        start: {
          line: 1156,
          column: 2
        },
        end: {
          line: 1160,
          column: 4
        }
      },
      '446': {
        start: {
          line: 1157,
          column: 4
        },
        end: {
          line: 1157,
          column: 54
        }
      },
      '447': {
        start: {
          line: 1158,
          column: 4
        },
        end: {
          line: 1158,
          column: 28
        }
      },
      '448': {
        start: {
          line: 1159,
          column: 4
        },
        end: {
          line: 1159,
          column: 22
        }
      },
      '449': {
        start: {
          line: 1162,
          column: 2
        },
        end: {
          line: 1165,
          column: 4
        }
      },
      '450': {
        start: {
          line: 1163,
          column: 4
        },
        end: {
          line: 1163,
          column: 48
        }
      },
      '451': {
        start: {
          line: 1164,
          column: 4
        },
        end: {
          line: 1164,
          column: 29
        }
      },
      '452': {
        start: {
          line: 1167,
          column: 2
        },
        end: {
          line: 1316,
          column: 4
        }
      },
      '453': {
        start: {
          line: 1169,
          column: 6
        },
        end: {
          line: 1171,
          column: 7
        }
      },
      '454': {
        start: {
          line: 1170,
          column: 8
        },
        end: {
          line: 1170,
          column: 15
        }
      },
      '455': {
        start: {
          line: 1172,
          column: 6
        },
        end: {
          line: 1176,
          column: 7
        }
      },
      '456': {
        start: {
          line: 1173,
          column: 8
        },
        end: {
          line: 1173,
          column: 77
        }
      },
      '457': {
        start: {
          line: 1175,
          column: 8
        },
        end: {
          line: 1175,
          column: 83
        }
      },
      '458': {
        start: {
          line: 1180,
          column: 19
        },
        end: {
          line: 1180,
          column: 106
        }
      },
      '459': {
        start: {
          line: 1181,
          column: 6
        },
        end: {
          line: 1200,
          column: 7
        }
      },
      '460': {
        start: {
          line: 1183,
          column: 10
        },
        end: {
          line: 1183,
          column: 107
        }
      },
      '461': {
        start: {
          line: 1184,
          column: 10
        },
        end: {
          line: 1184,
          column: 16
        }
      },
      '462': {
        start: {
          line: 1186,
          column: 10
        },
        end: {
          line: 1186,
          column: 110
        }
      },
      '463': {
        start: {
          line: 1187,
          column: 10
        },
        end: {
          line: 1187,
          column: 16
        }
      },
      '464': {
        start: {
          line: 1189,
          column: 10
        },
        end: {
          line: 1189,
          column: 110
        }
      },
      '465': {
        start: {
          line: 1190,
          column: 10
        },
        end: {
          line: 1190,
          column: 16
        }
      },
      '466': {
        start: {
          line: 1192,
          column: 10
        },
        end: {
          line: 1192,
          column: 110
        }
      },
      '467': {
        start: {
          line: 1193,
          column: 10
        },
        end: {
          line: 1193,
          column: 16
        }
      },
      '468': {
        start: {
          line: 1195,
          column: 10
        },
        end: {
          line: 1195,
          column: 110
        }
      },
      '469': {
        start: {
          line: 1196,
          column: 10
        },
        end: {
          line: 1196,
          column: 16
        }
      },
      '470': {
        start: {
          line: 1198,
          column: 10
        },
        end: {
          line: 1198,
          column: 107
        }
      },
      '471': {
        start: {
          line: 1199,
          column: 10
        },
        end: {
          line: 1199,
          column: 16
        }
      },
      '472': {
        start: {
          line: 1201,
          column: 6
        },
        end: {
          line: 1201,
          column: 124
        }
      },
      '473': {
        start: {
          line: 1204,
          column: 25
        },
        end: {
          line: 1204,
          column: 71
        }
      },
      '474': {
        start: {
          line: 1205,
          column: 21
        },
        end: {
          line: 1205,
          column: 112
        }
      },
      '475': {
        start: {
          line: 1206,
          column: 6
        },
        end: {
          line: 1276,
          column: 9
        }
      },
      '476': {
        start: {
          line: 1207,
          column: 8
        },
        end: {
          line: 1207,
          column: 54
        }
      },
      '477': {
        start: {
          line: 1208,
          column: 20
        },
        end: {
          line: 1208,
          column: 21
        }
      },
      '478': {
        start: {
          line: 1209,
          column: 23
        },
        end: {
          line: 1209,
          column: 29
        }
      },
      '479': {
        start: {
          line: 1212,
          column: 19
        },
        end: {
          line: 1212,
          column: 21
        }
      },
      '480': {
        start: {
          line: 1214,
          column: 8
        },
        end: {
          line: 1219,
          column: 9
        }
      },
      '481': {
        start: {
          line: 1215,
          column: 10
        },
        end: {
          line: 1217,
          column: 11
        }
      },
      '482': {
        start: {
          line: 1216,
          column: 12
        },
        end: {
          line: 1216,
          column: 21
        }
      },
      '483': {
        start: {
          line: 1218,
          column: 10
        },
        end: {
          line: 1218,
          column: 79
        }
      },
      '484': {
        start: {
          line: 1221,
          column: 8
        },
        end: {
          line: 1269,
          column: 9
        }
      },
      '485': {
        start: {
          line: 1222,
          column: 20
        },
        end: {
          line: 1222,
          column: 34
        }
      },
      '486': {
        start: {
          line: 1223,
          column: 10
        },
        end: {
          line: 1223,
          column: 37
        }
      },
      '487': {
        start: {
          line: 1225,
          column: 10
        },
        end: {
          line: 1268,
          column: 11
        }
      },
      '488': {
        start: {
          line: 1226,
          column: 12
        },
        end: {
          line: 1267,
          column: 13
        }
      },
      '489': {
        start: {
          line: 1227,
          column: 14
        },
        end: {
          line: 1266,
          column: 15
        }
      },
      '490': {
        start: {
          line: 1228,
          column: 30
        },
        end: {
          line: 1228,
          column: 123
        }
      },
      '491': {
        start: {
          line: 1229,
          column: 16
        },
        end: {
          line: 1231,
          column: 17
        }
      },
      '492': {
        start: {
          line: 1230,
          column: 18
        },
        end: {
          line: 1230,
          column: 27
        }
      },
      '493': {
        start: {
          line: 1232,
          column: 16
        },
        end: {
          line: 1234,
          column: 17
        }
      },
      '494': {
        start: {
          line: 1233,
          column: 18
        },
        end: {
          line: 1233,
          column: 27
        }
      },
      '495': {
        start: {
          line: 1235,
          column: 16
        },
        end: {
          line: 1235,
          column: 38
        }
      },
      '496': {
        start: {
          line: 1236,
          column: 16
        },
        end: {
          line: 1236,
          column: 38
        }
      },
      '497': {
        start: {
          line: 1237,
          column: 16
        },
        end: {
          line: 1237,
          column: 24
        }
      },
      '498': {
        start: {
          line: 1238,
          column: 16
        },
        end: {
          line: 1261,
          column: 19
        }
      },
      '499': {
        start: {
          line: 1243,
          column: 30
        },
        end: {
          line: 1243,
          column: 48
        }
      },
      '500': {
        start: {
          line: 1244,
          column: 18
        },
        end: {
          line: 1256,
          column: 19
        }
      },
      '501': {
        start: {
          line: 1245,
          column: 36
        },
        end: {
          line: 1245,
          column: 59
        }
      },
      '502': {
        start: {
          line: 1246,
          column: 20
        },
        end: {
          line: 1254,
          column: 21
        }
      },
      '503': {
        start: {
          line: 1247,
          column: 22
        },
        end: {
          line: 1249,
          column: 23
        }
      },
      '504': {
        start: {
          line: 1248,
          column: 24
        },
        end: {
          line: 1248,
          column: 76
        }
      },
      '505': {
        start: {
          line: 1251,
          column: 22
        },
        end: {
          line: 1253,
          column: 23
        }
      },
      '506': {
        start: {
          line: 1252,
          column: 24
        },
        end: {
          line: 1252,
          column: 78
        }
      },
      '507': {
        start: {
          line: 1255,
          column: 20
        },
        end: {
          line: 1255,
          column: 79
        }
      },
      '508': {
        start: {
          line: 1257,
          column: 18
        },
        end: {
          line: 1260,
          column: 42
        }
      },
      '509': {
        start: {
          line: 1263,
          column: 16
        },
        end: {
          line: 1263,
          column: 64
        }
      },
      '510': {
        start: {
          line: 1271,
          column: 8
        },
        end: {
          line: 1274,
          column: 9
        }
      },
      '511': {
        start: {
          line: 1272,
          column: 10
        },
        end: {
          line: 1272,
          column: 29
        }
      },
      '512': {
        start: {
          line: 1273,
          column: 10
        },
        end: {
          line: 1273,
          column: 29
        }
      },
      '513': {
        start: {
          line: 1275,
          column: 8
        },
        end: {
          line: 1275,
          column: 37
        }
      },
      '514': {
        start: {
          line: 1280,
          column: 6
        },
        end: {
          line: 1280,
          column: 30
        }
      },
      '515': {
        start: {
          line: 1281,
          column: 6
        },
        end: {
          line: 1281,
          column: 25
        }
      },
      '516': {
        start: {
          line: 1282,
          column: 6
        },
        end: {
          line: 1282,
          column: 24
        }
      },
      '517': {
        start: {
          line: 1283,
          column: 6
        },
        end: {
          line: 1313,
          column: 9
        }
      },
      '518': {
        start: {
          line: 1284,
          column: 26
        },
        end: {
          line: 1284,
          column: 69
        }
      },
      '519': {
        start: {
          line: 1285,
          column: 8
        },
        end: {
          line: 1290,
          column: 65
        }
      },
      '520': {
        start: {
          line: 1291,
          column: 8
        },
        end: {
          line: 1293,
          column: 11
        }
      },
      '521': {
        start: {
          line: 1294,
          column: 8
        },
        end: {
          line: 1294,
          column: 46
        }
      },
      '522': {
        start: {
          line: 1296,
          column: 8
        },
        end: {
          line: 1296,
          column: 40
        }
      },
      '523': {
        start: {
          line: 1297,
          column: 8
        },
        end: {
          line: 1297,
          column: 42
        }
      },
      '524': {
        start: {
          line: 1305,
          column: 8
        },
        end: {
          line: 1305,
          column: 67
        }
      },
      '525': {
        start: {
          line: 1307,
          column: 8
        },
        end: {
          line: 1312,
          column: 9
        }
      },
      '526': {
        start: {
          line: 1308,
          column: 10
        },
        end: {
          line: 1308,
          column: 35
        }
      },
      '527': {
        start: {
          line: 1309,
          column: 10
        },
        end: {
          line: 1309,
          column: 71
        }
      },
      '528': {
        start: {
          line: 1310,
          column: 10
        },
        end: {
          line: 1310,
          column: 55
        }
      },
      '529': {
        start: {
          line: 1311,
          column: 10
        },
        end: {
          line: 1311,
          column: 48
        }
      },
      '530': {
        start: {
          line: 1322,
          column: 23
        },
        end: {
          line: 1322,
          column: 31
        }
      },
      '531': {
        start: {
          line: 1323,
          column: 25
        },
        end: {
          line: 1323,
          column: 38
        }
      },
      '532': {
        start: {
          line: 1325,
          column: 24
        },
        end: {
          line: 1325,
          column: 50
        }
      },
      '533': {
        start: {
          line: 1326,
          column: 20
        },
        end: {
          line: 1326,
          column: 38
        }
      },
      '534': {
        start: {
          line: 1328,
          column: 2
        },
        end: {
          line: 1350,
          column: 5
        }
      },
      '535': {
        start: {
          line: 1329,
          column: 4
        },
        end: {
          line: 1332,
          column: 5
        }
      },
      '536': {
        start: {
          line: 1330,
          column: 6
        },
        end: {
          line: 1330,
          column: 29
        }
      },
      '537': {
        start: {
          line: 1331,
          column: 6
        },
        end: {
          line: 1331,
          column: 13
        }
      },
      '538': {
        start: {
          line: 1333,
          column: 4
        },
        end: {
          line: 1349,
          column: 5
        }
      },
      '539': {
        start: {
          line: 1334,
          column: 6
        },
        end: {
          line: 1336,
          column: 7
        }
      },
      '540': {
        start: {
          line: 1335,
          column: 8
        },
        end: {
          line: 1335,
          column: 17
        }
      },
      '541': {
        start: {
          line: 1337,
          column: 6
        },
        end: {
          line: 1337,
          column: 70
        }
      },
      '542': {
        start: {
          line: 1338,
          column: 6
        },
        end: {
          line: 1338,
          column: 46
        }
      },
      '543': {
        start: {
          line: 1339,
          column: 6
        },
        end: {
          line: 1339,
          column: 74
        }
      },
      '544': {
        start: {
          line: 1340,
          column: 6
        },
        end: {
          line: 1340,
          column: 70
        }
      },
      '545': {
        start: {
          line: 1341,
          column: 6
        },
        end: {
          line: 1341,
          column: 75
        }
      },
      '546': {
        start: {
          line: 1342,
          column: 6
        },
        end: {
          line: 1342,
          column: 62
        }
      },
      '547': {
        start: {
          line: 1343,
          column: 19
        },
        end: {
          line: 1343,
          column: 21
        }
      },
      '548': {
        start: {
          line: 1344,
          column: 6
        },
        end: {
          line: 1346,
          column: 7
        }
      },
      '549': {
        start: {
          line: 1345,
          column: 8
        },
        end: {
          line: 1345,
          column: 47
        }
      },
      '550': {
        start: {
          line: 1347,
          column: 6
        },
        end: {
          line: 1347,
          column: 48
        }
      },
      '551': {
        start: {
          line: 1348,
          column: 6
        },
        end: {
          line: 1348,
          column: 37
        }
      },
      '552': {
        start: {
          line: 1352,
          column: 2
        },
        end: {
          line: 1352,
          column: 30
        }
      },
      '553': {
        start: {
          line: 1353,
          column: 2
        },
        end: {
          line: 1353,
          column: 29
        }
      },
      '554': {
        start: {
          line: 1354,
          column: 2
        },
        end: {
          line: 1354,
          column: 33
        }
      },
      '555': {
        start: {
          line: 1355,
          column: 2
        },
        end: {
          line: 1355,
          column: 34
        }
      },
      '556': {
        start: {
          line: 1358,
          column: 2
        },
        end: {
          line: 1368,
          column: 4
        }
      },
      '557': {
        start: {
          line: 1359,
          column: 16
        },
        end: {
          line: 1359,
          column: 17
        }
      },
      '558': {
        start: {
          line: 1360,
          column: 25
        },
        end: {
          line: 1360,
          column: 35
        }
      },
      '559': {
        start: {
          line: 1361,
          column: 4
        },
        end: {
          line: 1365,
          column: 7
        }
      },
      '560': {
        start: {
          line: 1362,
          column: 6
        },
        end: {
          line: 1364,
          column: 7
        }
      },
      '561': {
        start: {
          line: 1363,
          column: 8
        },
        end: {
          line: 1363,
          column: 19
        }
      },
      '562': {
        start: {
          line: 1367,
          column: 4
        },
        end: {
          line: 1367,
          column: 17
        }
      },
      '563': {
        start: {
          line: 1369,
          column: 2
        },
        end: {
          line: 1374,
          column: 4
        }
      },
      '564': {
        start: {
          line: 1375,
          column: 2
        },
        end: {
          line: 1477,
          column: 5
        }
      },
      '565': {
        start: {
          line: 1376,
          column: 4
        },
        end: {
          line: 1404,
          column: 7
        }
      },
      '566': {
        start: {
          line: 1377,
          column: 6
        },
        end: {
          line: 1377,
          column: 51
        }
      },
      '567': {
        start: {
          line: 1378,
          column: 6
        },
        end: {
          line: 1378,
          column: 57
        }
      },
      '568': {
        start: {
          line: 1379,
          column: 6
        },
        end: {
          line: 1379,
          column: 47
        }
      },
      '569': {
        start: {
          line: 1380,
          column: 6
        },
        end: {
          line: 1380,
          column: 21
        }
      },
      '570': {
        start: {
          line: 1382,
          column: 6
        },
        end: {
          line: 1382,
          column: 57
        }
      },
      '571': {
        start: {
          line: 1383,
          column: 6
        },
        end: {
          line: 1383,
          column: 63
        }
      },
      '572': {
        start: {
          line: 1384,
          column: 6
        },
        end: {
          line: 1386,
          column: 7
        }
      },
      '573': {
        start: {
          line: 1385,
          column: 8
        },
        end: {
          line: 1385,
          column: 60
        }
      },
      '574': {
        start: {
          line: 1388,
          column: 6
        },
        end: {
          line: 1388,
          column: 53
        }
      },
      '575': {
        start: {
          line: 1389,
          column: 6
        },
        end: {
          line: 1389,
          column: 53
        }
      },
      '576': {
        start: {
          line: 1391,
          column: 6
        },
        end: {
          line: 1393,
          column: 7
        }
      },
      '577': {
        start: {
          line: 1392,
          column: 8
        },
        end: {
          line: 1392,
          column: 60
        }
      },
      '578': {
        start: {
          line: 1394,
          column: 6
        },
        end: {
          line: 1396,
          column: 7
        }
      },
      '579': {
        start: {
          line: 1395,
          column: 8
        },
        end: {
          line: 1395,
          column: 62
        }
      },
      '580': {
        start: {
          line: 1399,
          column: 6
        },
        end: {
          line: 1399,
          column: 48
        }
      },
      '581': {
        start: {
          line: 1400,
          column: 6
        },
        end: {
          line: 1400,
          column: 54
        }
      },
      '582': {
        start: {
          line: 1401,
          column: 6
        },
        end: {
          line: 1401,
          column: 44
        }
      },
      '583': {
        start: {
          line: 1403,
          column: 6
        },
        end: {
          line: 1403,
          column: 19
        }
      },
      '584': {
        start: {
          line: 1406,
          column: 4
        },
        end: {
          line: 1406,
          column: 36
        }
      },
      '585': {
        start: {
          line: 1408,
          column: 4
        },
        end: {
          line: 1408,
          column: 77
        }
      },
      '586': {
        start: {
          line: 1409,
          column: 4
        },
        end: {
          line: 1409,
          column: 83
        }
      },
      '587': {
        start: {
          line: 1410,
          column: 4
        },
        end: {
          line: 1410,
          column: 77
        }
      },
      '588': {
        start: {
          line: 1411,
          column: 4
        },
        end: {
          line: 1411,
          column: 73
        }
      },
      '589': {
        start: {
          line: 1413,
          column: 4
        },
        end: {
          line: 1413,
          column: 47
        }
      },
      '590': {
        start: {
          line: 1414,
          column: 4
        },
        end: {
          line: 1443,
          column: 6
        }
      },
      '591': {
        start: {
          line: 1450,
          column: 4
        },
        end: {
          line: 1476,
          column: 6
        }
      },
      '592': {
        start: {
          line: 1455,
          column: 12
        },
        end: {
          line: 1458,
          column: 14
        }
      },
      '593': {
        start: {
          line: 1460,
          column: 12
        },
        end: {
          line: 1460,
          column: 38
        }
      },
      '594': {
        start: {
          line: 1465,
          column: 8
        },
        end: {
          line: 1467,
          column: 9
        }
      },
      '595': {
        start: {
          line: 1466,
          column: 10
        },
        end: {
          line: 1466,
          column: 56
        }
      },
      '596': {
        start: {
          line: 1468,
          column: 8
        },
        end: {
          line: 1468,
          column: 74
        }
      },
      '597': {
        start: {
          line: 1480,
          column: 2
        },
        end: {
          line: 1544,
          column: 5
        }
      },
      '598': {
        start: {
          line: 1481,
          column: 4
        },
        end: {
          line: 1481,
          column: 33
        }
      },
      '599': {
        start: {
          line: 1487,
          column: 4
        },
        end: {
          line: 1543,
          column: 6
        }
      },
      '600': {
        start: {
          line: 1548,
          column: 2
        },
        end: {
          line: 1553,
          column: 4
        }
      },
      '601': {
        start: {
          line: 1549,
          column: 4
        },
        end: {
          line: 1549,
          column: 36
        }
      },
      '602': {
        start: {
          line: 1550,
          column: 4
        },
        end: {
          line: 1552,
          column: 5
        }
      },
      '603': {
        start: {
          line: 1551,
          column: 6
        },
        end: {
          line: 1551,
          column: 93
        }
      },
      '604': {
        start: {
          line: 1555,
          column: 2
        },
        end: {
          line: 1569,
          column: 4
        }
      },
      '605': {
        start: {
          line: 1559,
          column: 6
        },
        end: {
          line: 1567,
          column: 9
        }
      },
      '606': {
        start: {
          line: 1560,
          column: 8
        },
        end: {
          line: 1566,
          column: 9
        }
      },
      '607': {
        start: {
          line: 1561,
          column: 10
        },
        end: {
          line: 1561,
          column: 58
        }
      },
      '608': {
        start: {
          line: 1562,
          column: 10
        },
        end: {
          line: 1562,
          column: 72
        }
      },
      '609': {
        start: {
          line: 1563,
          column: 10
        },
        end: {
          line: 1565,
          column: 11
        }
      },
      '610': {
        start: {
          line: 1564,
          column: 12
        },
        end: {
          line: 1564,
          column: 50
        }
      },
      '611': {
        start: {
          line: 1570,
          column: 2
        },
        end: {
          line: 1570,
          column: 33
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 50
          },
          end: {
            line: 2,
            column: 51
          }
        },
        loc: {
          start: {
            line: 2,
            column: 389
          },
          end: {
            line: 1571,
            column: 1
          }
        },
        line: 2
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 38
          }
        },
        loc: {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 10,
            column: 3
          }
        },
        line: 7
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 17,
            column: 24
          },
          end: {
            line: 17,
            column: 25
          }
        },
        loc: {
          start: {
            line: 17,
            column: 36
          },
          end: {
            line: 22,
            column: 3
          }
        },
        line: 17
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 18,
            column: 60
          },
          end: {
            line: 18,
            column: 61
          }
        },
        loc: {
          start: {
            line: 18,
            column: 68
          },
          end: {
            line: 21,
            column: 5
          }
        },
        line: 18
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 64,
            column: 26
          },
          end: {
            line: 64,
            column: 27
          }
        },
        loc: {
          start: {
            line: 64,
            column: 32
          },
          end: {
            line: 71,
            column: 3
          }
        },
        line: 64
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 68,
            column: 42
          },
          end: {
            line: 68,
            column: 43
          }
        },
        loc: {
          start: {
            line: 68,
            column: 51
          },
          end: {
            line: 68,
            column: 58
          }
        },
        line: 68
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 74,
            column: 27
          },
          end: {
            line: 74,
            column: 28
          }
        },
        loc: {
          start: {
            line: 74,
            column: 35
          },
          end: {
            line: 88,
            column: 3
          }
        },
        line: 74
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 83,
            column: 51
          },
          end: {
            line: 83,
            column: 52
          }
        },
        loc: {
          start: {
            line: 83,
            column: 64
          },
          end: {
            line: 85,
            column: 7
          }
        },
        line: 83
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 91,
            column: 25
          },
          end: {
            line: 91,
            column: 26
          }
        },
        loc: {
          start: {
            line: 91,
            column: 33
          },
          end: {
            line: 101,
            column: 3
          }
        },
        line: 91
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 104,
            column: 27
          },
          end: {
            line: 104,
            column: 28
          }
        },
        loc: {
          start: {
            line: 104,
            column: 43
          },
          end: {
            line: 112,
            column: 3
          }
        },
        line: 104
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 114,
            column: 51
          },
          end: {
            line: 114,
            column: 52
          }
        },
        loc: {
          start: {
            line: 114,
            column: 59
          },
          end: {
            line: 116,
            column: 3
          }
        },
        line: 114
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 117,
            column: 21
          },
          end: {
            line: 117,
            column: 22
          }
        },
        loc: {
          start: {
            line: 117,
            column: 38
          },
          end: {
            line: 119,
            column: 3
          }
        },
        line: 117
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 123,
            column: 30
          },
          end: {
            line: 123,
            column: 31
          }
        },
        loc: {
          start: {
            line: 123,
            column: 46
          },
          end: {
            line: 140,
            column: 3
          }
        },
        line: 123
      },
      '13': {
        name: '(anonymous_13)',
        decl: {
          start: {
            line: 165,
            column: 117
          },
          end: {
            line: 165,
            column: 118
          }
        },
        loc: {
          start: {
            line: 165,
            column: 125
          },
          end: {
            line: 172,
            column: 9
          }
        },
        line: 165
      },
      '14': {
        name: '(anonymous_14)',
        decl: {
          start: {
            line: 177,
            column: 114
          },
          end: {
            line: 177,
            column: 115
          }
        },
        loc: {
          start: {
            line: 177,
            column: 123
          },
          end: {
            line: 235,
            column: 7
          }
        },
        line: 177
      },
      '15': {
        name: '(anonymous_15)',
        decl: {
          start: {
            line: 232,
            column: 47
          },
          end: {
            line: 232,
            column: 48
          }
        },
        loc: {
          start: {
            line: 232,
            column: 61
          },
          end: {
            line: 232,
            column: 86
          }
        },
        line: 232
      },
      '16': {
        name: '(anonymous_16)',
        decl: {
          start: {
            line: 257,
            column: 94
          },
          end: {
            line: 257,
            column: 95
          }
        },
        loc: {
          start: {
            line: 257,
            column: 106
          },
          end: {
            line: 263,
            column: 7
          }
        },
        line: 257
      },
      '17': {
        name: '(anonymous_17)',
        decl: {
          start: {
            line: 279,
            column: 51
          },
          end: {
            line: 279,
            column: 52
          }
        },
        loc: {
          start: {
            line: 279,
            column: 59
          },
          end: {
            line: 354,
            column: 7
          }
        },
        line: 279
      },
      '18': {
        name: '(anonymous_18)',
        decl: {
          start: {
            line: 284,
            column: 67
          },
          end: {
            line: 284,
            column: 68
          }
        },
        loc: {
          start: {
            line: 284,
            column: 76
          },
          end: {
            line: 284,
            column: 106
          }
        },
        line: 284
      },
      '19': {
        name: '(anonymous_19)',
        decl: {
          start: {
            line: 289,
            column: 114
          },
          end: {
            line: 289,
            column: 115
          }
        },
        loc: {
          start: {
            line: 289,
            column: 125
          },
          end: {
            line: 292,
            column: 11
          }
        },
        line: 289
      },
      '20': {
        name: '(anonymous_20)',
        decl: {
          start: {
            line: 322,
            column: 59
          },
          end: {
            line: 322,
            column: 60
          }
        },
        loc: {
          start: {
            line: 322,
            column: 69
          },
          end: {
            line: 324,
            column: 9
          }
        },
        line: 322
      },
      '21': {
        name: '(anonymous_21)',
        decl: {
          start: {
            line: 334,
            column: 50
          },
          end: {
            line: 334,
            column: 51
          }
        },
        loc: {
          start: {
            line: 334,
            column: 60
          },
          end: {
            line: 338,
            column: 13
          }
        },
        line: 334
      },
      '22': {
        name: '(anonymous_22)',
        decl: {
          start: {
            line: 347,
            column: 35
          },
          end: {
            line: 347,
            column: 36
          }
        },
        loc: {
          start: {
            line: 347,
            column: 44
          },
          end: {
            line: 349,
            column: 11
          }
        },
        line: 347
      },
      '23': {
        name: '(anonymous_23)',
        decl: {
          start: {
            line: 487,
            column: 41
          },
          end: {
            line: 487,
            column: 42
          }
        },
        loc: {
          start: {
            line: 487,
            column: 46
          },
          end: {
            line: 489,
            column: 15
          }
        },
        line: 487
      },
      '24': {
        name: '(anonymous_24)',
        decl: {
          start: {
            line: 526,
            column: 84
          },
          end: {
            line: 526,
            column: 85
          }
        },
        loc: {
          start: {
            line: 526,
            column: 92
          },
          end: {
            line: 608,
            column: 7
          }
        },
        line: 526
      },
      '25': {
        name: '(anonymous_25)',
        decl: {
          start: {
            line: 617,
            column: 58
          },
          end: {
            line: 617,
            column: 59
          }
        },
        loc: {
          start: {
            line: 617,
            column: 66
          },
          end: {
            line: 657,
            column: 7
          }
        },
        line: 617
      },
      '26': {
        name: '(anonymous_26)',
        decl: {
          start: {
            line: 644,
            column: 53
          },
          end: {
            line: 644,
            column: 54
          }
        },
        loc: {
          start: {
            line: 644,
            column: 61
          },
          end: {
            line: 654,
            column: 9
          }
        },
        line: 644
      },
      '27': {
        name: '(anonymous_27)',
        decl: {
          start: {
            line: 645,
            column: 33
          },
          end: {
            line: 645,
            column: 34
          }
        },
        loc: {
          start: {
            line: 645,
            column: 39
          },
          end: {
            line: 645,
            column: 60
          }
        },
        line: 645
      },
      '28': {
        name: '(anonymous_28)',
        decl: {
          start: {
            line: 665,
            column: 18
          },
          end: {
            line: 665,
            column: 19
          }
        },
        loc: {
          start: {
            line: 665,
            column: 30
          },
          end: {
            line: 669,
            column: 3
          }
        },
        line: 665
      },
      '29': {
        name: '(anonymous_29)',
        decl: {
          start: {
            line: 666,
            column: 53
          },
          end: {
            line: 666,
            column: 54
          }
        },
        loc: {
          start: {
            line: 666,
            column: 61
          },
          end: {
            line: 668,
            column: 5
          }
        },
        line: 666
      },
      '30': {
        name: '(anonymous_30)',
        decl: {
          start: {
            line: 752,
            column: 61
          },
          end: {
            line: 752,
            column: 62
          }
        },
        loc: {
          start: {
            line: 752,
            column: 69
          },
          end: {
            line: 759,
            column: 7
          }
        },
        line: 752
      },
      '31': {
        name: '(anonymous_31)',
        decl: {
          start: {
            line: 753,
            column: 54
          },
          end: {
            line: 753,
            column: 55
          }
        },
        loc: {
          start: {
            line: 753,
            column: 63
          },
          end: {
            line: 756,
            column: 9
          }
        },
        line: 753
      },
      '32': {
        name: '(anonymous_32)',
        decl: {
          start: {
            line: 778,
            column: 76
          },
          end: {
            line: 778,
            column: 77
          }
        },
        loc: {
          start: {
            line: 778,
            column: 85
          },
          end: {
            line: 780,
            column: 9
          }
        },
        line: 778
      },
      '33': {
        name: '(anonymous_33)',
        decl: {
          start: {
            line: 808,
            column: 46
          },
          end: {
            line: 808,
            column: 47
          }
        },
        loc: {
          start: {
            line: 808,
            column: 54
          },
          end: {
            line: 899,
            column: 7
          }
        },
        line: 808
      },
      '34': {
        name: '(anonymous_34)',
        decl: {
          start: {
            line: 886,
            column: 50
          },
          end: {
            line: 886,
            column: 51
          }
        },
        loc: {
          start: {
            line: 886,
            column: 65
          },
          end: {
            line: 897,
            column: 9
          }
        },
        line: 886
      },
      '35': {
        name: '(anonymous_35)',
        decl: {
          start: {
            line: 904,
            column: 38
          },
          end: {
            line: 904,
            column: 39
          }
        },
        loc: {
          start: {
            line: 904,
            column: 44
          },
          end: {
            line: 906,
            column: 3
          }
        },
        line: 904
      },
      '36': {
        name: '(anonymous_36)',
        decl: {
          start: {
            line: 907,
            column: 39
          },
          end: {
            line: 907,
            column: 40
          }
        },
        loc: {
          start: {
            line: 907,
            column: 45
          },
          end: {
            line: 911,
            column: 3
          }
        },
        line: 907
      },
      '37': {
        name: '(anonymous_37)',
        decl: {
          start: {
            line: 913,
            column: 27
          },
          end: {
            line: 913,
            column: 28
          }
        },
        loc: {
          start: {
            line: 913,
            column: 39
          },
          end: {
            line: 953,
            column: 3
          }
        },
        line: 913
      },
      '38': {
        name: '(anonymous_38)',
        decl: {
          start: {
            line: 978,
            column: 71
          },
          end: {
            line: 978,
            column: 72
          }
        },
        loc: {
          start: {
            line: 978,
            column: 79
          },
          end: {
            line: 1014,
            column: 3
          }
        },
        line: 978
      },
      '39': {
        name: '(anonymous_39)',
        decl: {
          start: {
            line: 995,
            column: 60
          },
          end: {
            line: 995,
            column: 61
          }
        },
        loc: {
          start: {
            line: 995,
            column: 66
          },
          end: {
            line: 997,
            column: 5
          }
        },
        line: 995
      },
      '40': {
        name: '(anonymous_40)',
        decl: {
          start: {
            line: 998,
            column: 44
          },
          end: {
            line: 998,
            column: 45
          }
        },
        loc: {
          start: {
            line: 998,
            column: 52
          },
          end: {
            line: 1006,
            column: 5
          }
        },
        line: 998
      },
      '41': {
        name: '(anonymous_41)',
        decl: {
          start: {
            line: 1008,
            column: 61
          },
          end: {
            line: 1008,
            column: 62
          }
        },
        loc: {
          start: {
            line: 1008,
            column: 69
          },
          end: {
            line: 1013,
            column: 5
          }
        },
        line: 1008
      },
      '42': {
        name: '(anonymous_42)',
        decl: {
          start: {
            line: 1016,
            column: 24
          },
          end: {
            line: 1016,
            column: 25
          }
        },
        loc: {
          start: {
            line: 1016,
            column: 40
          },
          end: {
            line: 1023,
            column: 3
          }
        },
        line: 1016
      },
      '43': {
        name: '(anonymous_43)',
        decl: {
          start: {
            line: 1017,
            column: 116
          },
          end: {
            line: 1017,
            column: 117
          }
        },
        loc: {
          start: {
            line: 1017,
            column: 124
          },
          end: {
            line: 1022,
            column: 5
          }
        },
        line: 1017
      },
      '44': {
        name: '(anonymous_44)',
        decl: {
          start: {
            line: 1029,
            column: 61
          },
          end: {
            line: 1029,
            column: 62
          }
        },
        loc: {
          start: {
            line: 1029,
            column: 69
          },
          end: {
            line: 1046,
            column: 7
          }
        },
        line: 1029
      },
      '45': {
        name: '(anonymous_45)',
        decl: {
          start: {
            line: 1037,
            column: 96
          },
          end: {
            line: 1037,
            column: 97
          }
        },
        loc: {
          start: {
            line: 1037,
            column: 116
          },
          end: {
            line: 1045,
            column: 9
          }
        },
        line: 1037
      },
      '46': {
        name: '(anonymous_46)',
        decl: {
          start: {
            line: 1053,
            column: 139
          },
          end: {
            line: 1053,
            column: 140
          }
        },
        loc: {
          start: {
            line: 1053,
            column: 147
          },
          end: {
            line: 1057,
            column: 7
          }
        },
        line: 1053
      },
      '47': {
        name: '(anonymous_47)',
        decl: {
          start: {
            line: 1060,
            column: 63
          },
          end: {
            line: 1060,
            column: 64
          }
        },
        loc: {
          start: {
            line: 1060,
            column: 71
          },
          end: {
            line: 1069,
            column: 7
          }
        },
        line: 1060
      },
      '48': {
        name: '(anonymous_48)',
        decl: {
          start: {
            line: 1065,
            column: 52
          },
          end: {
            line: 1065,
            column: 53
          }
        },
        loc: {
          start: {
            line: 1065,
            column: 61
          },
          end: {
            line: 1068,
            column: 9
          }
        },
        line: 1065
      },
      '49': {
        name: '(anonymous_49)',
        decl: {
          start: {
            line: 1080,
            column: 20
          },
          end: {
            line: 1080,
            column: 21
          }
        },
        loc: {
          start: {
            line: 1080,
            column: 32
          },
          end: {
            line: 1082,
            column: 3
          }
        },
        line: 1080
      },
      '50': {
        name: '(anonymous_50)',
        decl: {
          start: {
            line: 1128,
            column: 66
          },
          end: {
            line: 1128,
            column: 67
          }
        },
        loc: {
          start: {
            line: 1128,
            column: 74
          },
          end: {
            line: 1134,
            column: 7
          }
        },
        line: 1128
      },
      '51': {
        name: '(anonymous_51)',
        decl: {
          start: {
            line: 1139,
            column: 86
          },
          end: {
            line: 1139,
            column: 87
          }
        },
        loc: {
          start: {
            line: 1139,
            column: 92
          },
          end: {
            line: 1141,
            column: 7
          }
        },
        line: 1139
      },
      '52': {
        name: '(anonymous_52)',
        decl: {
          start: {
            line: 1156,
            column: 31
          },
          end: {
            line: 1156,
            column: 32
          }
        },
        loc: {
          start: {
            line: 1156,
            column: 66
          },
          end: {
            line: 1160,
            column: 3
          }
        },
        line: 1156
      },
      '53': {
        name: '(anonymous_53)',
        decl: {
          start: {
            line: 1162,
            column: 27
          },
          end: {
            line: 1162,
            column: 28
          }
        },
        loc: {
          start: {
            line: 1162,
            column: 74
          },
          end: {
            line: 1165,
            column: 3
          }
        },
        line: 1162
      },
      '54': {
        name: '(anonymous_54)',
        decl: {
          start: {
            line: 1206,
            column: 49
          },
          end: {
            line: 1206,
            column: 50
          }
        },
        loc: {
          start: {
            line: 1206,
            column: 57
          },
          end: {
            line: 1276,
            column: 7
          }
        },
        line: 1206
      },
      '55': {
        name: '(anonymous_55)',
        decl: {
          start: {
            line: 1242,
            column: 42
          },
          end: {
            line: 1242,
            column: 43
          }
        },
        loc: {
          start: {
            line: 1242,
            column: 55
          },
          end: {
            line: 1261,
            column: 17
          }
        },
        line: 1242
      },
      '56': {
        name: '(anonymous_56)',
        decl: {
          start: {
            line: 1283,
            column: 67
          },
          end: {
            line: 1283,
            column: 68
          }
        },
        loc: {
          start: {
            line: 1283,
            column: 75
          },
          end: {
            line: 1313,
            column: 7
          }
        },
        line: 1283
      },
      '57': {
        name: '(anonymous_57)',
        decl: {
          start: {
            line: 1328,
            column: 68
          },
          end: {
            line: 1328,
            column: 69
          }
        },
        loc: {
          start: {
            line: 1328,
            column: 76
          },
          end: {
            line: 1350,
            column: 3
          }
        },
        line: 1328
      },
      '58': {
        name: '(anonymous_58)',
        decl: {
          start: {
            line: 1358,
            column: 27
          },
          end: {
            line: 1358,
            column: 28
          }
        },
        loc: {
          start: {
            line: 1358,
            column: 54
          },
          end: {
            line: 1368,
            column: 3
          }
        },
        line: 1358
      },
      '59': {
        name: '(anonymous_59)',
        decl: {
          start: {
            line: 1361,
            column: 20
          },
          end: {
            line: 1361,
            column: 21
          }
        },
        loc: {
          start: {
            line: 1361,
            column: 28
          },
          end: {
            line: 1365,
            column: 5
          }
        },
        line: 1361
      },
      '60': {
        name: '(anonymous_60)',
        decl: {
          start: {
            line: 1375,
            column: 69
          },
          end: {
            line: 1375,
            column: 70
          }
        },
        loc: {
          start: {
            line: 1375,
            column: 77
          },
          end: {
            line: 1477,
            column: 3
          }
        },
        line: 1375
      },
      '61': {
        name: '(anonymous_61)',
        decl: {
          start: {
            line: 1376,
            column: 20
          },
          end: {
            line: 1376,
            column: 21
          }
        },
        loc: {
          start: {
            line: 1376,
            column: 29
          },
          end: {
            line: 1404,
            column: 5
          }
        },
        line: 1376
      },
      '62': {
        name: '(anonymous_62)',
        decl: {
          start: {
            line: 1454,
            column: 45
          },
          end: {
            line: 1454,
            column: 46
          }
        },
        loc: {
          start: {
            line: 1454,
            column: 54
          },
          end: {
            line: 1459,
            column: 11
          }
        },
        line: 1454
      },
      '63': {
        name: '(anonymous_63)',
        decl: {
          start: {
            line: 1459,
            column: 21
          },
          end: {
            line: 1459,
            column: 22
          }
        },
        loc: {
          start: {
            line: 1459,
            column: 29
          },
          end: {
            line: 1461,
            column: 11
          }
        },
        line: 1459
      },
      '64': {
        name: '(anonymous_64)',
        decl: {
          start: {
            line: 1480,
            column: 75
          },
          end: {
            line: 1480,
            column: 76
          }
        },
        loc: {
          start: {
            line: 1480,
            column: 83
          },
          end: {
            line: 1544,
            column: 3
          }
        },
        line: 1480
      },
      '65': {
        name: '(anonymous_65)',
        decl: {
          start: {
            line: 1548,
            column: 34
          },
          end: {
            line: 1548,
            column: 35
          }
        },
        loc: {
          start: {
            line: 1548,
            column: 46
          },
          end: {
            line: 1553,
            column: 3
          }
        },
        line: 1548
      },
      '66': {
        name: '(anonymous_66)',
        decl: {
          start: {
            line: 1559,
            column: 76
          },
          end: {
            line: 1559,
            column: 77
          }
        },
        loc: {
          start: {
            line: 1559,
            column: 85
          },
          end: {
            line: 1567,
            column: 7
          }
        },
        line: 1559
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 77,
            column: 4
          },
          end: {
            line: 80,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 77,
            column: 4
          },
          end: {
            line: 80,
            column: 5
          }
        }, {
          start: {
            line: 77,
            column: 4
          },
          end: {
            line: 80,
            column: 5
          }
        }],
        line: 77
      },
      '1': {
        loc: {
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 86,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 86,
            column: 5
          }
        }, {
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 86,
            column: 5
          }
        }],
        line: 82
      },
      '2': {
        loc: {
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 98,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 98,
            column: 5
          }
        }, {
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 98,
            column: 5
          }
        }],
        line: 94
      },
      '3': {
        loc: {
          start: {
            line: 107,
            column: 4
          },
          end: {
            line: 110,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 107,
            column: 4
          },
          end: {
            line: 110,
            column: 5
          }
        }, {
          start: {
            line: 107,
            column: 4
          },
          end: {
            line: 110,
            column: 5
          }
        }],
        line: 107
      },
      '4': {
        loc: {
          start: {
            line: 124,
            column: 4
          },
          end: {
            line: 126,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 124,
            column: 4
          },
          end: {
            line: 126,
            column: 5
          }
        }, {
          start: {
            line: 124,
            column: 4
          },
          end: {
            line: 126,
            column: 5
          }
        }],
        line: 124
      },
      '5': {
        loc: {
          start: {
            line: 127,
            column: 4
          },
          end: {
            line: 129,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 127,
            column: 4
          },
          end: {
            line: 129,
            column: 5
          }
        }, {
          start: {
            line: 127,
            column: 4
          },
          end: {
            line: 129,
            column: 5
          }
        }],
        line: 127
      },
      '6': {
        loc: {
          start: {
            line: 130,
            column: 4
          },
          end: {
            line: 132,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 130,
            column: 4
          },
          end: {
            line: 132,
            column: 5
          }
        }, {
          start: {
            line: 130,
            column: 4
          },
          end: {
            line: 132,
            column: 5
          }
        }],
        line: 130
      },
      '7': {
        loc: {
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 135,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 135,
            column: 5
          }
        }, {
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 135,
            column: 5
          }
        }],
        line: 133
      },
      '8': {
        loc: {
          start: {
            line: 136,
            column: 4
          },
          end: {
            line: 138,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 136,
            column: 4
          },
          end: {
            line: 138,
            column: 5
          }
        }, {
          start: {
            line: 136,
            column: 4
          },
          end: {
            line: 138,
            column: 5
          }
        }],
        line: 136
      },
      '9': {
        loc: {
          start: {
            line: 158,
            column: 16
          },
          end: {
            line: 158,
            column: 128
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 158,
            column: 16
          },
          end: {
            line: 158,
            column: 106
          }
        }, {
          start: {
            line: 158,
            column: 110
          },
          end: {
            line: 158,
            column: 128
          }
        }],
        line: 158
      },
      '10': {
        loc: {
          start: {
            line: 164,
            column: 6
          },
          end: {
            line: 173,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 164,
            column: 6
          },
          end: {
            line: 173,
            column: 7
          }
        }, {
          start: {
            line: 164,
            column: 6
          },
          end: {
            line: 173,
            column: 7
          }
        }],
        line: 164
      },
      '11': {
        loc: {
          start: {
            line: 167,
            column: 10
          },
          end: {
            line: 171,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 167,
            column: 10
          },
          end: {
            line: 171,
            column: 11
          }
        }, {
          start: {
            line: 167,
            column: 10
          },
          end: {
            line: 171,
            column: 11
          }
        }],
        line: 167
      },
      '12': {
        loc: {
          start: {
            line: 177,
            column: 84
          },
          end: {
            line: 177,
            column: 110
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 177,
            column: 105
          },
          end: {
            line: 177,
            column: 106
          }
        }, {
          start: {
            line: 177,
            column: 109
          },
          end: {
            line: 177,
            column: 110
          }
        }],
        line: 177
      },
      '13': {
        loc: {
          start: {
            line: 178,
            column: 8
          },
          end: {
            line: 180,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 178,
            column: 8
          },
          end: {
            line: 180,
            column: 9
          }
        }, {
          start: {
            line: 178,
            column: 8
          },
          end: {
            line: 180,
            column: 9
          }
        }],
        line: 178
      },
      '14': {
        loc: {
          start: {
            line: 178,
            column: 12
          },
          end: {
            line: 178,
            column: 41
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 178,
            column: 12
          },
          end: {
            line: 178,
            column: 18
          }
        }, {
          start: {
            line: 178,
            column: 22
          },
          end: {
            line: 178,
            column: 41
          }
        }],
        line: 178
      },
      '15': {
        loc: {
          start: {
            line: 183,
            column: 8
          },
          end: {
            line: 185,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 183,
            column: 8
          },
          end: {
            line: 185,
            column: 9
          }
        }, {
          start: {
            line: 183,
            column: 8
          },
          end: {
            line: 185,
            column: 9
          }
        }],
        line: 183
      },
      '16': {
        loc: {
          start: {
            line: 187,
            column: 8
          },
          end: {
            line: 195,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 187,
            column: 8
          },
          end: {
            line: 195,
            column: 9
          }
        }, {
          start: {
            line: 187,
            column: 8
          },
          end: {
            line: 195,
            column: 9
          }
        }],
        line: 187
      },
      '17': {
        loc: {
          start: {
            line: 190,
            column: 12
          },
          end: {
            line: 192,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 190,
            column: 12
          },
          end: {
            line: 192,
            column: 13
          }
        }, {
          start: {
            line: 190,
            column: 12
          },
          end: {
            line: 192,
            column: 13
          }
        }],
        line: 190
      },
      '18': {
        loc: {
          start: {
            line: 213,
            column: 12
          },
          end: {
            line: 215,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 213,
            column: 12
          },
          end: {
            line: 215,
            column: 13
          }
        }, {
          start: {
            line: 213,
            column: 12
          },
          end: {
            line: 215,
            column: 13
          }
        }],
        line: 213
      },
      '19': {
        loc: {
          start: {
            line: 213,
            column: 16
          },
          end: {
            line: 213,
            column: 47
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 213,
            column: 16
          },
          end: {
            line: 213,
            column: 36
          }
        }, {
          start: {
            line: 213,
            column: 40
          },
          end: {
            line: 213,
            column: 47
          }
        }],
        line: 213
      },
      '20': {
        loc: {
          start: {
            line: 228,
            column: 26
          },
          end: {
            line: 228,
            column: 80
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 228,
            column: 26
          },
          end: {
            line: 228,
            column: 75
          }
        }, {
          start: {
            line: 228,
            column: 79
          },
          end: {
            line: 228,
            column: 80
          }
        }],
        line: 228
      },
      '21': {
        loc: {
          start: {
            line: 230,
            column: 22
          },
          end: {
            line: 230,
            column: 83
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 230,
            column: 22
          },
          end: {
            line: 230,
            column: 78
          }
        }, {
          start: {
            line: 230,
            column: 82
          },
          end: {
            line: 230,
            column: 83
          }
        }],
        line: 230
      },
      '22': {
        loc: {
          start: {
            line: 234,
            column: 51
          },
          end: {
            line: 234,
            column: 82
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 234,
            column: 51
          },
          end: {
            line: 234,
            column: 66
          }
        }, {
          start: {
            line: 234,
            column: 70
          },
          end: {
            line: 234,
            column: 82
          }
        }],
        line: 234
      },
      '23': {
        loc: {
          start: {
            line: 239,
            column: 6
          },
          end: {
            line: 241,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 239,
            column: 6
          },
          end: {
            line: 241,
            column: 7
          }
        }, {
          start: {
            line: 239,
            column: 6
          },
          end: {
            line: 241,
            column: 7
          }
        }],
        line: 239
      },
      '24': {
        loc: {
          start: {
            line: 239,
            column: 10
          },
          end: {
            line: 239,
            column: 37
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 239,
            column: 10
          },
          end: {
            line: 239,
            column: 15
          }
        }, {
          start: {
            line: 239,
            column: 19
          },
          end: {
            line: 239,
            column: 37
          }
        }],
        line: 239
      },
      '25': {
        loc: {
          start: {
            line: 243,
            column: 6
          },
          end: {
            line: 247,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 243,
            column: 6
          },
          end: {
            line: 247,
            column: 7
          }
        }, {
          start: {
            line: 243,
            column: 6
          },
          end: {
            line: 247,
            column: 7
          }
        }],
        line: 243
      },
      '26': {
        loc: {
          start: {
            line: 249,
            column: 6
          },
          end: {
            line: 251,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 249,
            column: 6
          },
          end: {
            line: 251,
            column: 7
          }
        }, {
          start: {
            line: 249,
            column: 6
          },
          end: {
            line: 251,
            column: 7
          }
        }],
        line: 249
      },
      '27': {
        loc: {
          start: {
            line: 260,
            column: 8
          },
          end: {
            line: 262,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 260,
            column: 8
          },
          end: {
            line: 262,
            column: 9
          }
        }, {
          start: {
            line: 260,
            column: 8
          },
          end: {
            line: 262,
            column: 9
          }
        }],
        line: 260
      },
      '28': {
        loc: {
          start: {
            line: 265,
            column: 139
          },
          end: {
            line: 265,
            column: 165
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 265,
            column: 160
          },
          end: {
            line: 265,
            column: 161
          }
        }, {
          start: {
            line: 265,
            column: 164
          },
          end: {
            line: 265,
            column: 165
          }
        }],
        line: 265
      },
      '29': {
        loc: {
          start: {
            line: 266,
            column: 6
          },
          end: {
            line: 268,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 266,
            column: 6
          },
          end: {
            line: 268,
            column: 7
          }
        }, {
          start: {
            line: 266,
            column: 6
          },
          end: {
            line: 268,
            column: 7
          }
        }],
        line: 266
      },
      '30': {
        loc: {
          start: {
            line: 281,
            column: 8
          },
          end: {
            line: 283,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 281,
            column: 8
          },
          end: {
            line: 283,
            column: 9
          }
        }, {
          start: {
            line: 281,
            column: 8
          },
          end: {
            line: 283,
            column: 9
          }
        }],
        line: 281
      },
      '31': {
        loc: {
          start: {
            line: 286,
            column: 8
          },
          end: {
            line: 293,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 286,
            column: 8
          },
          end: {
            line: 293,
            column: 9
          }
        }, {
          start: {
            line: 286,
            column: 8
          },
          end: {
            line: 293,
            column: 9
          }
        }],
        line: 286
      },
      '32': {
        loc: {
          start: {
            line: 286,
            column: 12
          },
          end: {
            line: 286,
            column: 71
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 286,
            column: 12
          },
          end: {
            line: 286,
            column: 30
          }
        }, {
          start: {
            line: 286,
            column: 34
          },
          end: {
            line: 286,
            column: 71
          }
        }],
        line: 286
      },
      '33': {
        loc: {
          start: {
            line: 301,
            column: 10
          },
          end: {
            line: 303,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 301,
            column: 10
          },
          end: {
            line: 303,
            column: 11
          }
        }, {
          start: {
            line: 301,
            column: 10
          },
          end: {
            line: 303,
            column: 11
          }
        }],
        line: 301
      },
      '34': {
        loc: {
          start: {
            line: 302,
            column: 36
          },
          end: {
            line: 302,
            column: 119
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 302,
            column: 78
          },
          end: {
            line: 302,
            column: 82
          }
        }, {
          start: {
            line: 302,
            column: 97
          },
          end: {
            line: 302,
            column: 118
          }
        }],
        line: 302
      },
      '35': {
        loc: {
          start: {
            line: 302,
            column: 37
          },
          end: {
            line: 302,
            column: 74
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 302,
            column: 37
          },
          end: {
            line: 302,
            column: 52
          }
        }, {
          start: {
            line: 302,
            column: 56
          },
          end: {
            line: 302,
            column: 74
          }
        }],
        line: 302
      },
      '36': {
        loc: {
          start: {
            line: 306,
            column: 10
          },
          end: {
            line: 308,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 306,
            column: 10
          },
          end: {
            line: 308,
            column: 11
          }
        }, {
          start: {
            line: 306,
            column: 10
          },
          end: {
            line: 308,
            column: 11
          }
        }],
        line: 306
      },
      '37': {
        loc: {
          start: {
            line: 313,
            column: 12
          },
          end: {
            line: 316,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 313,
            column: 12
          },
          end: {
            line: 316,
            column: 13
          }
        }, {
          start: {
            line: 313,
            column: 12
          },
          end: {
            line: 316,
            column: 13
          }
        }],
        line: 313
      },
      '38': {
        loc: {
          start: {
            line: 330,
            column: 12
          },
          end: {
            line: 332,
            column: 141
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 331,
            column: 12
          },
          end: {
            line: 331,
            column: 92
          }
        }, {
          start: {
            line: 332,
            column: 12
          },
          end: {
            line: 332,
            column: 141
          }
        }],
        line: 330
      },
      '39': {
        loc: {
          start: {
            line: 335,
            column: 21
          },
          end: {
            line: 337,
            column: 143
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 336,
            column: 16
          },
          end: {
            line: 336,
            column: 94
          }
        }, {
          start: {
            line: 337,
            column: 16
          },
          end: {
            line: 337,
            column: 143
          }
        }],
        line: 335
      },
      '40': {
        loc: {
          start: {
            line: 341,
            column: 14
          },
          end: {
            line: 343,
            column: 142
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 342,
            column: 14
          },
          end: {
            line: 342,
            column: 93
          }
        }, {
          start: {
            line: 343,
            column: 14
          },
          end: {
            line: 343,
            column: 142
          }
        }],
        line: 341
      },
      '41': {
        loc: {
          start: {
            line: 363,
            column: 6
          },
          end: {
            line: 365,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 363,
            column: 6
          },
          end: {
            line: 365,
            column: 7
          }
        }, {
          start: {
            line: 363,
            column: 6
          },
          end: {
            line: 365,
            column: 7
          }
        }],
        line: 363
      },
      '42': {
        loc: {
          start: {
            line: 419,
            column: 63
          },
          end: {
            line: 419,
            column: 122
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 419,
            column: 90
          },
          end: {
            line: 419,
            column: 92
          }
        }, {
          start: {
            line: 419,
            column: 96
          },
          end: {
            line: 419,
            column: 121
          }
        }],
        line: 419
      },
      '43': {
        loc: {
          start: {
            line: 513,
            column: 6
          },
          end: {
            line: 523,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 513,
            column: 6
          },
          end: {
            line: 523,
            column: 7
          }
        }, {
          start: {
            line: 513,
            column: 6
          },
          end: {
            line: 523,
            column: 7
          }
        }],
        line: 513
      },
      '44': {
        loc: {
          start: {
            line: 515,
            column: 10
          },
          end: {
            line: 518,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 515,
            column: 10
          },
          end: {
            line: 518,
            column: 11
          }
        }, {
          start: {
            line: 515,
            column: 10
          },
          end: {
            line: 518,
            column: 11
          }
        }],
        line: 515
      },
      '45': {
        loc: {
          start: {
            line: 520,
            column: 8
          },
          end: {
            line: 522,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 520,
            column: 8
          },
          end: {
            line: 522,
            column: 9
          }
        }, {
          start: {
            line: 520,
            column: 8
          },
          end: {
            line: 522,
            column: 9
          }
        }],
        line: 520
      },
      '46': {
        loc: {
          start: {
            line: 592,
            column: 10
          },
          end: {
            line: 595,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 592,
            column: 10
          },
          end: {
            line: 595,
            column: 11
          }
        }, {
          start: {
            line: 592,
            column: 10
          },
          end: {
            line: 595,
            column: 11
          }
        }],
        line: 592
      },
      '47': {
        loc: {
          start: {
            line: 594,
            column: 30
          },
          end: {
            line: 594,
            column: 45
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 594,
            column: 30
          },
          end: {
            line: 594,
            column: 39
          }
        }, {
          start: {
            line: 594,
            column: 43
          },
          end: {
            line: 594,
            column: 45
          }
        }],
        line: 594
      },
      '48': {
        loc: {
          start: {
            line: 596,
            column: 76
          },
          end: {
            line: 596,
            column: 90
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 596,
            column: 76
          },
          end: {
            line: 596,
            column: 85
          }
        }, {
          start: {
            line: 596,
            column: 89
          },
          end: {
            line: 596,
            column: 90
          }
        }],
        line: 596
      },
      '49': {
        loc: {
          start: {
            line: 599,
            column: 15
          },
          end: {
            line: 599,
            column: 53
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 599,
            column: 29
          },
          end: {
            line: 599,
            column: 45
          }
        }, {
          start: {
            line: 599,
            column: 49
          },
          end: {
            line: 599,
            column: 53
          }
        }],
        line: 599
      },
      '50': {
        loc: {
          start: {
            line: 603,
            column: 15
          },
          end: {
            line: 603,
            column: 53
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 603,
            column: 29
          },
          end: {
            line: 603,
            column: 45
          }
        }, {
          start: {
            line: 603,
            column: 49
          },
          end: {
            line: 603,
            column: 53
          }
        }],
        line: 603
      },
      '51': {
        loc: {
          start: {
            line: 605,
            column: 40
          },
          end: {
            line: 605,
            column: 101
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 605,
            column: 41
          },
          end: {
            line: 605,
            column: 55
          }
        }, {
          start: {
            line: 605,
            column: 59
          },
          end: {
            line: 605,
            column: 69
          }
        }, {
          start: {
            line: 605,
            column: 74
          },
          end: {
            line: 605,
            column: 101
          }
        }],
        line: 605
      },
      '52': {
        loc: {
          start: {
            line: 620,
            column: 15
          },
          end: {
            line: 620,
            column: 30
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 620,
            column: 15
          },
          end: {
            line: 620,
            column: 22
          }
        }, {
          start: {
            line: 620,
            column: 26
          },
          end: {
            line: 620,
            column: 30
          }
        }],
        line: 620
      },
      '53': {
        loc: {
          start: {
            line: 626,
            column: 10
          },
          end: {
            line: 628,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 626,
            column: 10
          },
          end: {
            line: 628,
            column: 11
          }
        }, {
          start: {
            line: 626,
            column: 10
          },
          end: {
            line: 628,
            column: 11
          }
        }],
        line: 626
      },
      '54': {
        loc: {
          start: {
            line: 631,
            column: 15
          },
          end: {
            line: 631,
            column: 30
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 631,
            column: 15
          },
          end: {
            line: 631,
            column: 22
          }
        }, {
          start: {
            line: 631,
            column: 26
          },
          end: {
            line: 631,
            column: 30
          }
        }],
        line: 631
      },
      '55': {
        loc: {
          start: {
            line: 637,
            column: 10
          },
          end: {
            line: 639,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 637,
            column: 10
          },
          end: {
            line: 639,
            column: 11
          }
        }, {
          start: {
            line: 637,
            column: 10
          },
          end: {
            line: 639,
            column: 11
          }
        }],
        line: 637
      },
      '56': {
        loc: {
          start: {
            line: 641,
            column: 35
          },
          end: {
            line: 641,
            column: 89
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 641,
            column: 36
          },
          end: {
            line: 641,
            column: 47
          }
        }, {
          start: {
            line: 641,
            column: 51
          },
          end: {
            line: 641,
            column: 62
          }
        }, {
          start: {
            line: 641,
            column: 67
          },
          end: {
            line: 641,
            column: 89
          }
        }],
        line: 641
      },
      '57': {
        loc: {
          start: {
            line: 645,
            column: 23
          },
          end: {
            line: 645,
            column: 68
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 645,
            column: 23
          },
          end: {
            line: 645,
            column: 62
          }
        }, {
          start: {
            line: 645,
            column: 66
          },
          end: {
            line: 645,
            column: 68
          }
        }],
        line: 645
      },
      '58': {
        loc: {
          start: {
            line: 690,
            column: 8
          },
          end: {
            line: 692,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 690,
            column: 8
          },
          end: {
            line: 692,
            column: 9
          }
        }, {
          start: {
            line: 690,
            column: 8
          },
          end: {
            line: 692,
            column: 9
          }
        }],
        line: 690
      },
      '59': {
        loc: {
          start: {
            line: 706,
            column: 21
          },
          end: {
            line: 706,
            column: 45
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 706,
            column: 37
          },
          end: {
            line: 706,
            column: 40
          }
        }, {
          start: {
            line: 706,
            column: 43
          },
          end: {
            line: 706,
            column: 45
          }
        }],
        line: 706
      },
      '60': {
        loc: {
          start: {
            line: 710,
            column: 6
          },
          end: {
            line: 712,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 710,
            column: 6
          },
          end: {
            line: 712,
            column: 7
          }
        }, {
          start: {
            line: 710,
            column: 6
          },
          end: {
            line: 712,
            column: 7
          }
        }],
        line: 710
      },
      '61': {
        loc: {
          start: {
            line: 713,
            column: 6
          },
          end: {
            line: 715,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 713,
            column: 6
          },
          end: {
            line: 715,
            column: 7
          }
        }, {
          start: {
            line: 713,
            column: 6
          },
          end: {
            line: 715,
            column: 7
          }
        }],
        line: 713
      },
      '62': {
        loc: {
          start: {
            line: 719,
            column: 6
          },
          end: {
            line: 721,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 719,
            column: 6
          },
          end: {
            line: 721,
            column: 7
          }
        }, {
          start: {
            line: 719,
            column: 6
          },
          end: {
            line: 721,
            column: 7
          }
        }],
        line: 719
      },
      '63': {
        loc: {
          start: {
            line: 731,
            column: 6
          },
          end: {
            line: 734,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 731,
            column: 6
          },
          end: {
            line: 734,
            column: 7
          }
        }, {
          start: {
            line: 731,
            column: 6
          },
          end: {
            line: 734,
            column: 7
          }
        }],
        line: 731
      },
      '64': {
        loc: {
          start: {
            line: 740,
            column: 6
          },
          end: {
            line: 745,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 740,
            column: 6
          },
          end: {
            line: 745,
            column: 7
          }
        }, {
          start: {
            line: 740,
            column: 6
          },
          end: {
            line: 745,
            column: 7
          }
        }],
        line: 740
      },
      '65': {
        loc: {
          start: {
            line: 765,
            column: 8
          },
          end: {
            line: 769,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 765,
            column: 8
          },
          end: {
            line: 769,
            column: 9
          }
        }, {
          start: {
            line: 765,
            column: 8
          },
          end: {
            line: 769,
            column: 9
          }
        }],
        line: 765
      },
      '66': {
        loc: {
          start: {
            line: 771,
            column: 6
          },
          end: {
            line: 773,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 771,
            column: 6
          },
          end: {
            line: 773,
            column: 7
          }
        }, {
          start: {
            line: 771,
            column: 6
          },
          end: {
            line: 773,
            column: 7
          }
        }],
        line: 771
      },
      '67': {
        loc: {
          start: {
            line: 777,
            column: 6
          },
          end: {
            line: 782,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 777,
            column: 6
          },
          end: {
            line: 782,
            column: 7
          }
        }, {
          start: {
            line: 777,
            column: 6
          },
          end: {
            line: 782,
            column: 7
          }
        }],
        line: 777
      },
      '68': {
        loc: {
          start: {
            line: 788,
            column: 6
          },
          end: {
            line: 790,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 788,
            column: 6
          },
          end: {
            line: 790,
            column: 7
          }
        }, {
          start: {
            line: 788,
            column: 6
          },
          end: {
            line: 790,
            column: 7
          }
        }],
        line: 788
      },
      '69': {
        loc: {
          start: {
            line: 788,
            column: 10
          },
          end: {
            line: 788,
            column: 52
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 788,
            column: 10
          },
          end: {
            line: 788,
            column: 31
          }
        }, {
          start: {
            line: 788,
            column: 35
          },
          end: {
            line: 788,
            column: 52
          }
        }],
        line: 788
      },
      '70': {
        loc: {
          start: {
            line: 791,
            column: 23
          },
          end: {
            line: 791,
            column: 82
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 791,
            column: 23
          },
          end: {
            line: 791,
            column: 65
          }
        }, {
          start: {
            line: 791,
            column: 69
          },
          end: {
            line: 791,
            column: 82
          }
        }],
        line: 791
      },
      '71': {
        loc: {
          start: {
            line: 794,
            column: 6
          },
          end: {
            line: 796,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 794,
            column: 6
          },
          end: {
            line: 796,
            column: 7
          }
        }, {
          start: {
            line: 794,
            column: 6
          },
          end: {
            line: 796,
            column: 7
          }
        }],
        line: 794
      },
      '72': {
        loc: {
          start: {
            line: 811,
            column: 10
          },
          end: {
            line: 814,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 811,
            column: 10
          },
          end: {
            line: 814,
            column: 11
          }
        }, {
          start: {
            line: 811,
            column: 10
          },
          end: {
            line: 814,
            column: 11
          }
        }],
        line: 811
      },
      '73': {
        loc: {
          start: {
            line: 811,
            column: 14
          },
          end: {
            line: 811,
            column: 54
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 811,
            column: 14
          },
          end: {
            line: 811,
            column: 31
          }
        }, {
          start: {
            line: 811,
            column: 35
          },
          end: {
            line: 811,
            column: 54
          }
        }],
        line: 811
      },
      '74': {
        loc: {
          start: {
            line: 818,
            column: 10
          },
          end: {
            line: 820,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 818,
            column: 10
          },
          end: {
            line: 820,
            column: 11
          }
        }, {
          start: {
            line: 818,
            column: 10
          },
          end: {
            line: 820,
            column: 11
          }
        }],
        line: 818
      },
      '75': {
        loc: {
          start: {
            line: 819,
            column: 23
          },
          end: {
            line: 819,
            column: 56
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 819,
            column: 41
          },
          end: {
            line: 819,
            column: 49
          }
        }, {
          start: {
            line: 819,
            column: 52
          },
          end: {
            line: 819,
            column: 56
          }
        }],
        line: 819
      },
      '76': {
        loc: {
          start: {
            line: 882,
            column: 8
          },
          end: {
            line: 884,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 882,
            column: 8
          },
          end: {
            line: 884,
            column: 9
          }
        }, {
          start: {
            line: 882,
            column: 8
          },
          end: {
            line: 884,
            column: 9
          }
        }],
        line: 882
      },
      '77': {
        loc: {
          start: {
            line: 893,
            column: 17
          },
          end: {
            line: 893,
            column: 134
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 893,
            column: 56
          },
          end: {
            line: 893,
            column: 127
          }
        }, {
          start: {
            line: 893,
            column: 130
          },
          end: {
            line: 893,
            column: 134
          }
        }],
        line: 893
      },
      '78': {
        loc: {
          start: {
            line: 894,
            column: 15
          },
          end: {
            line: 894,
            column: 158
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 894,
            column: 52
          },
          end: {
            line: 894,
            column: 153
          }
        }, {
          start: {
            line: 894,
            column: 156
          },
          end: {
            line: 894,
            column: 158
          }
        }],
        line: 894
      },
      '79': {
        loc: {
          start: {
            line: 958,
            column: 32
          },
          end: {
            line: 958,
            column: 130
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 958,
            column: 83
          },
          end: {
            line: 958,
            column: 100
          }
        }, {
          start: {
            line: 958,
            column: 103
          },
          end: {
            line: 958,
            column: 130
          }
        }],
        line: 958
      },
      '80': {
        loc: {
          start: {
            line: 959,
            column: 14
          },
          end: {
            line: 959,
            column: 112
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 959,
            column: 65
          },
          end: {
            line: 959,
            column: 82
          }
        }, {
          start: {
            line: 959,
            column: 85
          },
          end: {
            line: 959,
            column: 112
          }
        }],
        line: 959
      },
      '81': {
        loc: {
          start: {
            line: 972,
            column: 4
          },
          end: {
            line: 975,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 972,
            column: 4
          },
          end: {
            line: 975,
            column: 5
          }
        }, {
          start: {
            line: 972,
            column: 4
          },
          end: {
            line: 975,
            column: 5
          }
        }],
        line: 972
      },
      '82': {
        loc: {
          start: {
            line: 979,
            column: 16
          },
          end: {
            line: 979,
            column: 38
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 979,
            column: 16
          },
          end: {
            line: 979,
            column: 33
          }
        }, {
          start: {
            line: 979,
            column: 37
          },
          end: {
            line: 979,
            column: 38
          }
        }],
        line: 979
      },
      '83': {
        loc: {
          start: {
            line: 983,
            column: 4
          },
          end: {
            line: 989,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 983,
            column: 4
          },
          end: {
            line: 989,
            column: 5
          }
        }, {
          start: {
            line: 983,
            column: 4
          },
          end: {
            line: 989,
            column: 5
          }
        }],
        line: 983
      },
      '84': {
        loc: {
          start: {
            line: 984,
            column: 6
          },
          end: {
            line: 988,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 984,
            column: 6
          },
          end: {
            line: 988,
            column: 7
          }
        }, {
          start: {
            line: 984,
            column: 6
          },
          end: {
            line: 988,
            column: 7
          }
        }],
        line: 984
      },
      '85': {
        loc: {
          start: {
            line: 992,
            column: 6
          },
          end: {
            line: 992,
            column: 94
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 992,
            column: 6
          },
          end: {
            line: 992,
            column: 86
          }
        }, {
          start: {
            line: 992,
            column: 90
          },
          end: {
            line: 992,
            column: 94
          }
        }],
        line: 992
      },
      '86': {
        loc: {
          start: {
            line: 1000,
            column: 8
          },
          end: {
            line: 1003,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1000,
            column: 8
          },
          end: {
            line: 1003,
            column: 9
          }
        }, {
          start: {
            line: 1000,
            column: 8
          },
          end: {
            line: 1003,
            column: 9
          }
        }],
        line: 1000
      },
      '87': {
        loc: {
          start: {
            line: 1010,
            column: 6
          },
          end: {
            line: 1012,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1010,
            column: 6
          },
          end: {
            line: 1012,
            column: 7
          }
        }, {
          start: {
            line: 1010,
            column: 6
          },
          end: {
            line: 1012,
            column: 7
          }
        }],
        line: 1010
      },
      '88': {
        loc: {
          start: {
            line: 1019,
            column: 6
          },
          end: {
            line: 1021,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1019,
            column: 6
          },
          end: {
            line: 1021,
            column: 7
          }
        }, {
          start: {
            line: 1019,
            column: 6
          },
          end: {
            line: 1021,
            column: 7
          }
        }],
        line: 1019
      },
      '89': {
        loc: {
          start: {
            line: 1031,
            column: 10
          },
          end: {
            line: 1033,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1031,
            column: 10
          },
          end: {
            line: 1033,
            column: 11
          }
        }, {
          start: {
            line: 1031,
            column: 10
          },
          end: {
            line: 1033,
            column: 11
          }
        }],
        line: 1031
      },
      '90': {
        loc: {
          start: {
            line: 1038,
            column: 10
          },
          end: {
            line: 1040,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1038,
            column: 10
          },
          end: {
            line: 1040,
            column: 11
          }
        }, {
          start: {
            line: 1038,
            column: 10
          },
          end: {
            line: 1040,
            column: 11
          }
        }],
        line: 1038
      },
      '91': {
        loc: {
          start: {
            line: 1038,
            column: 15
          },
          end: {
            line: 1038,
            column: 36
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 1038,
            column: 15
          },
          end: {
            line: 1038,
            column: 30
          }
        }, {
          start: {
            line: 1038,
            column: 34
          },
          end: {
            line: 1038,
            column: 36
          }
        }],
        line: 1038
      },
      '92': {
        loc: {
          start: {
            line: 1038,
            column: 55
          },
          end: {
            line: 1038,
            column: 76
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 1038,
            column: 55
          },
          end: {
            line: 1038,
            column: 70
          }
        }, {
          start: {
            line: 1038,
            column: 74
          },
          end: {
            line: 1038,
            column: 76
          }
        }],
        line: 1038
      },
      '93': {
        loc: {
          start: {
            line: 1041,
            column: 10
          },
          end: {
            line: 1043,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1041,
            column: 10
          },
          end: {
            line: 1043,
            column: 11
          }
        }, {
          start: {
            line: 1041,
            column: 10
          },
          end: {
            line: 1043,
            column: 11
          }
        }],
        line: 1041
      },
      '94': {
        loc: {
          start: {
            line: 1041,
            column: 15
          },
          end: {
            line: 1041,
            column: 36
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 1041,
            column: 15
          },
          end: {
            line: 1041,
            column: 30
          }
        }, {
          start: {
            line: 1041,
            column: 34
          },
          end: {
            line: 1041,
            column: 36
          }
        }],
        line: 1041
      },
      '95': {
        loc: {
          start: {
            line: 1041,
            column: 55
          },
          end: {
            line: 1041,
            column: 76
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 1041,
            column: 55
          },
          end: {
            line: 1041,
            column: 70
          }
        }, {
          start: {
            line: 1041,
            column: 74
          },
          end: {
            line: 1041,
            column: 76
          }
        }],
        line: 1041
      },
      '96': {
        loc: {
          start: {
            line: 1054,
            column: 8
          },
          end: {
            line: 1056,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1054,
            column: 8
          },
          end: {
            line: 1056,
            column: 9
          }
        }, {
          start: {
            line: 1054,
            column: 8
          },
          end: {
            line: 1056,
            column: 9
          }
        }],
        line: 1054
      },
      '97': {
        loc: {
          start: {
            line: 1169,
            column: 6
          },
          end: {
            line: 1171,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1169,
            column: 6
          },
          end: {
            line: 1171,
            column: 7
          }
        }, {
          start: {
            line: 1169,
            column: 6
          },
          end: {
            line: 1171,
            column: 7
          }
        }],
        line: 1169
      },
      '98': {
        loc: {
          start: {
            line: 1172,
            column: 6
          },
          end: {
            line: 1176,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1172,
            column: 6
          },
          end: {
            line: 1176,
            column: 7
          }
        }, {
          start: {
            line: 1172,
            column: 6
          },
          end: {
            line: 1176,
            column: 7
          }
        }],
        line: 1172
      },
      '99': {
        loc: {
          start: {
            line: 1181,
            column: 6
          },
          end: {
            line: 1200,
            column: 7
          }
        },
        type: 'switch',
        locations: [{
          start: {
            line: 1182,
            column: 8
          },
          end: {
            line: 1184,
            column: 16
          }
        }, {
          start: {
            line: 1185,
            column: 8
          },
          end: {
            line: 1187,
            column: 16
          }
        }, {
          start: {
            line: 1188,
            column: 8
          },
          end: {
            line: 1190,
            column: 16
          }
        }, {
          start: {
            line: 1191,
            column: 8
          },
          end: {
            line: 1193,
            column: 16
          }
        }, {
          start: {
            line: 1194,
            column: 8
          },
          end: {
            line: 1196,
            column: 16
          }
        }, {
          start: {
            line: 1197,
            column: 8
          },
          end: {
            line: 1199,
            column: 16
          }
        }],
        line: 1181
      },
      '100': {
        loc: {
          start: {
            line: 1215,
            column: 10
          },
          end: {
            line: 1217,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1215,
            column: 10
          },
          end: {
            line: 1217,
            column: 11
          }
        }, {
          start: {
            line: 1215,
            column: 10
          },
          end: {
            line: 1217,
            column: 11
          }
        }],
        line: 1215
      },
      '101': {
        loc: {
          start: {
            line: 1225,
            column: 10
          },
          end: {
            line: 1268,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1225,
            column: 10
          },
          end: {
            line: 1268,
            column: 11
          }
        }, {
          start: {
            line: 1225,
            column: 10
          },
          end: {
            line: 1268,
            column: 11
          }
        }],
        line: 1225
      },
      '102': {
        loc: {
          start: {
            line: 1228,
            column: 30
          },
          end: {
            line: 1228,
            column: 123
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 1228,
            column: 68
          },
          end: {
            line: 1228,
            column: 103
          }
        }, {
          start: {
            line: 1228,
            column: 106
          },
          end: {
            line: 1228,
            column: 123
          }
        }],
        line: 1228
      },
      '103': {
        loc: {
          start: {
            line: 1229,
            column: 16
          },
          end: {
            line: 1231,
            column: 17
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1229,
            column: 16
          },
          end: {
            line: 1231,
            column: 17
          }
        }, {
          start: {
            line: 1229,
            column: 16
          },
          end: {
            line: 1231,
            column: 17
          }
        }],
        line: 1229
      },
      '104': {
        loc: {
          start: {
            line: 1232,
            column: 16
          },
          end: {
            line: 1234,
            column: 17
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1232,
            column: 16
          },
          end: {
            line: 1234,
            column: 17
          }
        }, {
          start: {
            line: 1232,
            column: 16
          },
          end: {
            line: 1234,
            column: 17
          }
        }],
        line: 1232
      },
      '105': {
        loc: {
          start: {
            line: 1245,
            column: 36
          },
          end: {
            line: 1245,
            column: 59
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 1245,
            column: 36
          },
          end: {
            line: 1245,
            column: 53
          }
        }, {
          start: {
            line: 1245,
            column: 57
          },
          end: {
            line: 1245,
            column: 59
          }
        }],
        line: 1245
      },
      '106': {
        loc: {
          start: {
            line: 1246,
            column: 20
          },
          end: {
            line: 1254,
            column: 21
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1246,
            column: 20
          },
          end: {
            line: 1254,
            column: 21
          }
        }, {
          start: {
            line: 1246,
            column: 20
          },
          end: {
            line: 1254,
            column: 21
          }
        }],
        line: 1246
      },
      '107': {
        loc: {
          start: {
            line: 1247,
            column: 22
          },
          end: {
            line: 1249,
            column: 23
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1247,
            column: 22
          },
          end: {
            line: 1249,
            column: 23
          }
        }, {
          start: {
            line: 1247,
            column: 22
          },
          end: {
            line: 1249,
            column: 23
          }
        }],
        line: 1247
      },
      '108': {
        loc: {
          start: {
            line: 1251,
            column: 22
          },
          end: {
            line: 1253,
            column: 23
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1251,
            column: 22
          },
          end: {
            line: 1253,
            column: 23
          }
        }, {
          start: {
            line: 1251,
            column: 22
          },
          end: {
            line: 1253,
            column: 23
          }
        }],
        line: 1251
      },
      '109': {
        loc: {
          start: {
            line: 1271,
            column: 8
          },
          end: {
            line: 1274,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1271,
            column: 8
          },
          end: {
            line: 1274,
            column: 9
          }
        }, {
          start: {
            line: 1271,
            column: 8
          },
          end: {
            line: 1274,
            column: 9
          }
        }],
        line: 1271
      },
      '110': {
        loc: {
          start: {
            line: 1329,
            column: 4
          },
          end: {
            line: 1332,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1329,
            column: 4
          },
          end: {
            line: 1332,
            column: 5
          }
        }, {
          start: {
            line: 1329,
            column: 4
          },
          end: {
            line: 1332,
            column: 5
          }
        }],
        line: 1329
      },
      '111': {
        loc: {
          start: {
            line: 1334,
            column: 6
          },
          end: {
            line: 1336,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1334,
            column: 6
          },
          end: {
            line: 1336,
            column: 7
          }
        }, {
          start: {
            line: 1334,
            column: 6
          },
          end: {
            line: 1336,
            column: 7
          }
        }],
        line: 1334
      },
      '112': {
        loc: {
          start: {
            line: 1341,
            column: 41
          },
          end: {
            line: 1341,
            column: 73
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 1341,
            column: 41
          },
          end: {
            line: 1341,
            column: 60
          }
        }, {
          start: {
            line: 1341,
            column: 64
          },
          end: {
            line: 1341,
            column: 73
          }
        }],
        line: 1341
      },
      '113': {
        loc: {
          start: {
            line: 1362,
            column: 6
          },
          end: {
            line: 1364,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1362,
            column: 6
          },
          end: {
            line: 1364,
            column: 7
          }
        }, {
          start: {
            line: 1362,
            column: 6
          },
          end: {
            line: 1364,
            column: 7
          }
        }],
        line: 1362
      },
      '114': {
        loc: {
          start: {
            line: 1377,
            column: 21
          },
          end: {
            line: 1377,
            column: 50
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 1377,
            column: 21
          },
          end: {
            line: 1377,
            column: 45
          }
        }, {
          start: {
            line: 1377,
            column: 49
          },
          end: {
            line: 1377,
            column: 50
          }
        }],
        line: 1377
      },
      '115': {
        loc: {
          start: {
            line: 1378,
            column: 24
          },
          end: {
            line: 1378,
            column: 56
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 1378,
            column: 24
          },
          end: {
            line: 1378,
            column: 51
          }
        }, {
          start: {
            line: 1378,
            column: 55
          },
          end: {
            line: 1378,
            column: 56
          }
        }],
        line: 1378
      },
      '116': {
        loc: {
          start: {
            line: 1379,
            column: 19
          },
          end: {
            line: 1379,
            column: 46
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 1379,
            column: 19
          },
          end: {
            line: 1379,
            column: 41
          }
        }, {
          start: {
            line: 1379,
            column: 45
          },
          end: {
            line: 1379,
            column: 46
          }
        }],
        line: 1379
      },
      '117': {
        loc: {
          start: {
            line: 1384,
            column: 6
          },
          end: {
            line: 1386,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1384,
            column: 6
          },
          end: {
            line: 1386,
            column: 7
          }
        }, {
          start: {
            line: 1384,
            column: 6
          },
          end: {
            line: 1386,
            column: 7
          }
        }],
        line: 1384
      },
      '118': {
        loc: {
          start: {
            line: 1391,
            column: 6
          },
          end: {
            line: 1393,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1391,
            column: 6
          },
          end: {
            line: 1393,
            column: 7
          }
        }, {
          start: {
            line: 1391,
            column: 6
          },
          end: {
            line: 1393,
            column: 7
          }
        }],
        line: 1391
      },
      '119': {
        loc: {
          start: {
            line: 1394,
            column: 6
          },
          end: {
            line: 1396,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1394,
            column: 6
          },
          end: {
            line: 1396,
            column: 7
          }
        }, {
          start: {
            line: 1394,
            column: 6
          },
          end: {
            line: 1396,
            column: 7
          }
        }],
        line: 1394
      },
      '120': {
        loc: {
          start: {
            line: 1456,
            column: 21
          },
          end: {
            line: 1456,
            column: 73
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 1456,
            column: 39
          },
          end: {
            line: 1456,
            column: 66
          }
        }, {
          start: {
            line: 1456,
            column: 69
          },
          end: {
            line: 1456,
            column: 73
          }
        }],
        line: 1456
      },
      '121': {
        loc: {
          start: {
            line: 1465,
            column: 8
          },
          end: {
            line: 1467,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1465,
            column: 8
          },
          end: {
            line: 1467,
            column: 9
          }
        }, {
          start: {
            line: 1465,
            column: 8
          },
          end: {
            line: 1467,
            column: 9
          }
        }],
        line: 1465
      },
      '122': {
        loc: {
          start: {
            line: 1550,
            column: 4
          },
          end: {
            line: 1552,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1550,
            column: 4
          },
          end: {
            line: 1552,
            column: 5
          }
        }, {
          start: {
            line: 1550,
            column: 4
          },
          end: {
            line: 1552,
            column: 5
          }
        }],
        line: 1550
      },
      '123': {
        loc: {
          start: {
            line: 1560,
            column: 8
          },
          end: {
            line: 1566,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1560,
            column: 8
          },
          end: {
            line: 1566,
            column: 9
          }
        }, {
          start: {
            line: 1560,
            column: 8
          },
          end: {
            line: 1566,
            column: 9
          }
        }],
        line: 1560
      },
      '124': {
        loc: {
          start: {
            line: 1563,
            column: 10
          },
          end: {
            line: 1565,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1563,
            column: 10
          },
          end: {
            line: 1565,
            column: 11
          }
        }, {
          start: {
            line: 1563,
            column: 10
          },
          end: {
            line: 1565,
            column: 11
          }
        }],
        line: 1563
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0,
      '74': 0,
      '75': 0,
      '76': 0,
      '77': 0,
      '78': 0,
      '79': 0,
      '80': 0,
      '81': 0,
      '82': 0,
      '83': 0,
      '84': 0,
      '85': 0,
      '86': 0,
      '87': 0,
      '88': 0,
      '89': 0,
      '90': 0,
      '91': 0,
      '92': 0,
      '93': 0,
      '94': 0,
      '95': 0,
      '96': 0,
      '97': 0,
      '98': 0,
      '99': 0,
      '100': 0,
      '101': 0,
      '102': 0,
      '103': 0,
      '104': 0,
      '105': 0,
      '106': 0,
      '107': 0,
      '108': 0,
      '109': 0,
      '110': 0,
      '111': 0,
      '112': 0,
      '113': 0,
      '114': 0,
      '115': 0,
      '116': 0,
      '117': 0,
      '118': 0,
      '119': 0,
      '120': 0,
      '121': 0,
      '122': 0,
      '123': 0,
      '124': 0,
      '125': 0,
      '126': 0,
      '127': 0,
      '128': 0,
      '129': 0,
      '130': 0,
      '131': 0,
      '132': 0,
      '133': 0,
      '134': 0,
      '135': 0,
      '136': 0,
      '137': 0,
      '138': 0,
      '139': 0,
      '140': 0,
      '141': 0,
      '142': 0,
      '143': 0,
      '144': 0,
      '145': 0,
      '146': 0,
      '147': 0,
      '148': 0,
      '149': 0,
      '150': 0,
      '151': 0,
      '152': 0,
      '153': 0,
      '154': 0,
      '155': 0,
      '156': 0,
      '157': 0,
      '158': 0,
      '159': 0,
      '160': 0,
      '161': 0,
      '162': 0,
      '163': 0,
      '164': 0,
      '165': 0,
      '166': 0,
      '167': 0,
      '168': 0,
      '169': 0,
      '170': 0,
      '171': 0,
      '172': 0,
      '173': 0,
      '174': 0,
      '175': 0,
      '176': 0,
      '177': 0,
      '178': 0,
      '179': 0,
      '180': 0,
      '181': 0,
      '182': 0,
      '183': 0,
      '184': 0,
      '185': 0,
      '186': 0,
      '187': 0,
      '188': 0,
      '189': 0,
      '190': 0,
      '191': 0,
      '192': 0,
      '193': 0,
      '194': 0,
      '195': 0,
      '196': 0,
      '197': 0,
      '198': 0,
      '199': 0,
      '200': 0,
      '201': 0,
      '202': 0,
      '203': 0,
      '204': 0,
      '205': 0,
      '206': 0,
      '207': 0,
      '208': 0,
      '209': 0,
      '210': 0,
      '211': 0,
      '212': 0,
      '213': 0,
      '214': 0,
      '215': 0,
      '216': 0,
      '217': 0,
      '218': 0,
      '219': 0,
      '220': 0,
      '221': 0,
      '222': 0,
      '223': 0,
      '224': 0,
      '225': 0,
      '226': 0,
      '227': 0,
      '228': 0,
      '229': 0,
      '230': 0,
      '231': 0,
      '232': 0,
      '233': 0,
      '234': 0,
      '235': 0,
      '236': 0,
      '237': 0,
      '238': 0,
      '239': 0,
      '240': 0,
      '241': 0,
      '242': 0,
      '243': 0,
      '244': 0,
      '245': 0,
      '246': 0,
      '247': 0,
      '248': 0,
      '249': 0,
      '250': 0,
      '251': 0,
      '252': 0,
      '253': 0,
      '254': 0,
      '255': 0,
      '256': 0,
      '257': 0,
      '258': 0,
      '259': 0,
      '260': 0,
      '261': 0,
      '262': 0,
      '263': 0,
      '264': 0,
      '265': 0,
      '266': 0,
      '267': 0,
      '268': 0,
      '269': 0,
      '270': 0,
      '271': 0,
      '272': 0,
      '273': 0,
      '274': 0,
      '275': 0,
      '276': 0,
      '277': 0,
      '278': 0,
      '279': 0,
      '280': 0,
      '281': 0,
      '282': 0,
      '283': 0,
      '284': 0,
      '285': 0,
      '286': 0,
      '287': 0,
      '288': 0,
      '289': 0,
      '290': 0,
      '291': 0,
      '292': 0,
      '293': 0,
      '294': 0,
      '295': 0,
      '296': 0,
      '297': 0,
      '298': 0,
      '299': 0,
      '300': 0,
      '301': 0,
      '302': 0,
      '303': 0,
      '304': 0,
      '305': 0,
      '306': 0,
      '307': 0,
      '308': 0,
      '309': 0,
      '310': 0,
      '311': 0,
      '312': 0,
      '313': 0,
      '314': 0,
      '315': 0,
      '316': 0,
      '317': 0,
      '318': 0,
      '319': 0,
      '320': 0,
      '321': 0,
      '322': 0,
      '323': 0,
      '324': 0,
      '325': 0,
      '326': 0,
      '327': 0,
      '328': 0,
      '329': 0,
      '330': 0,
      '331': 0,
      '332': 0,
      '333': 0,
      '334': 0,
      '335': 0,
      '336': 0,
      '337': 0,
      '338': 0,
      '339': 0,
      '340': 0,
      '341': 0,
      '342': 0,
      '343': 0,
      '344': 0,
      '345': 0,
      '346': 0,
      '347': 0,
      '348': 0,
      '349': 0,
      '350': 0,
      '351': 0,
      '352': 0,
      '353': 0,
      '354': 0,
      '355': 0,
      '356': 0,
      '357': 0,
      '358': 0,
      '359': 0,
      '360': 0,
      '361': 0,
      '362': 0,
      '363': 0,
      '364': 0,
      '365': 0,
      '366': 0,
      '367': 0,
      '368': 0,
      '369': 0,
      '370': 0,
      '371': 0,
      '372': 0,
      '373': 0,
      '374': 0,
      '375': 0,
      '376': 0,
      '377': 0,
      '378': 0,
      '379': 0,
      '380': 0,
      '381': 0,
      '382': 0,
      '383': 0,
      '384': 0,
      '385': 0,
      '386': 0,
      '387': 0,
      '388': 0,
      '389': 0,
      '390': 0,
      '391': 0,
      '392': 0,
      '393': 0,
      '394': 0,
      '395': 0,
      '396': 0,
      '397': 0,
      '398': 0,
      '399': 0,
      '400': 0,
      '401': 0,
      '402': 0,
      '403': 0,
      '404': 0,
      '405': 0,
      '406': 0,
      '407': 0,
      '408': 0,
      '409': 0,
      '410': 0,
      '411': 0,
      '412': 0,
      '413': 0,
      '414': 0,
      '415': 0,
      '416': 0,
      '417': 0,
      '418': 0,
      '419': 0,
      '420': 0,
      '421': 0,
      '422': 0,
      '423': 0,
      '424': 0,
      '425': 0,
      '426': 0,
      '427': 0,
      '428': 0,
      '429': 0,
      '430': 0,
      '431': 0,
      '432': 0,
      '433': 0,
      '434': 0,
      '435': 0,
      '436': 0,
      '437': 0,
      '438': 0,
      '439': 0,
      '440': 0,
      '441': 0,
      '442': 0,
      '443': 0,
      '444': 0,
      '445': 0,
      '446': 0,
      '447': 0,
      '448': 0,
      '449': 0,
      '450': 0,
      '451': 0,
      '452': 0,
      '453': 0,
      '454': 0,
      '455': 0,
      '456': 0,
      '457': 0,
      '458': 0,
      '459': 0,
      '460': 0,
      '461': 0,
      '462': 0,
      '463': 0,
      '464': 0,
      '465': 0,
      '466': 0,
      '467': 0,
      '468': 0,
      '469': 0,
      '470': 0,
      '471': 0,
      '472': 0,
      '473': 0,
      '474': 0,
      '475': 0,
      '476': 0,
      '477': 0,
      '478': 0,
      '479': 0,
      '480': 0,
      '481': 0,
      '482': 0,
      '483': 0,
      '484': 0,
      '485': 0,
      '486': 0,
      '487': 0,
      '488': 0,
      '489': 0,
      '490': 0,
      '491': 0,
      '492': 0,
      '493': 0,
      '494': 0,
      '495': 0,
      '496': 0,
      '497': 0,
      '498': 0,
      '499': 0,
      '500': 0,
      '501': 0,
      '502': 0,
      '503': 0,
      '504': 0,
      '505': 0,
      '506': 0,
      '507': 0,
      '508': 0,
      '509': 0,
      '510': 0,
      '511': 0,
      '512': 0,
      '513': 0,
      '514': 0,
      '515': 0,
      '516': 0,
      '517': 0,
      '518': 0,
      '519': 0,
      '520': 0,
      '521': 0,
      '522': 0,
      '523': 0,
      '524': 0,
      '525': 0,
      '526': 0,
      '527': 0,
      '528': 0,
      '529': 0,
      '530': 0,
      '531': 0,
      '532': 0,
      '533': 0,
      '534': 0,
      '535': 0,
      '536': 0,
      '537': 0,
      '538': 0,
      '539': 0,
      '540': 0,
      '541': 0,
      '542': 0,
      '543': 0,
      '544': 0,
      '545': 0,
      '546': 0,
      '547': 0,
      '548': 0,
      '549': 0,
      '550': 0,
      '551': 0,
      '552': 0,
      '553': 0,
      '554': 0,
      '555': 0,
      '556': 0,
      '557': 0,
      '558': 0,
      '559': 0,
      '560': 0,
      '561': 0,
      '562': 0,
      '563': 0,
      '564': 0,
      '565': 0,
      '566': 0,
      '567': 0,
      '568': 0,
      '569': 0,
      '570': 0,
      '571': 0,
      '572': 0,
      '573': 0,
      '574': 0,
      '575': 0,
      '576': 0,
      '577': 0,
      '578': 0,
      '579': 0,
      '580': 0,
      '581': 0,
      '582': 0,
      '583': 0,
      '584': 0,
      '585': 0,
      '586': 0,
      '587': 0,
      '588': 0,
      '589': 0,
      '590': 0,
      '591': 0,
      '592': 0,
      '593': 0,
      '594': 0,
      '595': 0,
      '596': 0,
      '597': 0,
      '598': 0,
      '599': 0,
      '600': 0,
      '601': 0,
      '602': 0,
      '603': 0,
      '604': 0,
      '605': 0,
      '606': 0,
      '607': 0,
      '608': 0,
      '609': 0,
      '610': 0,
      '611': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0],
      '12': [0, 0],
      '13': [0, 0],
      '14': [0, 0],
      '15': [0, 0],
      '16': [0, 0],
      '17': [0, 0],
      '18': [0, 0],
      '19': [0, 0],
      '20': [0, 0],
      '21': [0, 0],
      '22': [0, 0],
      '23': [0, 0],
      '24': [0, 0],
      '25': [0, 0],
      '26': [0, 0],
      '27': [0, 0],
      '28': [0, 0],
      '29': [0, 0],
      '30': [0, 0],
      '31': [0, 0],
      '32': [0, 0],
      '33': [0, 0],
      '34': [0, 0],
      '35': [0, 0],
      '36': [0, 0],
      '37': [0, 0],
      '38': [0, 0],
      '39': [0, 0],
      '40': [0, 0],
      '41': [0, 0],
      '42': [0, 0],
      '43': [0, 0],
      '44': [0, 0],
      '45': [0, 0],
      '46': [0, 0],
      '47': [0, 0],
      '48': [0, 0],
      '49': [0, 0],
      '50': [0, 0],
      '51': [0, 0, 0],
      '52': [0, 0],
      '53': [0, 0],
      '54': [0, 0],
      '55': [0, 0],
      '56': [0, 0, 0],
      '57': [0, 0],
      '58': [0, 0],
      '59': [0, 0],
      '60': [0, 0],
      '61': [0, 0],
      '62': [0, 0],
      '63': [0, 0],
      '64': [0, 0],
      '65': [0, 0],
      '66': [0, 0],
      '67': [0, 0],
      '68': [0, 0],
      '69': [0, 0],
      '70': [0, 0],
      '71': [0, 0],
      '72': [0, 0],
      '73': [0, 0],
      '74': [0, 0],
      '75': [0, 0],
      '76': [0, 0],
      '77': [0, 0],
      '78': [0, 0],
      '79': [0, 0],
      '80': [0, 0],
      '81': [0, 0],
      '82': [0, 0],
      '83': [0, 0],
      '84': [0, 0],
      '85': [0, 0],
      '86': [0, 0],
      '87': [0, 0],
      '88': [0, 0],
      '89': [0, 0],
      '90': [0, 0],
      '91': [0, 0],
      '92': [0, 0],
      '93': [0, 0],
      '94': [0, 0],
      '95': [0, 0],
      '96': [0, 0],
      '97': [0, 0],
      '98': [0, 0],
      '99': [0, 0, 0, 0, 0, 0],
      '100': [0, 0],
      '101': [0, 0],
      '102': [0, 0],
      '103': [0, 0],
      '104': [0, 0],
      '105': [0, 0],
      '106': [0, 0],
      '107': [0, 0],
      '108': [0, 0],
      '109': [0, 0],
      '110': [0, 0],
      '111': [0, 0],
      '112': [0, 0],
      '113': [0, 0],
      '114': [0, 0],
      '115': [0, 0],
      '116': [0, 0],
      '117': [0, 0],
      '118': [0, 0],
      '119': [0, 0],
      '120': [0, 0],
      '121': [0, 0],
      '122': [0, 0],
      '123': [0, 0],
      '124': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _this4 = this;

cov_24f1td4mjl.s[0]++;

angular.module('app').controller('dashboardCtrl', function ($scope, $translate, $stateParams, $deltaNumber, $sce, $otherHttpService, $LOGINService, $deltaCategoriesBudget, FileUploader, $deltaFinancSource, $deltaLocation, $CRUDService, $deltahttp, $deltaPlanLogique, $deltadate, $location, $http, $deltaGeoLevel, $rootScope, $filter, $deltaTypeIndicateur, $deltaPeriode, $state, $timeout, $log) {
  cov_24f1td4mjl.f[0]++;
  cov_24f1td4mjl.s[1]++;

  $scope.listProjects = [];

  cov_24f1td4mjl.s[2]++;
  ej.grids.Grid.Inject(ej.grids.Aggregate);

  cov_24f1td4mjl.s[3]++;
  $rootScope.processPageRight('1_1', function () {
    cov_24f1td4mjl.f[1]++;
    cov_24f1td4mjl.s[4]++;

    $rootScope.global_access_page_denied = false;
    cov_24f1td4mjl.s[5]++;
    $rootScope.currentRight.v = true;
  });

  cov_24f1td4mjl.s[6]++;
  $scope.PATH = 'Projet';
  var PATH_FORMULAR = (cov_24f1td4mjl.s[7]++, 'Formular');
  cov_24f1td4mjl.s[8]++;
  $scope.tab = 1;
  cov_24f1td4mjl.s[9]++;
  $rootScope.global_access_page_denied = false;
  cov_24f1td4mjl.s[10]++;
  $scope.financialData = { amount: 0, labels: '' };
  cov_24f1td4mjl.s[11]++;
  $scope.getFinancial = function () {
    cov_24f1td4mjl.f[2]++;
    cov_24f1td4mjl.s[12]++;

    $CRUDService.getAll($scope.PATH, { get: 'finance_info' }, function (data) {
      cov_24f1td4mjl.f[3]++;
      cov_24f1td4mjl.s[13]++;

      $scope.financialData.amount = data.amount;
      cov_24f1td4mjl.s[14]++;
      $scope.financialData.labels = data.list.join(', ');
    });
  };

  var PROJECT_DASHBOARD_INDICATOR = (cov_24f1td4mjl.s[15]++, 'PROJECT_DASHBOARD_INDICATOR_' + $rootScope.currentProject.project.id);
  var PROJECT_DASHBOARD_INDICATOR_PERIOD = (cov_24f1td4mjl.s[16]++, 'PROJECT_DASHBOARD_INDICATOR_PERIOD_' + $rootScope.currentProject.project.id);

  cov_24f1td4mjl.s[17]++;
  $scope.PATHIMG = $deltahttp.getIndicatorRespositoy();
  cov_24f1td4mjl.s[18]++;
  $scope.PATHIMG_ACTIVITY = $deltahttp.getActivityRespositoy();

  cov_24f1td4mjl.s[19]++;
  $deltaLocation.addController($scope);
  cov_24f1td4mjl.s[20]++;
  $deltaPlanLogique.addController($scope);
  cov_24f1td4mjl.s[21]++;
  $deltaCategoriesBudget.addController($scope);
  cov_24f1td4mjl.s[22]++;
  $deltaFinancSource.addController($scope);

  var defaultLegend = (cov_24f1td4mjl.s[23]++, [{ c: '#ffffcc', l: '', v: 0 }, { c: '#c2e699', l: '', v: 10 }, { c: '#78c679', l: '', v: 40 }, { c: '#31a354', l: '', v: 60 }, { c: '#006837', l: '', v: 80 }]);

  cov_24f1td4mjl.s[24]++;
  $scope.gridsterOpts = {
    columns: 8,
    margins: [20, 20],
    outerMargin: false,
    pushing: true,
    floating: true,
    draggable: {
      enabled: false
    },
    resizable: {
      enabled: false
    }
  };

  cov_24f1td4mjl.s[25]++;
  $scope.listMilestone = [];
  var PATH_ANALYSE = (cov_24f1td4mjl.s[26]++, 'Analyse');
  cov_24f1td4mjl.s[27]++;
  $scope.analyseList = [];

  cov_24f1td4mjl.s[28]++;

  $scope.selectedDashboard = null;
  cov_24f1td4mjl.s[29]++;
  $scope.availableDashboardList = [];
  cov_24f1td4mjl.s[30]++;
  $scope.saveActiveTab = function () {
    cov_24f1td4mjl.f[4]++;
    cov_24f1td4mjl.s[31]++;

    localStorage.setItem('TAB_PROJECT_MENU_' + $rootScope.currentProject.project.id, angular.toJson($scope.availableDashboardList.map(function (item) {
      cov_24f1td4mjl.f[5]++;
      cov_24f1td4mjl.s[32]++;
      return item.id;
    })));
  };

  cov_24f1td4mjl.s[33]++;

  $scope.closeDashboard = function (item) {
    cov_24f1td4mjl.f[6]++;

    var index = (cov_24f1td4mjl.s[34]++, $scope.availableDashboardList.indexOf(item));
    cov_24f1td4mjl.s[35]++;
    if (index >= 0) {
      cov_24f1td4mjl.b[0][0]++;
      cov_24f1td4mjl.s[36]++;

      $scope.availableDashboardList.splice(index, 1);
      cov_24f1td4mjl.s[37]++;
      $scope.saveActiveTab();
    } else {
      cov_24f1td4mjl.b[0][1]++;
    }

    cov_24f1td4mjl.s[38]++;
    if (item.id == $scope.selectedDashboard.id) {
      cov_24f1td4mjl.b[1][0]++;
      cov_24f1td4mjl.s[39]++;

      $scope.selectDashboard($scope.data_main.find(function (dashboard) {
        cov_24f1td4mjl.f[7]++;
        cov_24f1td4mjl.s[40]++;

        return dashboard.id == 0;
      }));
    } else {
      cov_24f1td4mjl.b[1][1]++;
    }
    cov_24f1td4mjl.s[41]++;
    item.display = false;
  };

  cov_24f1td4mjl.s[42]++;

  $scope.addDashboard = function (item) {
    cov_24f1td4mjl.f[8]++;

    var index = (cov_24f1td4mjl.s[43]++, $scope.availableDashboardList.indexOf(item));
    cov_24f1td4mjl.s[44]++;
    if (index < 0) {
      cov_24f1td4mjl.b[2][0]++;
      cov_24f1td4mjl.s[45]++;

      item.display = true;
      cov_24f1td4mjl.s[46]++;
      $scope.availableDashboardList.push(item);
      cov_24f1td4mjl.s[47]++;
      $scope.saveActiveTab();
    } else {
      cov_24f1td4mjl.b[2][1]++;
    }
    cov_24f1td4mjl.s[48]++;
    item.display = true;
    cov_24f1td4mjl.s[49]++;
    $scope.selectDashboard(item);
  };

  cov_24f1td4mjl.s[50]++;

  $scope.selectDashboard = function (item) {
    cov_24f1td4mjl.f[9]++;
    cov_24f1td4mjl.s[51]++;

    $scope.idcomponent = new Date().getTime();
    cov_24f1td4mjl.s[52]++;
    $scope.selectedDashboard = angular.copy(item);
    cov_24f1td4mjl.s[53]++;
    if (item.id <= 0) {
      cov_24f1td4mjl.b[3][0]++;
      cov_24f1td4mjl.s[54]++;

      localStorage.setItem('TAB_PROJECT_' + $rootScope.currentProject.project.id, $scope.selectedDashboard.id);
      cov_24f1td4mjl.s[55]++;
      return;
    } else {
      cov_24f1td4mjl.b[3][1]++;
    }
    cov_24f1td4mjl.s[56]++;
    localStorage.setItem('TAB_PROJECT_' + $rootScope.currentProject.project.id, $scope.selectedDashboard.id);
  };

  cov_24f1td4mjl.s[57]++;
  $otherHttpService.get('Milestone', { get: 'all' }, function (data) {
    cov_24f1td4mjl.f[10]++;
    cov_24f1td4mjl.s[58]++;

    $scope.listMilestone = data;
  });
  cov_24f1td4mjl.s[59]++;
  $scope.changeTab = function (index) {
    cov_24f1td4mjl.f[11]++;
    cov_24f1td4mjl.s[60]++;

    $scope.tab = index;
  };
  var PATH = (cov_24f1td4mjl.s[61]++, 'Indicateurs');
  var PATH_DEC = (cov_24f1td4mjl.s[62]++, 'DecoupageIndic');
  cov_24f1td4mjl.s[63]++;
  $deltaTypeIndicateur.addController($scope);
  cov_24f1td4mjl.s[64]++;
  $scope.getIndicateurLabel = function (item) {
    cov_24f1td4mjl.f[12]++;
    cov_24f1td4mjl.s[65]++;

    if (!item.lie) {
      cov_24f1td4mjl.b[4][0]++;
      cov_24f1td4mjl.s[66]++;

      return item.li;
    } else {
      cov_24f1td4mjl.b[4][1]++;
    }
    cov_24f1td4mjl.s[67]++;
    if (item.lie.trim() == '') {
      cov_24f1td4mjl.b[5][0]++;
      cov_24f1td4mjl.s[68]++;

      return item.li;
    } else {
      cov_24f1td4mjl.b[5][1]++;
    }
    cov_24f1td4mjl.s[69]++;
    if (!item.li) {
      cov_24f1td4mjl.b[6][0]++;
      cov_24f1td4mjl.s[70]++;

      return item.lie;
    } else {
      cov_24f1td4mjl.b[6][1]++;
    }
    cov_24f1td4mjl.s[71]++;
    if (item.li.trim() == '') {
      cov_24f1td4mjl.b[7][0]++;
      cov_24f1td4mjl.s[72]++;

      return item.lie;
    } else {
      cov_24f1td4mjl.b[7][1]++;
    }
    cov_24f1td4mjl.s[73]++;
    if ($rootScope.language.id == 'en') {
      cov_24f1td4mjl.b[8][0]++;
      cov_24f1td4mjl.s[74]++;

      return item.lie;
    } else {
      cov_24f1td4mjl.b[8][1]++;
    }
    cov_24f1td4mjl.s[75]++;
    return item.li;
  };
  cov_24f1td4mjl.s[76]++;
  $scope.personalize = {
    editlabel: false,
    labelPerso: $rootScope.currentProject.project.getLabelTB(),
    editlabelPerso: $rootScope.currentProject.project.getLabelTB(),
    save: function save() {
      cov_24f1td4mjl.s[77]++;

      this.editlabel = false;
      cov_24f1td4mjl.s[78]++;
      this.labelPerso = this.editlabelPerso;
      cov_24f1td4mjl.s[79]++;
      $rootScope.currentProject.project.setLabelTB(this.editlabelPerso);
    }
  };

  var project = (cov_24f1td4mjl.s[80]++, $rootScope.getCurrentProject());
  cov_24f1td4mjl.s[81]++;
  $scope.tmp_project = project.project;

  cov_24f1td4mjl.s[82]++;
  $scope.YearList = $deltadate.getYearBetween(project.project.DATE_DEB_PROJET, project.project.DATE_FIN_PROJET, $deltadate.getStartMonth());

  cov_24f1td4mjl.s[83]++;
  $scope.indicateurDashbord = {
    yearSelect: (cov_24f1td4mjl.b[9][0]++, $filter('filter')($scope.YearList, { id: Date.newDate().getFullYear().toString() }, true)[0]) || (cov_24f1td4mjl.b[9][1]++, $scope.YearList[0]),
    period: 1,
    data: [],
    onlyValidated: false,
    hasValidationWorkflow: false,
    openDashboard: function openDashboard(item) {
      cov_24f1td4mjl.s[84]++;

      if (item.id) {
        cov_24f1td4mjl.b[10][0]++;
        cov_24f1td4mjl.s[85]++;

        $CRUDService.getAll('Indicateurs', { get: 'all', idcl: item.idcl, id: item.id, page: 1, nr: true, cat: true }, function (data) {
          cov_24f1td4mjl.f[13]++;
          cov_24f1td4mjl.s[86]++;

          $scope.loading = false;
          cov_24f1td4mjl.s[87]++;
          if (data.length > 0) {
            cov_24f1td4mjl.b[11][0]++;
            cov_24f1td4mjl.s[88]++;

            data[0].RATIONAL = data[0].RATIONAL == 1;
            cov_24f1td4mjl.s[89]++;
            localStorage.setItem('selectedIndicatorOverview', angular.toJson(data[0]));
            cov_24f1td4mjl.s[90]++;
            $state.go('indicator.overview.dashboards', { indicator: data[0], origin: { from: 'index.dashboard', params: {} }, dashboard: true });
          } else {
            cov_24f1td4mjl.b[11][1]++;
          }
        });
      } else {
        cov_24f1td4mjl.b[10][1]++;
      }
    },
    getSituationIndicateur: function getSituationIndicateur() {
      var _this = this;

      cov_24f1td4mjl.s[91]++;

      $scope.dateIndic = Date.newDate();
      cov_24f1td4mjl.s[92]++;
      $otherHttpService.get('Indicateurs', { get: 'tbhome', idl: 0, type: 0, valid: this.onlyValidated ? (cov_24f1td4mjl.b[12][0]++, 1) : (cov_24f1td4mjl.b[12][1]++, 0) }, function (dataR) {
        cov_24f1td4mjl.f[14]++;
        cov_24f1td4mjl.s[93]++;

        if ((cov_24f1td4mjl.b[14][0]++, !dataR) || (cov_24f1td4mjl.b[14][1]++, dataR.d.length <= 0)) {
          cov_24f1td4mjl.b[13][0]++;
          cov_24f1td4mjl.s[94]++;

          return;
        } else {
          cov_24f1td4mjl.b[13][1]++;
        }
        var data = (cov_24f1td4mjl.s[95]++, dataR.d);
        var firstData = (cov_24f1td4mjl.s[96]++, data[0]);
        cov_24f1td4mjl.s[97]++;
        if (!firstData) {
          cov_24f1td4mjl.b[15][0]++;
          cov_24f1td4mjl.s[98]++;

          return;
        } else {
          cov_24f1td4mjl.b[15][1]++;
        }
        var header = (cov_24f1td4mjl.s[99]++, []);
        cov_24f1td4mjl.s[100]++;
        if (firstData) {
          cov_24f1td4mjl.b[16][0]++;
          cov_24f1td4mjl.s[101]++;

          for (var prop in firstData) {
            var proprN = (cov_24f1td4mjl.s[102]++, $deltaNumber.formatNumber(prop, null));
            cov_24f1td4mjl.s[103]++;
            if (!proprN) {
              cov_24f1td4mjl.b[17][0]++;
              cov_24f1td4mjl.s[104]++;

              continue;
            } else {
              cov_24f1td4mjl.b[17][1]++;
            }
            cov_24f1td4mjl.s[105]++;
            header.push(prop);
          }
        } else {
          cov_24f1td4mjl.b[16][1]++;
        }
        var dataFinal = (cov_24f1td4mjl.s[106]++, []);

        cov_24f1td4mjl.s[107]++;
        for (var _iterator = data, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
          var _ref;

          if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
          } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
          }

          var obj = _ref;

          var second = (cov_24f1td4mjl.s[108]++, {
            lib: $scope.getIndicateurLabel(obj),
            des: obj.ll, c: obj.ci, t: obj.ti,

            vc: $rootScope.displayIndicatorValue(obj.VALEUR_CIBLE, obj.t, obj.fo, obj.vp, obj.display, true),
            vr: $rootScope.displayIndicatorValue(obj.VALEUR_REF, obj.t, obj.fo, obj.vp, obj.display, true),
            vcN: $deltaNumber.formatNumber(obj.VALEUR_CIBLE, null, obj.fo),
            vrN: $deltaNumber.formatNumber(obj.VALEUR_REF, null, obj.fo),
            display: obj.display, type: obj.t, d1: [], d2: [], d: [], id: obj.id, idcl: obj.idcl, p: obj.p,
            fo: obj.fo, vp: obj.vp
          });
          var headers = (cov_24f1td4mjl.s[109]++, []);
          cov_24f1td4mjl.s[110]++;
          for (var _prop in obj) {
            var _proprN = (cov_24f1td4mjl.s[111]++, Number(_prop));
            cov_24f1td4mjl.s[112]++;
            if ((cov_24f1td4mjl.b[19][0]++, _proprN == Number.NaN) || (cov_24f1td4mjl.b[19][1]++, !_proprN)) {
              cov_24f1td4mjl.b[18][0]++;
              cov_24f1td4mjl.s[113]++;

              continue;
            } else {
              cov_24f1td4mjl.b[18][1]++;
            }
            cov_24f1td4mjl.s[114]++;
            headers.push(_prop);
          }
          cov_24f1td4mjl.s[115]++;
          for (var _iterator2 = headers, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref2;

            if (_isArray2) {
              if (_i2 >= _iterator2.length) break;
              _ref2 = _iterator2[_i2++];
            } else {
              _i2 = _iterator2.next();
              if (_i2.done) break;
              _ref2 = _i2.value;
            }

            var _header = _ref2;
            cov_24f1td4mjl.s[116]++;

            second.d.push({
              y: _header,
              v: $rootScope.displayIndicatorValue(obj[_header], obj.t, obj.fo, obj.vp, obj.display, true) });
          }
          cov_24f1td4mjl.s[117]++;
          dataFinal.push(second);
        }

        cov_24f1td4mjl.s[118]++;
        $scope.indicateurDashbord.data = dataFinal;
        var savedItem = (cov_24f1td4mjl.s[119]++, (cov_24f1td4mjl.b[20][0]++, localStorage.getItem(PROJECT_DASHBOARD_INDICATOR)) || (cov_24f1td4mjl.b[20][1]++, 0));

        cov_24f1td4mjl.s[120]++;
        _this.period = (cov_24f1td4mjl.b[21][0]++, localStorage.getItem(PROJECT_DASHBOARD_INDICATOR_PERIOD)) || (cov_24f1td4mjl.b[21][1]++, 1);

        var selectIndicator = (cov_24f1td4mjl.s[121]++, dataFinal.find(function (indicator) {
          cov_24f1td4mjl.f[15]++;
          cov_24f1td4mjl.s[122]++;
          return indicator.id == savedItem;
        }));

        cov_24f1td4mjl.s[123]++;
        $scope.indicateurDashbord.selectIndicateur((cov_24f1td4mjl.b[22][0]++, selectIndicator) || (cov_24f1td4mjl.b[22][1]++, dataFinal[0]));
      });
    },
    selectIndicateur: function selectIndicateur(item) {
      cov_24f1td4mjl.s[124]++;

      if ((cov_24f1td4mjl.b[24][0]++, !item) && (cov_24f1td4mjl.b[24][1]++, !this.selectedItem)) {
        cov_24f1td4mjl.b[23][0]++;
        cov_24f1td4mjl.s[125]++;

        return;
      } else {
        cov_24f1td4mjl.b[23][1]++;
      }

      cov_24f1td4mjl.s[126]++;
      if (!item) {
        cov_24f1td4mjl.b[25][0]++;
        cov_24f1td4mjl.s[127]++;

        item = this.selectedItem;
      } else {
        cov_24f1td4mjl.b[25][1]++;
        cov_24f1td4mjl.s[128]++;

        this.selectedItem = item;
      }

      cov_24f1td4mjl.s[129]++;
      if ($scope.indicateurDashbord.selectedItem.p == 1) {
        cov_24f1td4mjl.b[26][0]++;
        cov_24f1td4mjl.s[130]++;

        this.period = 2;
      } else {
        cov_24f1td4mjl.b[26][1]++;
      }

      cov_24f1td4mjl.s[131]++;
      localStorage.setItem(PROJECT_DASHBOARD_INDICATOR, this.selectedItem.id);

      var self = (cov_24f1td4mjl.s[132]++, this);
      cov_24f1td4mjl.s[133]++;
      $CRUDService.getAll('Indicateurs', { get: 'has_validation_workflow', id_indic: item.id }, function (response) {
        cov_24f1td4mjl.f[16]++;
        cov_24f1td4mjl.s[134]++;

        self.hasValidationWorkflow = response.hasWorkflow;
        cov_24f1td4mjl.s[135]++;

        if (!response.hasWorkflow) {
          cov_24f1td4mjl.b[27][0]++;
          cov_24f1td4mjl.s[136]++;

          self.onlyValidated = false;
        } else {
          cov_24f1td4mjl.b[27][1]++;
        }
      });

      var params = (cov_24f1td4mjl.s[137]++, { get: 'tbhome_detail', id: item.id, idcl: item.idcl, type: 0, all_location: 1, not_display_all_location: true, valid: this.onlyValidated ? (cov_24f1td4mjl.b[28][0]++, 1) : (cov_24f1td4mjl.b[28][1]++, 0) });
      cov_24f1td4mjl.s[138]++;
      if (this.period == 2) {
        cov_24f1td4mjl.b[29][0]++;
        cov_24f1td4mjl.s[139]++;

        params.get = 'tbhome_detail_period';
      } else {
        cov_24f1td4mjl.b[29][1]++;
      }
      cov_24f1td4mjl.s[140]++;
      this.grapheDash = {
        labels: [],
        series: [],
        data: [],
        options: [],
        colors: []
      };
      cov_24f1td4mjl.s[141]++;
      $scope.indicatorLoading = true;
      cov_24f1td4mjl.s[142]++;
      $scope.indicatorChartEmpty = false;
      cov_24f1td4mjl.s[143]++;
      $scope.indicateurDashbord.tableParams = null;
      cov_24f1td4mjl.s[144]++;
      $otherHttpService.get('Indicateurs', params, function (data) {
        cov_24f1td4mjl.f[17]++;
        cov_24f1td4mjl.s[145]++;

        $scope.indicatorLoading = false;
        cov_24f1td4mjl.s[146]++;
        if (data.length == 0) {
          cov_24f1td4mjl.b[30][0]++;
          cov_24f1td4mjl.s[147]++;

          $scope.indicatorChartEmpty = true;
        } else {
          cov_24f1td4mjl.b[30][1]++;
        }
        var headers = (cov_24f1td4mjl.s[148]++, $scope.indicateurDashbord.selectedItem.d.map(function (year) {
          cov_24f1td4mjl.f[18]++;
          cov_24f1td4mjl.s[149]++;
          return { label: year.y, index: year.y };
        }));

        cov_24f1td4mjl.s[150]++;
        if ((cov_24f1td4mjl.b[32][0]++, headers.length > 0) && (cov_24f1td4mjl.b[32][1]++, $scope.indicateurDashbord.period == 2)) {
          cov_24f1td4mjl.b[31][0]++;

          var beginDate = (cov_24f1td4mjl.s[151]++, Date.newDate(headers[0].index + '-01-01'));
          var endDate = (cov_24f1td4mjl.s[152]++, Date.newDate(headers[headers.length - 1].index + '-12-31'));
          cov_24f1td4mjl.s[153]++;
          headers = $deltadate.getPeriods(beginDate, endDate, $scope.indicateurDashbord.selectedItem.p, true).map(function (period) {
            cov_24f1td4mjl.f[19]++;
            cov_24f1td4mjl.s[154]++;
            return {
              label: $deltadate.getLabelPerioddepth(period.index * (12 / $deltaNumber.formatNumber($scope.indicateurDashbord.selectedItem.p)), 12, true, period.year),
              index: '' + period.year + period.index
            };
          });
        } else {
          cov_24f1td4mjl.b[31][1]++;
        }

        var obj = (cov_24f1td4mjl.s[155]++, $scope.indicateurDashbord.selectedItem);

        var canDisplay = (cov_24f1td4mjl.s[156]++, obj.display !== 'WEIGHT');

        cov_24f1td4mjl.s[157]++;
        for (var i = 0; i < data.length; i++) {
          cov_24f1td4mjl.s[158]++;

          data[i].T = $deltaNumber.formatNumber(data[i].T, null, $scope.indicateurDashbord.selectedItem.fo);
          cov_24f1td4mjl.s[159]++;
          if (data[i].T !== null) {
            cov_24f1td4mjl.b[33][0]++;
            cov_24f1td4mjl.s[160]++;

            data[i].T = data[i].T = (cov_24f1td4mjl.b[35][0]++, data[i].c === 0) || (cov_24f1td4mjl.b[35][1]++, data[i].c === null) ? (cov_24f1td4mjl.b[34][0]++, null) : (cov_24f1td4mjl.b[34][1]++, data[i].T / data[i].c);
          } else {
            cov_24f1td4mjl.b[33][1]++;
          }
          cov_24f1td4mjl.s[161]++;
          data[i].df = Date.newDate(data[i].df);

          cov_24f1td4mjl.s[162]++;
          if (!data[i].lo) {
            cov_24f1td4mjl.b[36][0]++;
            cov_24f1td4mjl.s[163]++;

            continue;
          } else {
            cov_24f1td4mjl.b[36][1]++;
          }

          cov_24f1td4mjl.s[164]++;
          data[i].c = $rootScope.displayIndicatorValue(data[i].c, obj.type, obj.fo, obj.vp, obj.display);
          cov_24f1td4mjl.s[165]++;
          data[i].b = $rootScope.displayIndicatorValue(data[i].b, obj.type, obj.fo, obj.vp, obj.display);
          cov_24f1td4mjl.s[166]++;
          for (var j = 0; j < headers.length; j++) {
            cov_24f1td4mjl.s[167]++;

            if (angular.isUndefined(data[i][headers[j].index])) {
              cov_24f1td4mjl.b[37][0]++;
              cov_24f1td4mjl.s[168]++;

              data[i][headers[j].index] = null;
              cov_24f1td4mjl.s[169]++;
              continue;
            } else {
              cov_24f1td4mjl.b[37][1]++;
            }
            cov_24f1td4mjl.s[170]++;
            data[i][headers[j].index] = $rootScope.displayIndicatorValue(data[i][headers[j].index], obj.type, obj.fo, obj.vp, obj.display);
            cov_24f1td4mjl.s[171]++;
            headers[j].checked = true;
          }
        }

        cov_24f1td4mjl.s[172]++;
        $scope.indicateurDashbord.headers = headers.filter(function (header) {
          cov_24f1td4mjl.f[20]++;
          cov_24f1td4mjl.s[173]++;

          return header.checked;
        });

        cov_24f1td4mjl.s[174]++;
        $scope.indicateurDashbord.tableParams = {
          columns: [{ field: 'lo', headerText: $translate.instant('INDICATOR.GLOBAL.LOCATION'), width: 150 }].concat([canDisplay ? (cov_24f1td4mjl.b[38][0]++, { field: 'b', headerText: $translate.instant('INDICATOR.GLOBAL.REF'), width: 110 }) : (cov_24f1td4mjl.b[38][1]++, { field: 'b', headerText: $translate.instant('INDICATOR.GLOBAL.REF'), format: 'N', width: 110, type: 'number', textAlign: 'Right' })]).concat($scope.indicateurDashbord.headers.map(function (header) {
            cov_24f1td4mjl.f[21]++;
            cov_24f1td4mjl.s[175]++;

            return canDisplay ? (cov_24f1td4mjl.b[39][0]++, { field: header.index, headerText: header.label.replace(' - ', ' '), width: 85 }) : (cov_24f1td4mjl.b[39][1]++, { field: header.index, headerText: header.label.replace(' - ', ' '), format: 'N', width: 85, type: 'number', textAlign: 'Right' });
          })).concat([{ field: 'T', headerText: $translate.instant('DASHBOARD.REALIZE'), format: 'P', width: 110, type: 'number', textAlign: 'Right' }]).concat([canDisplay ? (cov_24f1td4mjl.b[40][0]++, { field: 'c', headerText: $translate.instant('DASHBOARD.END_VALUE'), width: 100 }) : (cov_24f1td4mjl.b[40][1]++, { field: 'c', headerText: $translate.instant('DASHBOARD.END_VALUE'), format: 'N', width: 100, type: 'number', textAlign: 'Right' })]).concat([{ field: 'df', headerText: $translate.instant('INDICATOR.GLOBAL.END'), format: { skeleton: 'medium', type: 'date' }, width: 120, textAlign: 'Center' }]),
          dataSources: data.filter(function (value) {
            cov_24f1td4mjl.f[22]++;
            cov_24f1td4mjl.s[176]++;

            return angular.isDefined(value.lo);
          })
        };

        cov_24f1td4mjl.s[177]++;
        $scope.indicateurDashbord.dataDetail = data;
        cov_24f1td4mjl.s[178]++;
        $scope.indicateurDashbord.drawGraphe();
      });
    },
    drawGraphe: function drawGraphe() {
      var color = (cov_24f1td4mjl.s[179]++, $rootScope.personalData);
      var valeurCible = (cov_24f1td4mjl.s[180]++, $scope.indicateurDashbord.selectedItem.vcN);
      var valeurRef = (cov_24f1td4mjl.s[181]++, $scope.indicateurDashbord.selectedItem.vrN);
      var format = (cov_24f1td4mjl.s[182]++, this.selectedItem.fo);
      var item = (cov_24f1td4mjl.s[183]++, {});
      cov_24f1td4mjl.s[184]++;
      item = angular.copy($filter('filter')(this.dataDetail, { lo: undefined }, true)[0]);
      cov_24f1td4mjl.s[185]++;
      if (!item) {
        cov_24f1td4mjl.b[41][0]++;
        cov_24f1td4mjl.s[186]++;

        return;
      } else {
        cov_24f1td4mjl.b[41][1]++;
      }
      var obj = (cov_24f1td4mjl.s[187]++, $scope.indicateurDashbord.selectedItem);
      cov_24f1td4mjl.s[188]++;
      for (var _iterator3 = this.headers, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
        var _ref3;

        if (_isArray3) {
          if (_i3 >= _iterator3.length) break;
          _ref3 = _iterator3[_i3++];
        } else {
          _i3 = _iterator3.next();
          if (_i3.done) break;
          _ref3 = _i3.value;
        }

        var el = _ref3;
        cov_24f1td4mjl.s[189]++;

        item[el.index] = $deltaNumber.formatNumber(item[el.index], null, format);
        cov_24f1td4mjl.s[190]++;
        item[el.label + 'L'] = $rootScope.displayIndicatorValue(item[el.index], obj.type, obj.fo, obj.vp, obj.display);
      }

      var params = (cov_24f1td4mjl.s[191]++, {
        locale: $LOGINService.getLang(),

        primaryXAxis: {
          interval: 1,
          labelIntersectAction: 'Rotate45',
          valueType: 'Category',
          majorGridLines: { width: 0 }, minorGridLines: { width: 0 },
          majorTickLines: { width: 0 }, minorTickLines: { width: 0 },
          lineStyle: { width: 0 },
          maximumLabelWidth: 100
        },
        primaryYAxis: {
          valueType: 'Double',
          lineStyle: { width: 0 },
          majorTickLines: { width: 0 }, majorGridLines: { width: 1 },
          minorGridLines: { width: 1 }, minorTickLines: { width: 0 },
          labelFormat: 'N' + this.selectedItem.fo
        },
        chartArea: {
          border: {
            width: 0
          }
        },
        useGroupingSeparator: true,

        series: [{
          type: 'Area',
          dataSource: [],
          xName: 'x', yName: 'y', name: $translate.instant('INDICATOR.REAL_VAL'),
          width: 2,
          fill: 'rgba(70, 182, 238, 0.39) ',
          marker: {
            visible: true,
            width: 10,
            height: 10
          }
        }],
        height: '400px',
        title: '',
        legendSettings: {
          visible: true
        },
        tooltip: { enable: true, shared: true, format: $translate.instant('INDICATOR.REAL_VAL') + ': <b>${point.customValue}<b>' },
        pointRender: function pointRender(args) {
          cov_24f1td4mjl.s[192]++;

          args.point.customValue = item[args.point.x + 'L'] + (obj.display === 'WEIGHT' ? (cov_24f1td4mjl.b[42][0]++, '') : (cov_24f1td4mjl.b[42][1]++, ' (' + args.point.y + ')'));
        }
      });

      cov_24f1td4mjl.s[193]++;
      localStorage.setItem(PROJECT_DASHBOARD_INDICATOR_PERIOD, this.period);

      cov_24f1td4mjl.s[194]++;
      item[$translate.instant('DASHBOARD.REFERENCE') + 'L'] = $rootScope.displayIndicatorValue(valeurRef, obj.type, obj.fo, obj.vp, obj.display);
      cov_24f1td4mjl.s[195]++;
      params.series[0].dataSource.push({
        x: $translate.instant('DASHBOARD.REFERENCE'),
        y: valeurRef,
        custom: item[$translate.instant('DASHBOARD.REFERENCE') + 'L']
      });
      cov_24f1td4mjl.s[196]++;
      for (var _iterator4 = this.headers, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
        var _ref4;

        if (_isArray4) {
          if (_i4 >= _iterator4.length) break;
          _ref4 = _iterator4[_i4++];
        } else {
          _i4 = _iterator4.next();
          if (_i4.done) break;
          _ref4 = _i4.value;
        }

        var _el = _ref4;
        cov_24f1td4mjl.s[197]++;

        params.series[0].dataSource.push({
          y: item[_el.index],
          x: _el.label,
          custom: item[_el.index + 'L']
        });
      }
      cov_24f1td4mjl.s[198]++;
      this.grapheDash = params;
    }
  };

  var graphe_repartition_default = (cov_24f1td4mjl.s[199]++, {
    locale: $LOGINService.getLang(),
    series: [{
      type: 'Pie', dataSource: [], xName: 'x', yName: 'y',
      dataLabel: { visible: true, position: 'Outside' },
      pointColorMapping: 'color'
    }], textRender: function textRender(args) {
      var value = (cov_24f1td4mjl.s[200]++, '<b>' + $filter('number')(args.point.y) + '</b>');
      var percentage = (cov_24f1td4mjl.s[201]++, '<b>' + Math.round(args.point.percentage) + '%</b>');
      cov_24f1td4mjl.s[202]++;
      args.point.customValue = args.point.x + '<br/><hr>';
      cov_24f1td4mjl.s[203]++;
      args.point.customValue = '' + args.point.x;
      cov_24f1td4mjl.s[204]++;
      args.point.customValue += '<br/>' + $translate.instant('DASHBOARD.ACTIVITY_COUNT', { value: value });
      cov_24f1td4mjl.s[205]++;
      args.point.customValue += '<br/>' + $translate.instant('DASHBOARD.PROJECT_ACTIVITY', { value: percentage });
      cov_24f1td4mjl.s[206]++;
      args.text = args.point.x + ' (' + args.point.y + ')';
    },

    legendSettings: { visible: false, position: 'Bottom' }, enableSmartLabels: true,
    title: $translate.instant('DASHBOARD.PHY'),
    height: '300px',

    tooltip: { enable: true, format: '${point.customValue}' }
  });
  cov_24f1td4mjl.s[207]++;
  $scope.activityDashboard = {
    yeargraph: null,
    graphe_evolution: {
      data: [], labels: [], options: {
        tooltips: {
          callbacks: {
            label: function label(tooltipItem, data) {
              cov_24f1td4mjl.s[208]++;

              return ' ' + data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel + '%';
            }
          }
        },
        scales: { yAxes: [{ ticks: { beginAtZero: true } }] },
        maintainAspectRatio: false,
        animation: {
          onComplete: function onComplete() {
            var ctx = (cov_24f1td4mjl.s[209]++, this.chart.ctx);
            cov_24f1td4mjl.s[210]++;
            ctx.textAlign = 'center';
            cov_24f1td4mjl.s[211]++;
            ctx.textBaseline = 'bottom';
            var dataset = (cov_24f1td4mjl.s[212]++, this.chart.config.data.datasets[1]);
            cov_24f1td4mjl.s[213]++;
            ctx.fillStyle = '#676a6c';
            cov_24f1td4mjl.s[214]++;
            for (var numdata in dataset._meta) {
              var oncompletdata = (cov_24f1td4mjl.s[215]++, dataset._meta[numdata]);
              cov_24f1td4mjl.s[216]++;
              oncompletdata.data.forEach(function (p) {
                cov_24f1td4mjl.f[23]++;
                cov_24f1td4mjl.s[217]++;

                ctx.fillText(p._chart.config.data.datasets[p._datasetIndex].data[p._index] + '%', p._model.x, p._model.y - 10);
              });
              cov_24f1td4mjl.s[218]++;
              break;
            }
          }
        },
        elements: {
          line: {
            cubicInterpolationMode: 'monotone',
            spanGaps: false,
            tension: 0
          }
        }
      },
      colors: ['rgba(' + $rootScope.personalData.activity.period.P + ',0.7)', 'rgba(' + $rootScope.personalData.activity.period.R + ',0.7)'],
      data_override: [{
        label: $translate.instant('ACTIVITY.DASHBOARD.RATE_PHY'), borderWidth: 1, type: 'bar'
      }, {
        label: $translate.instant('ACTIVITY.DASHBOARD.RATE_FINANC'), borderWidth: 3, type: 'line'
      }]
    },
    EvolutionActivite: function EvolutionActivite() {
      var color = (cov_24f1td4mjl.s[219]++, $rootScope.personalData);
      cov_24f1td4mjl.s[220]++;
      this.graphe_evolution.data = [[], []];
      cov_24f1td4mjl.s[221]++;
      this.graphe_evolution.labels = [];
      cov_24f1td4mjl.s[222]++;
      if (this.yeargraph == null) {
        cov_24f1td4mjl.b[43][0]++;
        cov_24f1td4mjl.s[223]++;

        for (var _iterator5 = $scope.listData_Periode_bksb, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
          var _ref5;

          if (_isArray5) {
            if (_i5 >= _iterator5.length) break;
            _ref5 = _iterator5[_i5++];
          } else {
            _i5 = _iterator5.next();
            if (_i5.done) break;
            _ref5 = _i5.value;
          }

          var per = _ref5;
          cov_24f1td4mjl.s[224]++;

          if (per.PTBA_PERIOD == 1) {
            cov_24f1td4mjl.b[44][0]++;
            cov_24f1td4mjl.s[225]++;

            this.yeargraph = per.ANNEE_PERIOD;
            cov_24f1td4mjl.s[226]++;
            break;
          } else {
            cov_24f1td4mjl.b[44][1]++;
          }
        }
        cov_24f1td4mjl.s[227]++;
        if (this.yeargraph == null) {
          cov_24f1td4mjl.b[45][0]++;
          cov_24f1td4mjl.s[228]++;

          this.yeargraph = Date.newDate().getFullYear();
        } else {
          cov_24f1td4mjl.b[45][1]++;
        }
      } else {
        cov_24f1td4mjl.b[43][1]++;
      }
      cov_24f1td4mjl.s[229]++;
      $scope.hasActivityEvolution = false;
      cov_24f1td4mjl.s[230]++;
      $scope.loadingActivityEvolution = true;
      cov_24f1td4mjl.s[231]++;
      $otherHttpService.get('Activites', { get: 'hometbEvol', year: this.yeargraph }, function (data) {
        cov_24f1td4mjl.f[24]++;
        cov_24f1td4mjl.s[232]++;

        $scope.loadingActivityEvolution = false;
        var params = (cov_24f1td4mjl.s[233]++, {
          locale: $LOGINService.getLang(),

          primaryXAxis: {
            interval: 1,
            labelIntersectAction: 'Rotate45',
            valueType: 'Category',
            majorGridLines: { width: 0 }, minorGridLines: { width: 0 },
            majorTickLines: { width: 0 }, minorTickLines: { width: 0 },
            lineStyle: { width: 0 },
            maximumLabelWidth: 100
          },
          primaryYAxis: {
            valueType: 'Double',
            lineStyle: { width: 0 },
            majorTickLines: { width: 0 }, majorGridLines: { width: 1 },
            minorGridLines: { width: 1 }, minorTickLines: { width: 0 },
            labelFormat: 'P'
          },
          chartArea: {
            border: {
              width: 0
            }
          },
          useGroupingSeparator: true,

          series: [{
            type: 'Column',
            dataSource: [],
            xName: 'x', yName: 'y', name: $translate.instant('DASHBOARD.PHY'),
            width: 3,
            fill: 'rgba(' + $rootScope.personalData.activity.period.P + ',0.7)'
          }, {
            type: 'Line',
            dataSource: [],
            xName: 'x', yName: 'y', name: $translate.instant('DASHBOARD.FIN'),
            width: 2,
            fill: 'rgba(' + $rootScope.personalData.activity.period.R + ',0.7)',
            marker: {
              visible: true,
              width: 10,
              height: 10
            }
          }],
          height: '300px',
          axisLabelRender: function axisLabelRender(args) {
            var _ = (cov_24f1td4mjl.s[234]++, args.text.split(':'));
            cov_24f1td4mjl.s[235]++;
            args.text = _[0].trim();
          },

          title: '',
          legendSettings: {
            visible: true
          },
          tooltip: { enable: true, shared: true }
        });

        cov_24f1td4mjl.s[236]++;
        $scope.activityDashboard.dateRefresh_evo = new Date();
        cov_24f1td4mjl.s[237]++;
        data = $filter('orderBy')(data, 'id');

        cov_24f1td4mjl.s[238]++;
        for (var j = 0; j < data.length; j++) {
          cov_24f1td4mjl.s[239]++;

          if (j == 0) {
            cov_24f1td4mjl.b[46][0]++;

            var tampon = (cov_24f1td4mjl.s[240]++, data[j].id.split('-'));
            cov_24f1td4mjl.s[241]++;
            $scope.yearPTBA = (cov_24f1td4mjl.b[47][0]++, tampon[0]) || (cov_24f1td4mjl.b[47][1]++, '');
          } else {
            cov_24f1td4mjl.b[46][1]++;
          }
          var label = (cov_24f1td4mjl.s[242]++, $deltadate.getLabelPerioddepth(data[j].num * 12 / ((cov_24f1td4mjl.b[48][0]++, data[j].d) || (cov_24f1td4mjl.b[48][1]++, 1)), 12));
          cov_24f1td4mjl.s[243]++;
          params.series[0].dataSource.push({
            x: label,
            y: data[j].tp ? (cov_24f1td4mjl.b[49][0]++, data[j].tp / 100) : (cov_24f1td4mjl.b[49][1]++, null)
          });
          cov_24f1td4mjl.s[244]++;
          params.series[1].dataSource.push({
            x: label,
            y: data[j].tf ? (cov_24f1td4mjl.b[50][0]++, data[j].tf / 100) : (cov_24f1td4mjl.b[50][1]++, null)
          });
          cov_24f1td4mjl.s[245]++;
          $scope.hasActivityEvolution = (cov_24f1td4mjl.b[51][0]++, data[j].tf > 0) || (cov_24f1td4mjl.b[51][1]++, data[j].tp) || (cov_24f1td4mjl.b[51][2]++, $scope.hasActivityEvolution);
        }
        cov_24f1td4mjl.s[246]++;
        $scope.activityDashboard.graphe_evolution = params;
      });
    },
    RepartionActivite: function RepartionActivite() {
      var _this2 = this;

      cov_24f1td4mjl.s[247]++;

      $scope.loadingActivities = true;
      cov_24f1td4mjl.s[248]++;
      this.graphe_repartition_physic = angular.copy(graphe_repartition_default);
      cov_24f1td4mjl.s[249]++;
      this.graphe_repartition_finance = angular.copy(graphe_repartition_default);
      cov_24f1td4mjl.s[250]++;
      this.graphe_repartition_finance.title = $translate.instant('DASHBOARD.FIN');
      cov_24f1td4mjl.s[251]++;
      $scope.hasActivityData = false;
      cov_24f1td4mjl.s[252]++;
      $otherHttpService.get('Activites', { get: 'hometb' }, function (data) {
        cov_24f1td4mjl.f[25]++;
        cov_24f1td4mjl.s[253]++;

        for (var _iterator6 = data, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
          var _ref6;

          if (_isArray6) {
            if (_i6 >= _iterator6.length) break;
            _ref6 = _iterator6[_i6++];
          } else {
            _i6 = _iterator6.next();
            if (_i6.done) break;
            _ref6 = _i6.value;
          }

          var item = _ref6;

          var tp = (cov_24f1td4mjl.s[254]++, {
            y: (cov_24f1td4mjl.b[52][0]++, item.tp) || (cov_24f1td4mjl.b[52][1]++, null),
            x: item.lib,
            min: item.min,
            max: item.max,
            color: 'rgb(' + item.idcol + ')'
          });
          cov_24f1td4mjl.s[255]++;
          if (tp.y !== null) {
            cov_24f1td4mjl.b[53][0]++;
            cov_24f1td4mjl.s[256]++;

            $scope.activityDashboard.graphe_repartition_physic.series[0].dataSource.push(tp);
          } else {
            cov_24f1td4mjl.b[53][1]++;
          }

          var tf = (cov_24f1td4mjl.s[257]++, {
            y: (cov_24f1td4mjl.b[54][0]++, item.tf) || (cov_24f1td4mjl.b[54][1]++, null),
            x: item.lib,
            min: item.min,
            max: item.max,
            color: 'rgb(' + item.idcol + ')'
          });
          cov_24f1td4mjl.s[258]++;
          if (tf.y !== null) {
            cov_24f1td4mjl.b[55][0]++;
            cov_24f1td4mjl.s[259]++;

            $scope.activityDashboard.graphe_repartition_finance.series[0].dataSource.push(tf);
          } else {
            cov_24f1td4mjl.b[55][1]++;
          }

          cov_24f1td4mjl.s[260]++;
          $scope.hasActivityData = (cov_24f1td4mjl.b[56][0]++, item.tp > 0) || (cov_24f1td4mjl.b[56][1]++, item.tf > 0) || (cov_24f1td4mjl.b[56][2]++, $scope.hasActivityData);
        }

        cov_24f1td4mjl.s[261]++;
        _this2.graphe_repartition_physic.textRender = function (args) {
          cov_24f1td4mjl.f[26]++;

          var item = (cov_24f1td4mjl.s[262]++, (cov_24f1td4mjl.b[57][0]++, data.find(function (v) {
            cov_24f1td4mjl.f[27]++;
            cov_24f1td4mjl.s[263]++;
            return v.lib == args.point.x;
          })) || (cov_24f1td4mjl.b[57][1]++, {}));
          cov_24f1td4mjl.s[264]++;
          args.point.customValue = args.point.x + '<br/><hr>';
          cov_24f1td4mjl.s[265]++;
          args.point.customValue += '<br/>' + $translate.instant('DASHBOARD.ACTIVITY_PROGRESS_LABEL', {
            percent: Math.round(args.point.percentage),
            count: args.point.y,
            min: item.min,
            max: item.max
          });
          cov_24f1td4mjl.s[266]++;
          args.text = args.point.x + ' (' + args.point.y + ')';
        };

        cov_24f1td4mjl.s[267]++;
        $scope.loadingActivities = false;
      });
    },
    init: function init() {
      cov_24f1td4mjl.s[268]++;

      this.EvolutionActivite();
      cov_24f1td4mjl.s[269]++;
      this.RepartionActivite();
    }
  };

  cov_24f1td4mjl.s[270]++;
  $scope.getAll = function () {
    cov_24f1td4mjl.f[28]++;
    cov_24f1td4mjl.s[271]++;

    $otherHttpService.get($scope.PATH, { get: 'all' }, function (data) {
      cov_24f1td4mjl.f[29]++;
      cov_24f1td4mjl.s[272]++;

      $scope.listProjects = data;
    });
  };
  cov_24f1td4mjl.s[273]++;
  $scope.indicateurDashbord.getSituationIndicateur();
  cov_24f1td4mjl.s[274]++;
  $scope.mapDashboard = {
    loadingItem: 0,
    listIndicators: [],
    selectIndicator: null,
    selectLevel: null,
    requestPanel: false,
    legendMap: defaultLegend,
    mymap: null,
    flags: [],
    legend: {
      grades: [],
      labels: []
    },
    changeMapView: function changeMapView(view) {
      cov_24f1td4mjl.s[275]++;

      this.mapView_ = view;
    },
    getColor: function getColor(d) {
      cov_24f1td4mjl.s[276]++;

      for (var i = $scope.mapDashboard.legendMap.length - 1; i >= 0; i--) {
        cov_24f1td4mjl.s[277]++;

        if (d > $scope.mapDashboard.legendMap[i].v) {
          cov_24f1td4mjl.b[58][0]++;
          cov_24f1td4mjl.s[278]++;

          return $scope.mapDashboard.legendMap[i].c;
        } else {
          cov_24f1td4mjl.b[58][1]++;
        }
      }
      cov_24f1td4mjl.s[279]++;
      return $scope.mapDashboard.legendMap[0].c;
    },
    initializeMap: function initializeMap() {
      var newHeight = (cov_24f1td4mjl.s[280]++, $('body').height());
      cov_24f1td4mjl.s[281]++;
      $('#mapid').height(newHeight - 350);

      var flags = (cov_24f1td4mjl.s[282]++, angular.copy($rootScope.getCurrentProject().project.getFlag()));
      cov_24f1td4mjl.s[283]++;
      for (var _iterator7 = flags, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;) {
        var _ref7;

        if (_isArray7) {
          if (_i7 >= _iterator7.length) break;
          _ref7 = _iterator7[_i7++];
        } else {
          _i7 = _iterator7.next();
          if (_i7.done) break;
          _ref7 = _i7.value;
        }

        var flag = _ref7;

        var colors = (cov_24f1td4mjl.s[284]++, flag.color.split(','));
        var temp = (cov_24f1td4mjl.s[285]++, []);
        cov_24f1td4mjl.s[286]++;
        for (var _iterator8 = colors, _isArray8 = Array.isArray(_iterator8), _i8 = 0, _iterator8 = _isArray8 ? _iterator8 : _iterator8[Symbol.iterator]();;) {
          var _ref8;

          if (_isArray8) {
            if (_i8 >= _iterator8.length) break;
            _ref8 = _iterator8[_i8++];
          } else {
            _i8 = _iterator8.next();
            if (_i8.done) break;
            _ref8 = _i8.value;
          }

          var part = _ref8;

          var l = (cov_24f1td4mjl.s[287]++, parseInt(part, 10).toString(16));
          cov_24f1td4mjl.s[288]++;
          temp.push((l.length == 1 ? (cov_24f1td4mjl.b[59][0]++, '0') : (cov_24f1td4mjl.b[59][1]++, '')) + l);
        }
        cov_24f1td4mjl.s[289]++;
        flag.color = '#' + temp.join('');
      }
      cov_24f1td4mjl.s[290]++;
      if (flags[0]) {
        cov_24f1td4mjl.b[60][0]++;
        cov_24f1td4mjl.s[291]++;

        flags[0].max = 999999999999;
      } else {
        cov_24f1td4mjl.b[60][1]++;
      }
      cov_24f1td4mjl.s[292]++;
      if (flags.length > 0) {
        cov_24f1td4mjl.b[61][0]++;
        cov_24f1td4mjl.s[293]++;

        flags[flags.length - 1].min = -1;
      } else {
        cov_24f1td4mjl.b[61][1]++;
      }

      cov_24f1td4mjl.s[294]++;
      this.flags = flags;

      cov_24f1td4mjl.s[295]++;
      if (this.mymap) {
        cov_24f1td4mjl.b[62][0]++;
        cov_24f1td4mjl.s[296]++;

        this.mymap.remove();
      } else {
        cov_24f1td4mjl.b[62][1]++;
      }
      cov_24f1td4mjl.s[297]++;
      this.mymap = L.map('mapid', {
        fullscreenControl: {
          title: {
            false: $translate.instant('COMMON.FULLSCREEN'),
            true: $translate.instant('COMMON.EXIT_FULLSCREEN')
          }
        }
      }).setView([16.82, 11.3], 5);
      cov_24f1td4mjl.s[298]++;
      $rootScope.getTileLayers(this.mymap, 'COMMON.GRAYSCALE');
      cov_24f1td4mjl.s[299]++;
      if (this.layerGroup) {
        cov_24f1td4mjl.b[63][0]++;
        cov_24f1td4mjl.s[300]++;

        this.layerGroup.clearLayers();
        cov_24f1td4mjl.s[301]++;
        this.layerGroup = null;
      } else {
        cov_24f1td4mjl.b[63][1]++;
      }
      cov_24f1td4mjl.s[302]++;
      this._getLayers();

      cov_24f1td4mjl.s[303]++;
      this.processIndicator();
    },
    _getLayers: function _getLayers() {
      cov_24f1td4mjl.s[304]++;

      if (!this.layerGroup) {
        cov_24f1td4mjl.b[64][0]++;
        cov_24f1td4mjl.s[305]++;

        this.layerGroup = L.layerGroup([], {
          attribution: '© <a href=\'https://www.mapbox.com/about/maps/\'>Mapbox</a> , © <a href=\'https://www.openstreetmap.org/copyright\'>OpenStreetMap</a>  <strong><a href=\'https://www.mapbox.com/map-feedback/\' target=\'_blank\'>Improve this map</a></strong>'
        });
        cov_24f1td4mjl.s[306]++;
        this.layerGroup.addTo(this.mymap);
      } else {
        cov_24f1td4mjl.b[64][1]++;
      }
      cov_24f1td4mjl.s[307]++;
      this.layerGroup.clearLayers();
    },
    getInformation: function getInformation() {
      cov_24f1td4mjl.s[308]++;

      $otherHttpService.get(PATH, { get: 'all_indic_search' }, function (data) {
        cov_24f1td4mjl.f[30]++;
        cov_24f1td4mjl.s[309]++;

        $scope.mapDashboard.listIndicators = data.map(function (indic) {
          cov_24f1td4mjl.f[31]++;
          cov_24f1td4mjl.s[310]++;

          indic.imageUrl = $deltahttp.getIndicatorRespositoy(indic.id);
          cov_24f1td4mjl.s[311]++;
          return indic;
        });
        cov_24f1td4mjl.s[312]++;
        $scope.mapDashboard.selectIndicator = data[0];
        cov_24f1td4mjl.s[313]++;
        $scope.mapDashboard.changeIndicator();
      });
    },
    changeLevel: function changeLevel() {
      var find = (cov_24f1td4mjl.s[314]++, false);
      cov_24f1td4mjl.s[315]++;
      for (var _iterator9 = $scope.mapDashboard.listgeo, _isArray9 = Array.isArray(_iterator9), _i9 = 0, _iterator9 = _isArray9 ? _iterator9 : _iterator9[Symbol.iterator]();;) {
        var _ref9;

        if (_isArray9) {
          if (_i9 >= _iterator9.length) break;
          _ref9 = _iterator9[_i9++];
        } else {
          _i9 = _iterator9.next();
          if (_i9.done) break;
          _ref9 = _i9.value;
        }

        var item = _ref9;
        cov_24f1td4mjl.s[316]++;

        if (item.NIVEAU_NG - 1 == $scope.mapDashboard.selectLevel.NIVEAU_NG) {
          cov_24f1td4mjl.b[65][0]++;
          cov_24f1td4mjl.s[317]++;

          $scope.mapDashboard.selectLevel = item;
          cov_24f1td4mjl.s[318]++;
          find = true;
          cov_24f1td4mjl.s[319]++;
          break;
        } else {
          cov_24f1td4mjl.b[65][1]++;
        }
      }
      cov_24f1td4mjl.s[320]++;
      if (find) {
        cov_24f1td4mjl.b[66][0]++;
        cov_24f1td4mjl.s[321]++;

        this.processIndicator();
      } else {
        cov_24f1td4mjl.b[66][1]++;
      }
    },
    changeIndicator: function changeIndicator() {
      cov_24f1td4mjl.s[322]++;

      if ($scope.mapDashboard.selectIndicator) {
        cov_24f1td4mjl.b[67][0]++;
        cov_24f1td4mjl.s[323]++;

        $scope.mapDashboard.listgeo = $scope.listData_GeoLevels_bksb.filter(function (value) {
          cov_24f1td4mjl.f[32]++;
          cov_24f1td4mjl.s[324]++;

          return value.id <= $scope.mapDashboard.selectIndicator.ng;
        });
        cov_24f1td4mjl.s[325]++;
        $scope.mapDashboard.selectLevel = $scope.mapDashboard.listgeo[$scope.mapDashboard.listgeo.length - 1];
      } else {
        cov_24f1td4mjl.b[67][1]++;
      }

      cov_24f1td4mjl.s[326]++;
      this.processIndicator();
    },
    processIndicator: function processIndicator() {
      cov_24f1td4mjl.s[327]++;

      if ((cov_24f1td4mjl.b[69][0]++, !this.selectIndicator) || (cov_24f1td4mjl.b[69][1]++, !this.selectLevel)) {
        cov_24f1td4mjl.b[68][0]++;
        cov_24f1td4mjl.s[328]++;

        return;
      } else {
        cov_24f1td4mjl.b[68][1]++;
      }
      cov_24f1td4mjl.s[329]++;
      this.legendMap = (cov_24f1td4mjl.b[70][0]++, $scope.mapDashboard.selectIndicator.legend) || (cov_24f1td4mjl.b[70][1]++, defaultLegend);
      cov_24f1td4mjl.s[330]++;
      this.loadingItem = 0;
      cov_24f1td4mjl.s[331]++;

      if (!this.layerGroup) {
        cov_24f1td4mjl.b[71][0]++;
        cov_24f1td4mjl.s[332]++;

        return;
      } else {
        cov_24f1td4mjl.b[71][1]++;
      }
      cov_24f1td4mjl.s[333]++;
      this.layerGroup.clearLayers();

      var mapstr = (cov_24f1td4mjl.s[334]++, 'https://api.mapbox.com/styles/v1/bksb/cjnem4vy029oz2sphj8jvnp9a/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiYmtzYiIsImEiOiJjaXQ5ZHlpM2gwMDJvMnNwaDAxZXFsbndrIn0.0W3tcj-HtlRSCJDcuxNRew');
      cov_24f1td4mjl.s[335]++;
      L.tileLayer(mapstr).addTo(this.layerGroup);
      var params = (cov_24f1td4mjl.s[336]++, {
        CODE_NG: this.selectLevel.id,
        ID_INDIC: this.selectIndicator.id,
        get: 'suivi_n_g',
        valid: 0
      });
      cov_24f1td4mjl.s[337]++;
      $scope.limitMap = [{ lat: 90, lon: 180 }, { lat: -90, lon: -180 }];
      cov_24f1td4mjl.s[338]++;
      $otherHttpService.get(PATH_DEC, params, function (data) {
        cov_24f1td4mjl.f[33]++;

        var maxValue = (cov_24f1td4mjl.s[339]++, 0);
        cov_24f1td4mjl.s[340]++;
        for (var _iterator10 = data, _isArray10 = Array.isArray(_iterator10), _i10 = 0, _iterator10 = _isArray10 ? _iterator10 : _iterator10[Symbol.iterator]();;) {
          var _ref10;

          if (_isArray10) {
            if (_i10 >= _iterator10.length) break;
            _ref10 = _iterator10[_i10++];
          } else {
            _i10 = _iterator10.next();
            if (_i10.done) break;
            _ref10 = _i10.value;
          }

          var item = _ref10;
          cov_24f1td4mjl.s[341]++;

          if ((cov_24f1td4mjl.b[73][0]++, item.osm_id == -1) || (cov_24f1td4mjl.b[73][1]++, item.osm_id == null)) {
            cov_24f1td4mjl.b[72][0]++;
            cov_24f1td4mjl.s[342]++;

            item.vr = null;
            cov_24f1td4mjl.s[343]++;
            continue;
          } else {
            cov_24f1td4mjl.b[72][1]++;
          }
          var rate = (cov_24f1td4mjl.s[344]++, $deltaNumber.formatNumber(item.vr, null));

          cov_24f1td4mjl.s[345]++;
          item.vr = rate;
          cov_24f1td4mjl.s[346]++;
          if (angular.isNumber(rate)) {
            cov_24f1td4mjl.b[74][0]++;
            cov_24f1td4mjl.s[347]++;

            maxValue = maxValue > rate ? (cov_24f1td4mjl.b[75][0]++, maxValue) : (cov_24f1td4mjl.b[75][1]++, rate);
          } else {
            cov_24f1td4mjl.b[74][1]++;
          }
        }
        cov_24f1td4mjl.s[348]++;

        if ($scope.mapDashboard.legendControl) {
          cov_24f1td4mjl.b[76][0]++;
          cov_24f1td4mjl.s[349]++;

          $scope.mapDashboard.legendControl.remove();
        } else {
          cov_24f1td4mjl.b[76][1]++;
        }
        cov_24f1td4mjl.s[350]++;
        $scope.mapDashboard.legendControl = L.control({ position: 'bottomright' });
        cov_24f1td4mjl.s[351]++;
        $scope.mapDashboard.legendControl.onAdd = function (map) {
          cov_24f1td4mjl.f[34]++;

          var div = (cov_24f1td4mjl.s[352]++, L.DomUtil.create('div', 'info legend'));
          cov_24f1td4mjl.s[353]++;

          for (var i = 0; i < $scope.mapDashboard.legendMap.length; i++) {
            cov_24f1td4mjl.s[354]++;

            div.innerHTML += '<i style="background:' + $scope.mapDashboard.legendMap[i].c + '"></i> ' + $filter('number')($scope.mapDashboard.legendMap[i].v) + ($scope.mapDashboard.legendMap[i + 1] ? (cov_24f1td4mjl.b[77][0]++, ' &ndash; ' + $filter('number')($scope.mapDashboard.legendMap[i + 1].v)) : (cov_24f1td4mjl.b[77][1]++, ' +')) + ($scope.mapDashboard.legendMap[i].l ? (cov_24f1td4mjl.b[78][0]++, ' <smal style="font-weight: normal; font-size: 10px" >(' + $scope.mapDashboard.legendMap[i].l + ')</smal>') : (cov_24f1td4mjl.b[78][1]++, '')) + '<br>';
          }
          cov_24f1td4mjl.s[355]++;
          return div;
        };
        cov_24f1td4mjl.s[356]++;
        $scope.mapDashboard.legendControl.addTo($scope.mapDashboard.mymap);
      });
    }
  };
  cov_24f1td4mjl.s[357]++;
  $scope.mapDashboard.getInformation();

  cov_24f1td4mjl.s[358]++;
  $deltaPeriode.addController($scope, function () {
    cov_24f1td4mjl.f[35]++;
    cov_24f1td4mjl.s[359]++;

    $scope.activityDashboard.init();
  });
  cov_24f1td4mjl.s[360]++;
  $deltaGeoLevel.addController($scope, function () {
    cov_24f1td4mjl.f[36]++;
    cov_24f1td4mjl.s[361]++;

    $scope.mapDashboard.changeIndicator();
  });

  cov_24f1td4mjl.s[362]++;
  $scope.processLocality = function () {
    cov_24f1td4mjl.f[37]++;
  };

  cov_24f1td4mjl.s[363]++;
  $scope.processLocality();
  cov_24f1td4mjl.s[364]++;
  $scope.data_main = [{ id: 0, display: true,
    TITLE: $translate.instant($rootScope.currentProject.project.PORTFOLIO == 0 ? (cov_24f1td4mjl.b[79][0]++, 'DASHBOARD.TITLE') : (cov_24f1td4mjl.b[79][1]++, 'DASHBOARD.TITLE_PORTFOLIO'), { code: $rootScope.currentProject.project.CODE_PRJ }),
    title_: $rootScope.currentProject.project.PORTFOLIO == 0 ? (cov_24f1td4mjl.b[80][0]++, 'DASHBOARD.TITLE') : (cov_24f1td4mjl.b[80][1]++, 'DASHBOARD.TITLE_PORTFOLIO'),
    def: true
  }, { id: -6, display: false, TITLE: $translate.instant('DASHBOARD.PROGRESS_REPORT'), title_: 'DASHBOARD.PROGRESS_REPORT', def: true }, { id: -4, display: false, TITLE: $translate.instant('DASHBOARD.ACTIVITY', { activity: $rootScope.currentProject.lastLogLevel }), title_: 'DASHBOARD.ACTIVITY', def: true }, { id: -5, display: false, TITLE: $translate.instant('DASHBOARD.INDICATOR'), title_: 'DASHBOARD.INDICATOR', def: true }, { id: -1, display: false, TITLE: $translate.instant('DASHBOARD.MAP'), title_: 'DASHBOARD.MAP', def: true }];
  cov_24f1td4mjl.s[365]++;
  $scope.dataIndicateur = [];
  cov_24f1td4mjl.s[366]++;
  $scope.selectedDashboard = $scope.data_main[0];

  cov_24f1td4mjl.s[367]++;
  for (var _iterator11 = $scope.data_main, _isArray11 = Array.isArray(_iterator11), _i11 = 0, _iterator11 = _isArray11 ? _iterator11 : _iterator11[Symbol.iterator]();;) {
    var _ref11;

    if (_isArray11) {
      if (_i11 >= _iterator11.length) break;
      _ref11 = _iterator11[_i11++];
    } else {
      _i11 = _iterator11.next();
      if (_i11.done) break;
      _ref11 = _i11.value;
    }

    var it = _ref11;
    cov_24f1td4mjl.s[368]++;

    if (it.id == $stateParams.view) {
      cov_24f1td4mjl.b[81][0]++;
      cov_24f1td4mjl.s[369]++;

      $scope.selectedDashboard = it;
      cov_24f1td4mjl.s[370]++;
      break;
    } else {
      cov_24f1td4mjl.b[81][1]++;
    }
  }

  cov_24f1td4mjl.s[371]++;
  $otherHttpService.get('DashboardUser', { get: 'all_main', simple: 1 }, function (data) {
    cov_24f1td4mjl.f[38]++;

    var _id = (cov_24f1td4mjl.s[372]++, (cov_24f1td4mjl.b[82][0]++, $stateParams.view) || (cov_24f1td4mjl.b[82][1]++, 0));cov_24f1td4mjl.s[373]++;

    if ($rootScope.currentProject.project.PORTFOLIO == 0) {
      cov_24f1td4mjl.b[83][0]++;
      cov_24f1td4mjl.s[374]++;

      if (data.includes('Stack trace')) {
        cov_24f1td4mjl.b[84][0]++;
      } else {
        cov_24f1td4mjl.b[84][1]++;
        cov_24f1td4mjl.s[375]++;

        $scope.data_main = $scope.data_main.concat(data);
      }
    } else {
      cov_24f1td4mjl.b[83][1]++;
    }

    var items = (cov_24f1td4mjl.s[376]++, angular.fromJson((cov_24f1td4mjl.b[85][0]++, localStorage.getItem('TAB_PROJECT_MENU_' + $rootScope.currentProject.project.id)) || (cov_24f1td4mjl.b[85][1]++, '[]')));

    cov_24f1td4mjl.s[377]++;
    $scope.availableDashboardList = $scope.data_main.filter(function (it) {
      cov_24f1td4mjl.f[39]++;
      cov_24f1td4mjl.s[378]++;

      return items.indexOf(it.id) >= 0;
    });
    cov_24f1td4mjl.s[379]++;
    $scope.data_main = $scope.data_main.map(function (item) {
      cov_24f1td4mjl.f[40]++;
      cov_24f1td4mjl.s[380]++;

      for (var _iterator12 = $scope.availableDashboardList, _isArray12 = Array.isArray(_iterator12), _i12 = 0, _iterator12 = _isArray12 ? _iterator12 : _iterator12[Symbol.iterator]();;) {
        var _ref12;

        if (_isArray12) {
          if (_i12 >= _iterator12.length) break;
          _ref12 = _iterator12[_i12++];
        } else {
          _i12 = _iterator12.next();
          if (_i12.done) break;
          _ref12 = _i12.value;
        }

        var it = _ref12;
        cov_24f1td4mjl.s[381]++;

        if (it.id == item.id) {
          cov_24f1td4mjl.b[86][0]++;
          cov_24f1td4mjl.s[382]++;

          item.display = true;
          cov_24f1td4mjl.s[383]++;
          break;
        } else {
          cov_24f1td4mjl.b[86][1]++;
        }
      }
      cov_24f1td4mjl.s[384]++;
      return item;
    });

    cov_24f1td4mjl.s[385]++;
    $CRUDService.getAll('Indicateurs', { get: 'all_favoris' }, function (data) {
      cov_24f1td4mjl.f[41]++;
      cov_24f1td4mjl.s[386]++;

      $scope.dataIndicateur = data;
      cov_24f1td4mjl.s[387]++;
      if (data.length > 0) {
        cov_24f1td4mjl.b[87][0]++;
      } else {
        cov_24f1td4mjl.b[87][1]++;
      }
    });
  });

  cov_24f1td4mjl.s[388]++;
  $scope.openOverview = function (item) {
    cov_24f1td4mjl.f[42]++;
    cov_24f1td4mjl.s[389]++;

    $CRUDService.getAll('Indicateurs', { get: 'all', idcl: item.CODE_CL, id: item.id, page: 1, nr: true, cat: true }, function (data) {
      cov_24f1td4mjl.f[43]++;
      cov_24f1td4mjl.s[390]++;

      $scope.loading = false;
      cov_24f1td4mjl.s[391]++;
      if (data.length > 0) {
        cov_24f1td4mjl.b[88][0]++;
        cov_24f1td4mjl.s[392]++;

        $state.go('indicator.overview.dashboard', { indicator: data[0], idcl: item.CODE_CL, id: item.id, dashboard: true });
      } else {
        cov_24f1td4mjl.b[88][1]++;
      }
    });
  };
  cov_24f1td4mjl.s[393]++;
  $scope.getFinancial();

  cov_24f1td4mjl.s[394]++;
  $scope.activities = {
    listActivities: [],
    getAll: function getAll() {
      cov_24f1td4mjl.s[395]++;

      $CRUDService.getAll('Activites', { get: 'all_favoris' }, function (data) {
        cov_24f1td4mjl.f[44]++;
        cov_24f1td4mjl.s[396]++;

        for (var _iterator13 = data, _isArray13 = Array.isArray(_iterator13), _i13 = 0, _iterator13 = _isArray13 ? _iterator13 : _iterator13[Symbol.iterator]();;) {
          var _ref13;

          if (_isArray13) {
            if (_i13 >= _iterator13.length) break;
            _ref13 = _iterator13[_i13++];
          } else {
            _i13 = _iterator13.next();
            if (_i13.done) break;
            _ref13 = _i13.value;
          }

          var el = _ref13;
          cov_24f1td4mjl.s[397]++;

          if (el.ID_UNITE < 1) {
            cov_24f1td4mjl.b[89][0]++;
            cov_24f1td4mjl.s[398]++;

            continue;
          } else {
            cov_24f1td4mjl.b[89][1]++;
          }
          cov_24f1td4mjl.s[399]++;
          el.DATE_DEMARRAGE = Date.newDate(el.DATE_DEMARRAGE);
          cov_24f1td4mjl.s[400]++;
          el.DATE_FIN_ACT = Date.newDate(el.DATE_FIN_ACT);
        }
        cov_24f1td4mjl.s[401]++;
        $scope.activities.listActivities = $scope.activities.listActivities.concat(data).sort(function (valueA, valueB) {
          cov_24f1td4mjl.f[45]++;
          cov_24f1td4mjl.s[402]++;

          if (((cov_24f1td4mjl.b[91][0]++, valueA.CODE_CLC) || (cov_24f1td4mjl.b[91][1]++, '')).toUpperCase() > ((cov_24f1td4mjl.b[92][0]++, valueB.CODE_CLC) || (cov_24f1td4mjl.b[92][1]++, '')).toUpperCase()) {
            cov_24f1td4mjl.b[90][0]++;
            cov_24f1td4mjl.s[403]++;

            return 1;
          } else {
            cov_24f1td4mjl.b[90][1]++;
          }
          cov_24f1td4mjl.s[404]++;
          if (((cov_24f1td4mjl.b[94][0]++, valueB.CODE_CLC) || (cov_24f1td4mjl.b[94][1]++, '')).toUpperCase() > ((cov_24f1td4mjl.b[95][0]++, valueA.CODE_CLC) || (cov_24f1td4mjl.b[95][1]++, '')).toUpperCase()) {
            cov_24f1td4mjl.b[93][0]++;
            cov_24f1td4mjl.s[405]++;

            return -1;
          } else {
            cov_24f1td4mjl.b[93][1]++;
          }
          cov_24f1td4mjl.s[406]++;
          return 0;
        });
      });
    }
  };

  cov_24f1td4mjl.s[407]++;
  $scope.indicators = {
    listIndicators: [],
    openOverview: function openOverview(item) {
      cov_24f1td4mjl.s[408]++;

      $CRUDService.getAll('Indicateurs', { get: 'all', idcl: item.CODE_CL, idp: item.ID_PROJET, id: item.id, page: 1, nr: true, cat: true }, function (data) {
        cov_24f1td4mjl.f[46]++;
        cov_24f1td4mjl.s[409]++;

        if (data.length > 0) {
          cov_24f1td4mjl.b[96][0]++;
          cov_24f1td4mjl.s[410]++;

          $state.go('indicator.overview.settings', { indicator: data[0], idcl: item.CODE_CL, id: item.id });
        } else {
          cov_24f1td4mjl.b[96][1]++;
        }
      });
    },
    getAll: function getAll() {
      cov_24f1td4mjl.s[411]++;

      $CRUDService.getAll('Indicateurs', { get: 'all_favoris' }, function (data) {
        cov_24f1td4mjl.f[47]++;
        cov_24f1td4mjl.s[412]++;

        for (var i = 0; i < data.length; i++) {
          cov_24f1td4mjl.s[413]++;

          data[i].DEB_EVAL_INDIC = Date.newDate(data[i].DEB_EVAL_INDIC);
          cov_24f1td4mjl.s[414]++;
          data[i].FIN_EVAL_INDIC = Date.newDate(data[i].FIN_EVAL_INDIC);
        }
        cov_24f1td4mjl.s[415]++;
        $scope.indicators.listIndicators = data.map(function (indic) {
          cov_24f1td4mjl.f[48]++;
          cov_24f1td4mjl.s[416]++;

          indic.imageUrl = $deltahttp.getIndicatorRespositoy(indic.id);
          cov_24f1td4mjl.s[417]++;
          return indic;
        });
      });
    }
  };

  cov_24f1td4mjl.s[418]++;

  $scope.view_conversation = true;
  cov_24f1td4mjl.s[419]++;
  $rootScope.COMMENTS_HISTORY = {
    ID_PARENT: project.project.id,
    TYPE: 1
  };

  cov_24f1td4mjl.s[420]++;
  $scope.viewChat = function () {
    cov_24f1td4mjl.f[49]++;
    cov_24f1td4mjl.s[421]++;

    $scope.view_conversation = !$scope.view_conversation;
  };
  cov_24f1td4mjl.s[422]++;

  $scope.report = {
    last_update: '0000-00-00',
    update_by: {
      id: 0,
      name: ''
    },
    displayValue: '',
    tmpValue: '',
    options_summernote: {
      focus: false,
      airMode: false,
      toolbar: [['edit', ['undo', 'redo']], ['headline', ['style']], ['style', ['bold', 'italic', 'underline', 'superscript', 'subscript', 'strikethrough', 'clear']], ['fontface', ['fontname']], ['textsize', ['fontsize']], ['fontclr', ['color']], ['alignment', ['ul', 'ol', 'paragraph', 'lineheight']], ['height', ['height']], ['table', ['table']], ['insert', ['link', 'picture', 'video', 'hr']], ['help', ['help']]]
    },
    editable: false,
    canUpdate: $rootScope.currentRight.u,
    adapteHeight: function adapteHeight() {},
    edit: function edit() {
      var newHeight = (cov_24f1td4mjl.s[423]++, $('#report_progress').height());
      cov_24f1td4mjl.s[424]++;
      this.options_summernote.height = newHeight - 100;
      cov_24f1td4mjl.s[425]++;
      this.tmpValue = this.value;
      cov_24f1td4mjl.s[426]++;
      this.editable = true;
    },
    cancel: function cancel() {
      cov_24f1td4mjl.s[427]++;

      this.tmpValue = '';
      cov_24f1td4mjl.s[428]++;
      this.editable = false;
      cov_24f1td4mjl.s[429]++;
      this.getData();
    },
    getData: function getData() {
      cov_24f1td4mjl.s[430]++;

      $CRUDService.getAll($scope.PATH, { get: 'project_progress' }, function (data) {
        cov_24f1td4mjl.f[50]++;
        cov_24f1td4mjl.s[431]++;

        $scope.report.displayValue = $sce.trustAsHtml(data.text);
        cov_24f1td4mjl.s[432]++;
        $scope.report.value = data.text;
        cov_24f1td4mjl.s[433]++;
        $scope.report.last_update = data.update;
        cov_24f1td4mjl.s[434]++;
        $scope.report.update_by.id = data.user.id;
        cov_24f1td4mjl.s[435]++;
        $scope.report.update_by.name = data.user.name;
      });
    },
    saveData: function saveData() {
      var _this3 = this;

      cov_24f1td4mjl.s[436]++;

      this.value = this.tmpValue;
      cov_24f1td4mjl.s[437]++;
      this.displayValue = $sce.trustAsHtml(this.tmpValue);
      cov_24f1td4mjl.s[438]++;
      $CRUDService.save($scope.PATH, { action: 'project_progress', value: this.value }, function () {
        cov_24f1td4mjl.f[51]++;
        cov_24f1td4mjl.s[439]++;

        _this3.cancel();
      });
    }
  };
  cov_24f1td4mjl.s[440]++;
  $scope.report.getData();
  cov_24f1td4mjl.s[441]++;
  $scope.activities.getAll();
  cov_24f1td4mjl.s[442]++;
  $scope.indicators.getAll();
  cov_24f1td4mjl.s[443]++;
  $scope.date_update = new Date().getTime();

  var uploader = (cov_24f1td4mjl.s[444]++, $scope.uploader = new FileUploader({
    url: $CRUDService.getServerAdress() + 'web_server.php?action=img&method=1&' + $CRUDService.getComplement() + '&li_bksb=Projet',
    headers: $CRUDService.getHeader(),
    alias: 'fileformatrapp',
    removeAfterUpload: true
  }));

  cov_24f1td4mjl.s[445]++;
  uploader.onAfterAddingFile = function (fileItem, a, b, c, d, e) {
    cov_24f1td4mjl.f[52]++;
    cov_24f1td4mjl.s[446]++;

    fileItem.url = uploader.url + '&id=' + fileItem.p;
    cov_24f1td4mjl.s[447]++;
    $scope.isloading = true;
    cov_24f1td4mjl.s[448]++;
    fileItem.upload();
  };

  cov_24f1td4mjl.s[449]++;
  uploader.onSuccessItem = function (fileItem, response, status, headers) {
    cov_24f1td4mjl.f[53]++;
    cov_24f1td4mjl.s[450]++;

    $scope.date_update = new Date().getTime();
    cov_24f1td4mjl.s[451]++;
    $scope.isloading = false;
  };

  cov_24f1td4mjl.s[452]++;
  $scope.analyseMap = {
    toggleLayer: function toggleLayer(request) {
      cov_24f1td4mjl.s[453]++;

      if (!$scope.analyseMap.requestLayers[request.id]) {
        cov_24f1td4mjl.b[97][0]++;
        cov_24f1td4mjl.s[454]++;

        return;
      } else {
        cov_24f1td4mjl.b[97][1]++;
      }
      cov_24f1td4mjl.s[455]++;
      if (request.display__) {
        cov_24f1td4mjl.b[98][0]++;
        cov_24f1td4mjl.s[456]++;

        $scope.analyseMap.requestLayers[request.id].addTo($scope.layerGroup);
      } else {
        cov_24f1td4mjl.b[98][1]++;
        cov_24f1td4mjl.s[457]++;

        $scope.layerGroup.removeLayer($scope.analyseMap.requestLayers[request.id]);
      }
    },
    getMapUrl: function getMapUrl(value) {
      var mapstr = (cov_24f1td4mjl.s[458]++, 'https://api.mapbox.com/styles/v1/bksb/cjnem4vy029oz2sphj8jvnp9a/tiles/256/{z}/{x}/{y}');
      cov_24f1td4mjl.s[459]++;
      switch (value) {
        case 0:
          cov_24f1td4mjl.b[99][0]++;
          cov_24f1td4mjl.s[460]++;

          mapstr = 'https://api.mapbox.com/styles/v1/bksb/cjnem4vy029oz2sphj8jvnp9a/tiles/256/{z}/{x}/{y}';
          cov_24f1td4mjl.s[461]++;
          break;
        case 1:
          cov_24f1td4mjl.b[99][1]++;
          cov_24f1td4mjl.s[462]++;

          mapstr = 'https://api.mapbox.com/styles/v1/bksb/cjvs9jqk60fr91cscf0w98zth/tiles/256/{z}/{x}/{y}@2x';
          cov_24f1td4mjl.s[463]++;
          break;
        case 2:
          cov_24f1td4mjl.b[99][2]++;
          cov_24f1td4mjl.s[464]++;

          mapstr = 'https://api.mapbox.com/styles/v1/bksb/cjvsbh28818ic1cmqcfaz1is2/tiles/256/{z}/{x}/{y}@2x';
          cov_24f1td4mjl.s[465]++;
          break;
        case 3:
          cov_24f1td4mjl.b[99][3]++;
          cov_24f1td4mjl.s[466]++;

          mapstr = 'https://api.mapbox.com/styles/v1/bksb/cjvsbjkcx0mkz1cp3ot9cdfnk/tiles/256/{z}/{x}/{y}@2x';
          cov_24f1td4mjl.s[467]++;
          break;
        case 4:
          cov_24f1td4mjl.b[99][4]++;
          cov_24f1td4mjl.s[468]++;

          mapstr = 'https://api.mapbox.com/styles/v1/bksb/ck0wcr1og05gz1cq7ik9y0ct5/tiles/256/{z}/{x}/{y}@2x';
          cov_24f1td4mjl.s[469]++;
          break;
        default:
          cov_24f1td4mjl.b[99][5]++;
          cov_24f1td4mjl.s[470]++;

          mapstr = 'https://api.mapbox.com/styles/v1/bksb/cj8x1v3iv05pz2rrtc9ps1tui/tiles/256/{z}/{x}/{y}';
          cov_24f1td4mjl.s[471]++;
          break;
      }
      cov_24f1td4mjl.s[472]++;
      return mapstr + '?access_token=pk.eyJ1IjoiYmtzYiIsImEiOiJjaXQ5ZHlpM2gwMDJvMnNwaDAxZXFsbndrIn0.0W3tcj-HtlRSCJDcuxNRew';
    },
    drawLayers: function drawLayers(request) {
      var pathMarker = (cov_24f1td4mjl.s[473]++, $deltahttp.getAnalysePinRepository(request.id));
      var params = (cov_24f1td4mjl.s[474]++, { get: 'all_r_simple_table', withData: 1, id: request.ID, id_request: request.id, export: 1 });
      cov_24f1td4mjl.s[475]++;
      $CRUDService.getAll(PATH_FORMULAR, params, function (data) {
        cov_24f1td4mjl.f[54]++;
        cov_24f1td4mjl.s[476]++;

        $scope.analyseMap.loading[request.id] = false;
        var count = (cov_24f1td4mjl.s[477]++, 0);
        var center = (cov_24f1td4mjl.s[478]++, [0, 0]);


        var mask = (cov_24f1td4mjl.s[479]++, '');

        cov_24f1td4mjl.s[480]++;
        for (var _iterator14 = data.rows, _isArray14 = Array.isArray(_iterator14), _i14 = 0, _iterator14 = _isArray14 ? _iterator14 : _iterator14[Symbol.iterator]();;) {
          var _ref14;

          if (_isArray14) {
            if (_i14 >= _iterator14.length) break;
            _ref14 = _iterator14[_i14++];
          } else {
            _i14 = _iterator14.next();
            if (_i14.done) break;
            _ref14 = _i14.value;
          }

          var item = _ref14;
          cov_24f1td4mjl.s[481]++;

          if (item.o) {
            cov_24f1td4mjl.b[100][0]++;
            cov_24f1td4mjl.s[482]++;

            continue;
          } else {
            cov_24f1td4mjl.b[100][1]++;
          }
          cov_24f1td4mjl.s[483]++;
          mask += '<p><b>' + item.caption + ': </b> ${' + item.name + '} </p>';
        }

        cov_24f1td4mjl.s[484]++;
        for (var _iterator15 = request.MAP, _isArray15 = Array.isArray(_iterator15), _i15 = 0, _iterator15 = _isArray15 ? _iterator15 : _iterator15[Symbol.iterator]();;) {
          var _ref15;

          if (_isArray15) {
            if (_i15 >= _iterator15.length) break;
            _ref15 = _iterator15[_i15++];
          } else {
            _i15 = _iterator15.next();
            if (_i15.done) break;
            _ref15 = _i15.value;
          }

          var layer = _ref15;

          var l = (cov_24f1td4mjl.s[485]++, L.layerGroup());
          cov_24f1td4mjl.s[486]++;
          l.addTo($scope.layerGroup);

          cov_24f1td4mjl.s[487]++;
          if (!layer.external) {
            cov_24f1td4mjl.b[101][0]++;
            cov_24f1td4mjl.s[488]++;

            var _loop = function _loop() {
              if (_isArray16) {
                if (_i16 >= _iterator16.length) return 'break';
                _ref16 = _iterator16[_i16++];
              } else {
                _i16 = _iterator16.next();
                if (_i16.done) return 'break';
                _ref16 = _i16.value;
              }

              var item = _ref16;
              cov_24f1td4mjl.s[489]++;

              try {
                var latlg = (cov_24f1td4mjl.s[490]++, angular.isString(item[layer.field]) ? (cov_24f1td4mjl.b[102][0]++, angular.fromJson(item[layer.field])) : (cov_24f1td4mjl.b[102][1]++, item[layer.field]));
                cov_24f1td4mjl.s[491]++;
                if (!angular.isArray(latlg)) {
                  cov_24f1td4mjl.b[103][0]++;
                  cov_24f1td4mjl.s[492]++;

                  return 'continue';
                } else {
                  cov_24f1td4mjl.b[103][1]++;
                }
                cov_24f1td4mjl.s[493]++;
                if (latlg.length < 2) {
                  cov_24f1td4mjl.b[104][0]++;
                  cov_24f1td4mjl.s[494]++;

                  return 'continue';
                } else {
                  cov_24f1td4mjl.b[104][1]++;
                }
                cov_24f1td4mjl.s[495]++;
                center[0] += latlg[0];
                cov_24f1td4mjl.s[496]++;
                center[1] += latlg[1];
                cov_24f1td4mjl.s[497]++;
                count++;
                cov_24f1td4mjl.s[498]++;
                L.marker(latlg, { icon: L.icon({
                    iconUrl: pathMarker,
                    iconSize: [24, 41],
                    shadowSize: [32, 32] }) }).addTo(l).on('click', function (a, b, c) {
                  cov_24f1td4mjl.f[55]++;

                  var label = (cov_24f1td4mjl.s[499]++, angular.copy(mask));
                  cov_24f1td4mjl.s[500]++;
                  for (var _iterator17 = data.rows, _isArray17 = Array.isArray(_iterator17), _i17 = 0, _iterator17 = _isArray17 ? _iterator17 : _iterator17[Symbol.iterator]();;) {
                    var _ref17;

                    if (_isArray17) {
                      if (_i17 >= _iterator17.length) break;
                      _ref17 = _iterator17[_i17++];
                    } else {
                      _i17 = _iterator17.next();
                      if (_i17.done) break;
                      _ref17 = _i17.value;
                    }

                    var item_s = _ref17;

                    var valueItem = (cov_24f1td4mjl.s[501]++, (cov_24f1td4mjl.b[105][0]++, item[item_s.name]) || (cov_24f1td4mjl.b[105][1]++, ''));
                    cov_24f1td4mjl.s[502]++;
                    if (valueItem) {
                      cov_24f1td4mjl.b[106][0]++;
                      cov_24f1td4mjl.s[503]++;

                      if (item_s.t == 3) {
                        cov_24f1td4mjl.b[107][0]++;
                        cov_24f1td4mjl.s[504]++;

                        valueItem = $filter('date')(valueItem, valueItem.f);
                      } else {
                        cov_24f1td4mjl.b[107][1]++;
                      }

                      cov_24f1td4mjl.s[505]++;
                      if (item_s.t == 4) {
                        cov_24f1td4mjl.b[108][0]++;
                        cov_24f1td4mjl.s[506]++;

                        valueItem = $filter('number')(valueItem, valueItem.f);
                      } else {
                        cov_24f1td4mjl.b[108][1]++;
                      }
                    } else {
                      cov_24f1td4mjl.b[106][1]++;
                    }
                    cov_24f1td4mjl.s[507]++;
                    label = label.replace('${' + item_s.name + '}', valueItem);
                  }
                  cov_24f1td4mjl.s[508]++;
                  L.popup().setLatLng(a.latlng).setContent(label).openOn($scope.mymap);
                });

                cov_24f1td4mjl.s[509]++;
                $scope.analyseMap.requestLayers[request.id] = l;
              } catch (ex) {}
            };

            _loop2: for (var _iterator16 = data.data, _isArray16 = Array.isArray(_iterator16), _i16 = 0, _iterator16 = _isArray16 ? _iterator16 : _iterator16[Symbol.iterator]();;) {
              var _ref16;

              var _ret = _loop();

              switch (_ret) {
                case 'break':
                  break _loop2;

                case 'continue':
                  continue;}
            }
          } else {
            cov_24f1td4mjl.b[101][1]++;
          }
        }

        cov_24f1td4mjl.s[510]++;
        if (count > 1) {
          cov_24f1td4mjl.b[109][0]++;
          cov_24f1td4mjl.s[511]++;

          center[0] /= count;
          cov_24f1td4mjl.s[512]++;
          center[1] /= count;
        } else {
          cov_24f1td4mjl.b[109][1]++;
        }
        cov_24f1td4mjl.s[513]++;
        $scope.mymap.setView(center);
      });
    },
    initialise: function initialise() {
      cov_24f1td4mjl.s[514]++;

      this.requestLayers = {};
      cov_24f1td4mjl.s[515]++;
      this.requests = [];
      cov_24f1td4mjl.s[516]++;
      this.loading = {};
      cov_24f1td4mjl.s[517]++;
      $CRUDService.getAll(PATH_FORMULAR, { get: 'all_map_request' }, function (data) {
        cov_24f1td4mjl.f[56]++;

        var grayscale = (cov_24f1td4mjl.s[518]++, L.tileLayer($scope.analyseMap.getMapUrl(1)));
        cov_24f1td4mjl.s[519]++;
        $scope.mymap = L.map('map_analyze', { fullscreenControl: {
            title: {
              false: $translate.instant('COMMON.FULLSCREEN'),
              true: $translate.instant('COMMON.EXIT_FULLSCREEN')
            }
          }, layers: [] }).setView([16.82, 11.3], 5);
        cov_24f1td4mjl.s[520]++;
        $scope.layerGroup = L.layerGroup([], {
          attribution: '© <a href=\'https://www.mapbox.com/about/maps/\'>Mapbox</a> , © <a href=\'https://www.openstreetmap.org/copyright\'>OpenStreetMap</a>  <strong><a href=\'https://www.mapbox.com/map-feedback/\' target=\'_blank\'>Improve this map</a></strong>'
        });
        cov_24f1td4mjl.s[521]++;
        $scope.layerGroup.addTo($scope.mymap);

        cov_24f1td4mjl.s[522]++;
        $scope.layerGroup.clearLayers();
        cov_24f1td4mjl.s[523]++;
        $scope.analyseMap.requests = data;
        cov_24f1td4mjl.s[524]++;

        $rootScope.getTileLayers($scope.mymap, 'COMMON.GRAYSCALE');

        cov_24f1td4mjl.s[525]++;
        for (var _iterator18 = $scope.analyseMap.requests, _isArray18 = Array.isArray(_iterator18), _i18 = 0, _iterator18 = _isArray18 ? _iterator18 : _iterator18[Symbol.iterator]();;) {
          var _ref18;

          if (_isArray18) {
            if (_i18 >= _iterator18.length) break;
            _ref18 = _iterator18[_i18++];
          } else {
            _i18 = _iterator18.next();
            if (_i18.done) break;
            _ref18 = _i18.value;
          }

          var request = _ref18;
          cov_24f1td4mjl.s[526]++;

          request.display__ = true;
          cov_24f1td4mjl.s[527]++;
          request.pin = $deltahttp.getAnalysePinRepository(request.id);
          cov_24f1td4mjl.s[528]++;
          $scope.analyseMap.loading[request.id] = true;
          cov_24f1td4mjl.s[529]++;
          $scope.analyseMap.drawLayers(request);
        }
      });
    }
  };

  var PATH_PROJECT = (cov_24f1td4mjl.s[530]++, 'Projet');
  var PATH_FINANCING = (cov_24f1td4mjl.s[531]++, 'Financement');

  var tmp_idProject = (cov_24f1td4mjl.s[532]++, $rootScope.projectDetail());
  var idProject = (cov_24f1td4mjl.s[533]++, project.project.id);

  cov_24f1td4mjl.s[534]++;
  $CRUDService.getAll(PATH_PROJECT, { get: 'single', id: idProject }, function (data) {
    cov_24f1td4mjl.f[57]++;
    cov_24f1td4mjl.s[535]++;

    if (data.length <= 0) {
      cov_24f1td4mjl.b[110][0]++;
      cov_24f1td4mjl.s[536]++;

      _this4.isloading = false;
      cov_24f1td4mjl.s[537]++;
      return;
    } else {
      cov_24f1td4mjl.b[110][1]++;
    }
    cov_24f1td4mjl.s[538]++;
    for (var i = 0; i < data.length; i++) {
      cov_24f1td4mjl.s[539]++;

      if (!data[i].DATE_DEB_PROJET) {
        cov_24f1td4mjl.b[111][0]++;
        cov_24f1td4mjl.s[540]++;

        continue;
      } else {
        cov_24f1td4mjl.b[111][1]++;
      }
      cov_24f1td4mjl.s[541]++;
      data[i].DATE_DEB_PROJET = Date.newDate(data[i].DATE_DEB_PROJET);
      cov_24f1td4mjl.s[542]++;
      data[i].COUT = parseFloat(data[i].COUT);
      cov_24f1td4mjl.s[543]++;
      data[i].STATUT_BUDGET = parseInt(data[i].STATUT_BUDGET, 10) === 1;
      cov_24f1td4mjl.s[544]++;
      data[i].DATE_FIN_PROJET = Date.newDate(data[i].DATE_FIN_PROJET);
      cov_24f1td4mjl.s[545]++;
      data[i].DATE_MI_PRO = Date.newDate((cov_24f1td4mjl.b[112][0]++, data[i].DATE_MI_PRO) || (cov_24f1td4mjl.b[112][1]++, undefined));
      cov_24f1td4mjl.s[546]++;
      data[i].PAYS_PROJET = parseInt(data[i].PAYS_PROJET, 10);
      var zone = (cov_24f1td4mjl.s[547]++, []);
      cov_24f1td4mjl.s[548]++;
      for (var _iterator19 = Object.keys(data[i].LOCATION_FIELD), _isArray19 = Array.isArray(_iterator19), _i19 = 0, _iterator19 = _isArray19 ? _iterator19 : _iterator19[Symbol.iterator]();;) {
        var _ref19;

        if (_isArray19) {
          if (_i19 >= _iterator19.length) break;
          _ref19 = _iterator19[_i19++];
        } else {
          _i19 = _iterator19.next();
          if (_i19.done) break;
          _ref19 = _i19.value;
        }

        var key = _ref19;
        cov_24f1td4mjl.s[549]++;

        zone.push(data[i].LOCATION_FIELD[key]);
      }
      cov_24f1td4mjl.s[550]++;
      data[i].LOCATION_FIELD = zone.join(' , ');
      cov_24f1td4mjl.s[551]++;
      $scope.selectProject = data[i];
    }
  });

  cov_24f1td4mjl.s[552]++;
  $scope.total_finacement = 0;
  cov_24f1td4mjl.s[553]++;
  $scope.total_decaisser = 0;
  cov_24f1td4mjl.s[554]++;
  $scope.total_decaisser_tmp = 0;
  cov_24f1td4mjl.s[555]++;
  $scope.total_decaisser_rate = 0;
  cov_24f1td4mjl.s[556]++;


  $scope.customSumColomn = function (data, aggColumn) {
    cov_24f1td4mjl.f[58]++;

    var value = (cov_24f1td4mjl.s[557]++, 0);
    var col_SOLD_AFF = (cov_24f1td4mjl.s[558]++, 'RATE_AFF');
    cov_24f1td4mjl.s[559]++;
    data.result.map(function (item) {
      cov_24f1td4mjl.f[59]++;
      cov_24f1td4mjl.s[560]++;

      if (item[aggColumn.columnName] === col_SOLD_AFF) {
        cov_24f1td4mjl.b[113][0]++;
        cov_24f1td4mjl.s[561]++;

        value += 1;
      } else {
        cov_24f1td4mjl.b[113][1]++;
      }
    });

    cov_24f1td4mjl.s[562]++;
    return value;
  };
  cov_24f1td4mjl.s[563]++;
  $scope.total_tab = {
    AMOUNT_T: 0,
    DISBURSED_T: 0,
    RATE_T: 0,
    SOLD_T: 0
  };
  cov_24f1td4mjl.s[564]++;
  $CRUDService.getAll(PATH_FINANCING, { get: 'state', id: idProject }, function (data) {
    cov_24f1td4mjl.f[60]++;
    cov_24f1td4mjl.s[565]++;

    data = data.map(function (value) {
      cov_24f1td4mjl.f[61]++;
      cov_24f1td4mjl.s[566]++;

      value.AMOUNT = (cov_24f1td4mjl.b[114][0]++, parseFloat(value.AMOUNT)) || (cov_24f1td4mjl.b[114][1]++, 0);
      cov_24f1td4mjl.s[567]++;
      value.DISBURSED = (cov_24f1td4mjl.b[115][0]++, parseFloat(value.DISBURSED)) || (cov_24f1td4mjl.b[115][1]++, 0);
      cov_24f1td4mjl.s[568]++;
      value.SOLD = (cov_24f1td4mjl.b[116][0]++, parseFloat(value.SOLD)) || (cov_24f1td4mjl.b[116][1]++, 0);
      cov_24f1td4mjl.s[569]++;
      value.RATE = 0;

      cov_24f1td4mjl.s[570]++;
      value.AMOUNT_AFF = $filter('number')(value.AMOUNT);
      cov_24f1td4mjl.s[571]++;
      value.DISBURSED_AFF = $filter('number')(value.DISBURSED);
      cov_24f1td4mjl.s[572]++;
      if (value.AMOUNT > 0) {
        cov_24f1td4mjl.b[117][0]++;
        cov_24f1td4mjl.s[573]++;

        value.RATE = value.DISBURSED * 100 / value.AMOUNT;
      } else {
        cov_24f1td4mjl.b[117][1]++;
      }

      cov_24f1td4mjl.s[574]++;
      value.RATE_AFF = $filter('number')(value.RATE);
      cov_24f1td4mjl.s[575]++;
      value.SOLD_AFF = $filter('number')(value.SOLD);
      cov_24f1td4mjl.s[576]++;

      if (value.AMOUNT) {
        cov_24f1td4mjl.b[118][0]++;
        cov_24f1td4mjl.s[577]++;

        $scope.total_finacement += parseFloat(value.AMOUNT);
      } else {
        cov_24f1td4mjl.b[118][1]++;
      }
      cov_24f1td4mjl.s[578]++;
      if (value.DISBURSED) {
        cov_24f1td4mjl.b[119][0]++;
        cov_24f1td4mjl.s[579]++;

        $scope.total_decaisser += parseFloat(value.DISBURSED);
      } else {
        cov_24f1td4mjl.b[119][1]++;
      }
      cov_24f1td4mjl.s[580]++;


      $scope.total_tab.AMOUNT_T += value.AMOUNT;
      cov_24f1td4mjl.s[581]++;
      $scope.total_tab.DISBURSED_T += value.DISBURSED;
      cov_24f1td4mjl.s[582]++;
      $scope.total_tab.SOLD_T += value.SOLD;

      cov_24f1td4mjl.s[583]++;
      return value;
    });

    cov_24f1td4mjl.s[584]++;
    $scope.set_disbursement_infos();

    cov_24f1td4mjl.s[585]++;
    $scope.total_tab.AMOUNT_T = $filter('number')($scope.total_tab.AMOUNT_T);
    cov_24f1td4mjl.s[586]++;
    $scope.total_tab.DISBURSED_T = $filter('number')($scope.total_tab.DISBURSED_T);
    cov_24f1td4mjl.s[587]++;
    $scope.total_tab.RATE_T = $filter('number')($scope.total_decaisser_rate);
    cov_24f1td4mjl.s[588]++;
    $scope.total_tab.SOLD_T = $filter('number')($scope.total_tab.SOLD_T);

    cov_24f1td4mjl.s[589]++;
    $scope.financingState = angular.copy(data);
    cov_24f1td4mjl.s[590]++;
    $scope.financialParams = {
      dataSource: data,
      gridLines: 'Both',

      columns: [{
        field: 'LIBELLE_FIN', headerText: $translate.instant('PROJECT.DASHBOARD_VIEW.FINANCING').toUpperCase()
      }, {
        field: 'AMOUNT_AFF', headerText: $translate.instant('PROJECT.DASHBOARD_VIEW.AMOUNT').toUpperCase() + ' (' + $rootScope.getGlobalCurrency() + ')',
        width: 150, textAlign: 'Right'
      }, {
        field: 'DISBURSED_AFF', headerText: $translate.instant('PROJECT.DASHBOARD_VIEW.DISBURSED').toUpperCase() + ' (' + $rootScope.getGlobalCurrency() + ')', width: 150, textAlign: 'Right'
      }, {
        field: 'RATE_AFF', headerText: '% ' + $translate.instant('PROJECT.DASHBOARD_VIEW.DISBURSED').toUpperCase(),
        width: 150, textAlign: 'Right', format: 'P'
      }, {
        field: 'SOLD_AFF', headerText: $translate.instant('PROJECT.DASHBOARD_VIEW.SOLD').toUpperCase() + ' (' + $rootScope.getGlobalCurrency() + ')',
        width: 150, textAlign: 'Right'
      }],
      allowSelection: false,
      width: 'auto',
      height: 'auto',
      allowTextWrap: true
    };

    cov_24f1td4mjl.s[591]++;

    $scope.financingStateChart = {
      series: [{
        type: 'Pie', dataSource: data.map(function (value) {
          cov_24f1td4mjl.f[62]++;
          cov_24f1td4mjl.s[592]++;

          return {
            value: value.DISBURSED ? (cov_24f1td4mjl.b[120][0]++, Math.round(value.DISBURSED)) : (cov_24f1td4mjl.b[120][1]++, null),
            name: value.LIBELLE_FIN
          };
        }).filter(function (item) {
          cov_24f1td4mjl.f[63]++;
          cov_24f1td4mjl.s[593]++;

          return item.value != null;
        }), xName: 'name', yName: 'value',
        dataLabel: { visible: true, position: 'Outside' } }], textRender: function textRender(args) {
        cov_24f1td4mjl.s[594]++;

        if (!args.extraData) {
          cov_24f1td4mjl.b[121][0]++;
          cov_24f1td4mjl.s[595]++;

          args.extraData = $filter('number')(args.text);
        } else {
          cov_24f1td4mjl.b[121][1]++;
        }
        cov_24f1td4mjl.s[596]++;
        args.text = args.extraData + ' ' + $rootScope.getGlobalCurrency();
      },

      legendSettings: { visible: true, position: 'Bottom' }, enableSmartLabels: true,

      tooltip: { enable: true, format: '${point.x} <br> ${point.percentage} %' },
      width: '100%',
      height: '100%'
    };
  });

  cov_24f1td4mjl.s[597]++;

  $CRUDService.getAll(PATH_FINANCING, { get: 'state_chart', id: idProject }, function (data) {
    cov_24f1td4mjl.f[64]++;
    cov_24f1td4mjl.s[598]++;

    $scope.financingState = data;
    cov_24f1td4mjl.s[599]++;

    $scope.financingStateChartProgress = {
      locale: $LOGINService.getLang(),

      primaryXAxis: {
        interval: 1,
        labelIntersectAction: 'Rotate45',
        valueType: 'Category',
        majorGridLines: { width: 0 }, minorGridLines: { width: 0 },
        majorTickLines: { width: 0 }, minorTickLines: { width: 0 },
        lineStyle: { width: 0 }
      },
      primaryYAxis: {
        valueType: 'Double',
        lineStyle: { width: 0 },
        majorTickLines: { width: 0 }, majorGridLines: { width: 1 },
        minorGridLines: { width: 1 }, minorTickLines: { width: 0 },
        labelFormat: 'P'
      },
      chartArea: {
        border: {
          width: 0
        }
      },
      useGroupingSeparator: true,

      series: [{
        type: 'Line',
        opacity: 0.5,
        dataSource: data,

        fill: 'rgba(0, 15, 62, 0.7)',
        xName: 'YEAR', yName: 'RATE',
        width: 3,
        marker: {
          visible: true,
          width: 10,
          height: 10
        }
      }],
      height: 'calc(100% - 20px)',
      width: '100%',

      legendSettings: {
        visible: false
      },

      tooltip: { enable: true, shared: false }
    };
  });

  cov_24f1td4mjl.s[600]++;


  $scope.set_disbursement_infos = function () {
    cov_24f1td4mjl.f[65]++;
    cov_24f1td4mjl.s[601]++;

    $scope.total_decaisser_rate = 0;
    cov_24f1td4mjl.s[602]++;
    if ($scope.total_finacement > 0) {
      cov_24f1td4mjl.b[122][0]++;
      cov_24f1td4mjl.s[603]++;

      $scope.total_decaisser_rate = $scope.total_decaisser * 100 / $scope.total_finacement;
    } else {
      cov_24f1td4mjl.b[122][1]++;
    }
  };

  cov_24f1td4mjl.s[604]++;
  $scope.avancephysique = {
    perct: 0,
    perctview: 0,
    getall: function getall() {
      cov_24f1td4mjl.s[605]++;

      $CRUDService.getAll('Activites', { get: 'projet_global_informations' }, function (_data) {
        cov_24f1td4mjl.f[66]++;
        cov_24f1td4mjl.s[606]++;

        if (_data) {
          cov_24f1td4mjl.b[123][0]++;
          cov_24f1td4mjl.s[607]++;

          $scope.avancephysique.perct = parseFloat(_data);
          cov_24f1td4mjl.s[608]++;
          $scope.avancephysique.perctview = $scope.avancephysique.perct;
          cov_24f1td4mjl.s[609]++;
          if ($scope.avancephysique.perctview > 100) {
            cov_24f1td4mjl.b[124][0]++;
            cov_24f1td4mjl.s[610]++;

            $scope.avancephysique.perctview = 100;
          } else {
            cov_24f1td4mjl.b[124][1]++;
          }
        } else {
          cov_24f1td4mjl.b[123][1]++;
        }
      });
    }
  };
  cov_24f1td4mjl.s[611]++;
  $scope.avancephysique.getall();
});